module.exports = /******/
function(modules) {
    /******/
    /******/
    // The require function
    /******/
    function __webpack_require__(moduleId) {
        /******/
        /******/
        // Check if module is in cache
        /******/
        if (installedModules[moduleId]) /******/
        return installedModules[moduleId].exports;
        /******/
        /******/
        // Create a new module (and put it into the cache)
        /******/
        var module = installedModules[moduleId] = {
            /******/
            exports: {},
            /******/
            id: moduleId,
            /******/
            loaded: !1
        };
        /******/
        /******/
        // Return the exports of the module
        /******/
        /******/
        /******/
        // Execute the module function
        /******/
        /******/
        /******/
        // Flag the module as loaded
        /******/
        return modules[moduleId].call(module.exports, module, module.exports, __webpack_require__), 
        module.loaded = !0, module.exports;
    }
    // webpackBootstrap
    /******/
    // The module cache
    /******/
    var installedModules = {};
    /******/
    /******/
    // Load entry module and return exports
    /******/
    /******/
    /******/
    /******/
    // expose the modules object (__webpack_modules__)
    /******/
    /******/
    /******/
    // expose the module cache
    /******/
    /******/
    /******/
    // __webpack_public_path__
    /******/
    return __webpack_require__.m = modules, __webpack_require__.c = installedModules, 
    __webpack_require__.p = "", __webpack_require__(0);
}([ /* 0 */
/***/
function(module, exports, __webpack_require__) {
    module.exports = __webpack_require__(1);
}, /* 1 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    }), exports.size = exports.WarningIcon = exports.SuccessIcon = exports.SettingsIcon = exports.SearchIcon = exports.RadioIcon = exports.QuestionIcon = exports.ProjectsIcon = exports.MoreoptionsIcon = exports.JiraLogoIcon = exports.HomeIcon = exports.HelpIcon = exports.FeedbackIcon = exports.ExpandIcon = exports.ErrorIcon = exports.EmojiTravelIcon = exports.EmojiSymbolsIcon = exports.EmojiPeopleIcon = exports.EmojiObjectsIcon = exports.EmojiNatureIcon = exports.EmojiFrequentIcon = exports.EmojiFoodIcon = exports.EmojiFlagsIcon = exports.EmojiCustomIcon = exports.EmojiAtlassianIcon = exports.EmojiActivityIcon = exports.EditorWarningIcon = exports.EditorUnlinkIcon = exports.EditorUndoIcon = exports.EditorUnderlineIcon = exports.EditorTextColorIcon = exports.EditorTaskIcon = exports.EditorTableIcon = exports.EditorSearchIcon = exports.EditorRemoveIcon = exports.EditorRedoIcon = exports.EditorRecentIcon = exports.EditorPhotoIcon = exports.EditorPanelIcon = exports.EditorOutdentIcon = exports.EditorOpenIcon = exports.EditorNumberListIcon = exports.EditorNoteIcon = exports.EditorMoreIcon = exports.EditorMentionIcon = exports.EditorLocationIcon = exports.EditorLinkIcon = exports.EditorItalicIcon = exports.EditorInfoIcon = exports.EditorIndentIcon = exports.EditorImageIcon = exports.EditorImageResizeIcon = exports.EditorImageBorderIcon = exports.EditorHintIcon = exports.EditorHelpIcon = exports.EditorFileIcon = exports.EditorFeedbackIcon = exports.EditorExpandIcon = exports.EditorErrorIcon = exports.EditorEmojiIcon = exports.EditorDecisionIcon = exports.EditorDateIcon = exports.EditorCodeIcon = exports.EditorCloseIcon = exports.EditorCheckIcon = exports.EditorBulletListIcon = exports.EditorBoldIcon = exports.EditorAttachmentIcon = exports.EditorAlignRightIcon = exports.EditorAlignLeftIcon = exports.EditorAlignCenterIcon = exports.EditorAdvancedIcon = exports.EditorAddonIcon = exports.EditorAddIcon = exports.EditIcon = exports.DashboardIcon = exports.CreateIcon = exports.ConfluenceQuoteIcon = exports.ConfluencePersonIcon = exports.ConfluencePageIcon = exports.ConfluenceCanvasIcon = exports.ConfluenceCalendarIcon = exports.ConfirmIcon = exports.CheckboxIcon = exports.CancelIcon = exports.BitbucketWikiIcon = exports.BitbucketTeamsIcon = exports.BitbucketSourceIcon = exports.BitbucketSnippetsIcon = exports.BitbucketRepositoriesIcon = exports.BitbucketReposIcon = exports.BitbucketPullrequestsIcon = exports.BitbucketProjectsIcon = exports.BitbucketPipelinesIcon = exports.BitbucketOptoutIcon = exports.BitbucketMembersIcon = exports.BitbucketLogoIcon = exports.BitbucketIssuesIcon = exports.BitbucketFollowingIcon = exports.BitbucketFollowersIcon = exports.BitbucketDownloadsIcon = exports.BitbucketDashboardIcon = exports.BitbucketCommitsIcon = exports.BitbucketBuildsIcon = exports.BitbucketBranchesIcon = exports.BitbucketAdminIcon = exports.BitbucketAddonsIcon = exports.AtlassianIcon = exports.ArrowrightlongIcon = exports.ArrowrightIcon = exports.ArrowleftIcon = void 0;
    var _Icon = __webpack_require__(2), _arrowleft = __webpack_require__(18), _arrowleft2 = _interopRequireDefault(_arrowleft), _arrowright = __webpack_require__(20), _arrowright2 = _interopRequireDefault(_arrowright), _arrowrightlong = __webpack_require__(21), _arrowrightlong2 = _interopRequireDefault(_arrowrightlong), _atlassian = __webpack_require__(22), _atlassian2 = _interopRequireDefault(_atlassian), _addons = __webpack_require__(23), _addons2 = _interopRequireDefault(_addons), _admin = __webpack_require__(24), _admin2 = _interopRequireDefault(_admin), _branches = __webpack_require__(25), _branches2 = _interopRequireDefault(_branches), _builds = __webpack_require__(26), _builds2 = _interopRequireDefault(_builds), _commits = __webpack_require__(27), _commits2 = _interopRequireDefault(_commits), _dashboard = __webpack_require__(28), _dashboard2 = _interopRequireDefault(_dashboard), _downloads = __webpack_require__(29), _downloads2 = _interopRequireDefault(_downloads), _followers = __webpack_require__(30), _followers2 = _interopRequireDefault(_followers), _following = __webpack_require__(31), _following2 = _interopRequireDefault(_following), _issues = __webpack_require__(32), _issues2 = _interopRequireDefault(_issues), _logo = __webpack_require__(33), _logo2 = _interopRequireDefault(_logo), _members = __webpack_require__(34), _members2 = _interopRequireDefault(_members), _optout = __webpack_require__(35), _optout2 = _interopRequireDefault(_optout), _pipelines = __webpack_require__(36), _pipelines2 = _interopRequireDefault(_pipelines), _projects = __webpack_require__(37), _projects2 = _interopRequireDefault(_projects), _pullrequests = __webpack_require__(38), _pullrequests2 = _interopRequireDefault(_pullrequests), _repos = __webpack_require__(39), _repos2 = _interopRequireDefault(_repos), _repositories = __webpack_require__(40), _repositories2 = _interopRequireDefault(_repositories), _snippets = __webpack_require__(41), _snippets2 = _interopRequireDefault(_snippets), _source = __webpack_require__(42), _source2 = _interopRequireDefault(_source), _teams = __webpack_require__(43), _teams2 = _interopRequireDefault(_teams), _wiki = __webpack_require__(44), _wiki2 = _interopRequireDefault(_wiki), _cancel = __webpack_require__(45), _cancel2 = _interopRequireDefault(_cancel), _checkbox = __webpack_require__(46), _checkbox2 = _interopRequireDefault(_checkbox), _confirm = __webpack_require__(47), _confirm2 = _interopRequireDefault(_confirm), _calendar = __webpack_require__(48), _calendar2 = _interopRequireDefault(_calendar), _canvas = __webpack_require__(49), _canvas2 = _interopRequireDefault(_canvas), _page = __webpack_require__(50), _page2 = _interopRequireDefault(_page), _person = __webpack_require__(51), _person2 = _interopRequireDefault(_person), _quote = __webpack_require__(52), _quote2 = _interopRequireDefault(_quote), _create = __webpack_require__(53), _create2 = _interopRequireDefault(_create), _dashboard3 = __webpack_require__(54), _dashboard4 = _interopRequireDefault(_dashboard3), _edit = __webpack_require__(55), _edit2 = _interopRequireDefault(_edit), _add = __webpack_require__(56), _add2 = _interopRequireDefault(_add), _addon = __webpack_require__(57), _addon2 = _interopRequireDefault(_addon), _advanced = __webpack_require__(58), _advanced2 = _interopRequireDefault(_advanced), _alignCenter = __webpack_require__(59), _alignCenter2 = _interopRequireDefault(_alignCenter), _alignLeft = __webpack_require__(60), _alignLeft2 = _interopRequireDefault(_alignLeft), _alignRight = __webpack_require__(61), _alignRight2 = _interopRequireDefault(_alignRight), _attachment = __webpack_require__(62), _attachment2 = _interopRequireDefault(_attachment), _bold = __webpack_require__(63), _bold2 = _interopRequireDefault(_bold), _bulletList = __webpack_require__(64), _bulletList2 = _interopRequireDefault(_bulletList), _check = __webpack_require__(65), _check2 = _interopRequireDefault(_check), _close = __webpack_require__(66), _close2 = _interopRequireDefault(_close), _code = __webpack_require__(67), _code2 = _interopRequireDefault(_code), _date = __webpack_require__(68), _date2 = _interopRequireDefault(_date), _decision = __webpack_require__(69), _decision2 = _interopRequireDefault(_decision), _emoji = __webpack_require__(70), _emoji2 = _interopRequireDefault(_emoji), _error = __webpack_require__(71), _error2 = _interopRequireDefault(_error), _expand = __webpack_require__(72), _expand2 = _interopRequireDefault(_expand), _feedback = __webpack_require__(73), _feedback2 = _interopRequireDefault(_feedback), _file = __webpack_require__(74), _file2 = _interopRequireDefault(_file), _help = __webpack_require__(75), _help2 = _interopRequireDefault(_help), _hint = __webpack_require__(76), _hint2 = _interopRequireDefault(_hint), _imageBorder = __webpack_require__(77), _imageBorder2 = _interopRequireDefault(_imageBorder), _imageResize = __webpack_require__(78), _imageResize2 = _interopRequireDefault(_imageResize), _image = __webpack_require__(79), _image2 = _interopRequireDefault(_image), _indent = __webpack_require__(80), _indent2 = _interopRequireDefault(_indent), _info = __webpack_require__(81), _info2 = _interopRequireDefault(_info), _italic = __webpack_require__(82), _italic2 = _interopRequireDefault(_italic), _link = __webpack_require__(83), _link2 = _interopRequireDefault(_link), _location = __webpack_require__(84), _location2 = _interopRequireDefault(_location), _mention = __webpack_require__(85), _mention2 = _interopRequireDefault(_mention), _more = __webpack_require__(86), _more2 = _interopRequireDefault(_more), _note = __webpack_require__(87), _note2 = _interopRequireDefault(_note), _numberList = __webpack_require__(88), _numberList2 = _interopRequireDefault(_numberList), _open = __webpack_require__(89), _open2 = _interopRequireDefault(_open), _outdent = __webpack_require__(90), _outdent2 = _interopRequireDefault(_outdent), _panel = __webpack_require__(91), _panel2 = _interopRequireDefault(_panel), _photo = __webpack_require__(92), _photo2 = _interopRequireDefault(_photo), _recent = __webpack_require__(93), _recent2 = _interopRequireDefault(_recent), _redo = __webpack_require__(94), _redo2 = _interopRequireDefault(_redo), _remove = __webpack_require__(95), _remove2 = _interopRequireDefault(_remove), _search = __webpack_require__(96), _search2 = _interopRequireDefault(_search), _table = __webpack_require__(97), _table2 = _interopRequireDefault(_table), _task = __webpack_require__(98), _task2 = _interopRequireDefault(_task), _textColor = __webpack_require__(99), _textColor2 = _interopRequireDefault(_textColor), _underline = __webpack_require__(100), _underline2 = _interopRequireDefault(_underline), _undo = __webpack_require__(101), _undo2 = _interopRequireDefault(_undo), _unlink = __webpack_require__(102), _unlink2 = _interopRequireDefault(_unlink), _warning = __webpack_require__(103), _warning2 = _interopRequireDefault(_warning), _activity = __webpack_require__(104), _activity2 = _interopRequireDefault(_activity), _atlassian3 = __webpack_require__(105), _atlassian4 = _interopRequireDefault(_atlassian3), _custom = __webpack_require__(106), _custom2 = _interopRequireDefault(_custom), _flags = __webpack_require__(107), _flags2 = _interopRequireDefault(_flags), _food = __webpack_require__(108), _food2 = _interopRequireDefault(_food), _frequent = __webpack_require__(109), _frequent2 = _interopRequireDefault(_frequent), _nature = __webpack_require__(110), _nature2 = _interopRequireDefault(_nature), _objects = __webpack_require__(111), _objects2 = _interopRequireDefault(_objects), _people = __webpack_require__(112), _people2 = _interopRequireDefault(_people), _symbols = __webpack_require__(113), _symbols2 = _interopRequireDefault(_symbols), _travel = __webpack_require__(114), _travel2 = _interopRequireDefault(_travel), _error3 = __webpack_require__(115), _error4 = _interopRequireDefault(_error3), _expand3 = __webpack_require__(116), _expand4 = _interopRequireDefault(_expand3), _feedback3 = __webpack_require__(117), _feedback4 = _interopRequireDefault(_feedback3), _help3 = __webpack_require__(118), _help4 = _interopRequireDefault(_help3), _home = __webpack_require__(119), _home2 = _interopRequireDefault(_home), _logo3 = __webpack_require__(120), _logo4 = _interopRequireDefault(_logo3), _moreoptions = __webpack_require__(121), _moreoptions2 = _interopRequireDefault(_moreoptions), _projects3 = __webpack_require__(122), _projects4 = _interopRequireDefault(_projects3), _question = __webpack_require__(123), _question2 = _interopRequireDefault(_question), _radio = __webpack_require__(124), _radio2 = _interopRequireDefault(_radio), _search3 = __webpack_require__(125), _search4 = _interopRequireDefault(_search3), _settings = __webpack_require__(126), _settings2 = _interopRequireDefault(_settings), _success = __webpack_require__(127), _success2 = _interopRequireDefault(_success), _warning3 = __webpack_require__(128), _warning4 = _interopRequireDefault(_warning3);
    exports.ArrowleftIcon = _arrowleft2.default, exports.ArrowrightIcon = _arrowright2.default, 
    exports.ArrowrightlongIcon = _arrowrightlong2.default, exports.AtlassianIcon = _atlassian2.default, 
    exports.BitbucketAddonsIcon = _addons2.default, exports.BitbucketAdminIcon = _admin2.default, 
    exports.BitbucketBranchesIcon = _branches2.default, exports.BitbucketBuildsIcon = _builds2.default, 
    exports.BitbucketCommitsIcon = _commits2.default, exports.BitbucketDashboardIcon = _dashboard2.default, 
    exports.BitbucketDownloadsIcon = _downloads2.default, exports.BitbucketFollowersIcon = _followers2.default, 
    exports.BitbucketFollowingIcon = _following2.default, exports.BitbucketIssuesIcon = _issues2.default, 
    exports.BitbucketLogoIcon = _logo2.default, exports.BitbucketMembersIcon = _members2.default, 
    exports.BitbucketOptoutIcon = _optout2.default, exports.BitbucketPipelinesIcon = _pipelines2.default, 
    exports.BitbucketProjectsIcon = _projects2.default, exports.BitbucketPullrequestsIcon = _pullrequests2.default, 
    exports.BitbucketReposIcon = _repos2.default, exports.BitbucketRepositoriesIcon = _repositories2.default, 
    exports.BitbucketSnippetsIcon = _snippets2.default, exports.BitbucketSourceIcon = _source2.default, 
    exports.BitbucketTeamsIcon = _teams2.default, exports.BitbucketWikiIcon = _wiki2.default, 
    exports.CancelIcon = _cancel2.default, exports.CheckboxIcon = _checkbox2.default, 
    exports.ConfirmIcon = _confirm2.default, exports.ConfluenceCalendarIcon = _calendar2.default, 
    exports.ConfluenceCanvasIcon = _canvas2.default, exports.ConfluencePageIcon = _page2.default, 
    exports.ConfluencePersonIcon = _person2.default, exports.ConfluenceQuoteIcon = _quote2.default, 
    exports.CreateIcon = _create2.default, exports.DashboardIcon = _dashboard4.default, 
    exports.EditIcon = _edit2.default, exports.EditorAddIcon = _add2.default, exports.EditorAddonIcon = _addon2.default, 
    exports.EditorAdvancedIcon = _advanced2.default, exports.EditorAlignCenterIcon = _alignCenter2.default, 
    exports.EditorAlignLeftIcon = _alignLeft2.default, exports.EditorAlignRightIcon = _alignRight2.default, 
    exports.EditorAttachmentIcon = _attachment2.default, exports.EditorBoldIcon = _bold2.default, 
    exports.EditorBulletListIcon = _bulletList2.default, exports.EditorCheckIcon = _check2.default, 
    exports.EditorCloseIcon = _close2.default, exports.EditorCodeIcon = _code2.default, 
    exports.EditorDateIcon = _date2.default, exports.EditorDecisionIcon = _decision2.default, 
    exports.EditorEmojiIcon = _emoji2.default, exports.EditorErrorIcon = _error2.default, 
    exports.EditorExpandIcon = _expand2.default, exports.EditorFeedbackIcon = _feedback2.default, 
    exports.EditorFileIcon = _file2.default, exports.EditorHelpIcon = _help2.default, 
    exports.EditorHintIcon = _hint2.default, exports.EditorImageBorderIcon = _imageBorder2.default, 
    exports.EditorImageResizeIcon = _imageResize2.default, exports.EditorImageIcon = _image2.default, 
    exports.EditorIndentIcon = _indent2.default, exports.EditorInfoIcon = _info2.default, 
    exports.EditorItalicIcon = _italic2.default, exports.EditorLinkIcon = _link2.default, 
    exports.EditorLocationIcon = _location2.default, exports.EditorMentionIcon = _mention2.default, 
    exports.EditorMoreIcon = _more2.default, exports.EditorNoteIcon = _note2.default, 
    exports.EditorNumberListIcon = _numberList2.default, exports.EditorOpenIcon = _open2.default, 
    exports.EditorOutdentIcon = _outdent2.default, exports.EditorPanelIcon = _panel2.default, 
    exports.EditorPhotoIcon = _photo2.default, exports.EditorRecentIcon = _recent2.default, 
    exports.EditorRedoIcon = _redo2.default, exports.EditorRemoveIcon = _remove2.default, 
    exports.EditorSearchIcon = _search2.default, exports.EditorTableIcon = _table2.default, 
    exports.EditorTaskIcon = _task2.default, exports.EditorTextColorIcon = _textColor2.default, 
    exports.EditorUnderlineIcon = _underline2.default, exports.EditorUndoIcon = _undo2.default, 
    exports.EditorUnlinkIcon = _unlink2.default, exports.EditorWarningIcon = _warning2.default, 
    exports.EmojiActivityIcon = _activity2.default, exports.EmojiAtlassianIcon = _atlassian4.default, 
    exports.EmojiCustomIcon = _custom2.default, exports.EmojiFlagsIcon = _flags2.default, 
    exports.EmojiFoodIcon = _food2.default, exports.EmojiFrequentIcon = _frequent2.default, 
    exports.EmojiNatureIcon = _nature2.default, exports.EmojiObjectsIcon = _objects2.default, 
    exports.EmojiPeopleIcon = _people2.default, exports.EmojiSymbolsIcon = _symbols2.default, 
    exports.EmojiTravelIcon = _travel2.default, exports.ErrorIcon = _error4.default, 
    exports.ExpandIcon = _expand4.default, exports.FeedbackIcon = _feedback4.default, 
    exports.HelpIcon = _help4.default, exports.HomeIcon = _home2.default, exports.JiraLogoIcon = _logo4.default, 
    exports.MoreoptionsIcon = _moreoptions2.default, exports.ProjectsIcon = _projects4.default, 
    exports.QuestionIcon = _question2.default, exports.RadioIcon = _radio2.default, 
    exports.SearchIcon = _search4.default, exports.SettingsIcon = _settings2.default, 
    exports.SuccessIcon = _success2.default, exports.WarningIcon = _warning4.default;
    exports.size = _Icon.size;
}, /* 2 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    }), exports.size = exports.NotImplementedError = void 0;
    var _keys = __webpack_require__(3), _keys2 = _interopRequireDefault(_keys), _getPrototypeOf = __webpack_require__(4), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(5), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(6), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(7), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(8), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(9), _react2 = _interopRequireDefault(_react), _classnames = __webpack_require__(10), _classnames2 = _interopRequireDefault(_classnames), _styles = __webpack_require__(11), _styles2 = _interopRequireDefault(_styles), _exceptions = __webpack_require__(15), _size = __webpack_require__(17), _size2 = _interopRequireDefault(_size), Icon = function(_PureComponent) {
        function Icon() {
            return (0, _classCallCheck3.default)(this, Icon), (0, _possibleConstructorReturn3.default)(this, (Icon.__proto__ || (0, 
            _getPrototypeOf2.default)(Icon)).apply(this, arguments));
        }
        return (0, _inherits3.default)(Icon, _PureComponent), (0, _createClass3.default)(Icon, [ {
            key: "getGlyphTemplate",
            /**
	    * This method has to be implemented by subclasses and must return a template function.
	    * This method should not be used directly.
	    *
	    * @throws {NotImplementedError} throws an error if the subclass does not override this method
	    * @private
	    * @return {Function} a template function
	    */
            // eslint-disable-next-line class-methods-use-this
            value: function() {
                throw new _exceptions.NotImplementedError("Subclasses need to provide an implementation");
            }
        }, {
            key: "render",
            value: function() {
                var Glyph = this.getGlyphTemplate(), iconBodyClasses = (0, _classnames2.default)([ _styles2.default.iconBody, _styles2.default[this.props.size] ]);
                // eslint-disable-next-line jsx-a11y/no-static-element-interactions
                return _react2.default.createElement("span", {
                    className: iconBodyClasses,
                    onClick: this.props.onClick
                }, _react2.default.createElement(Glyph, {
                    className: _styles2.default.svg,
                    label: this.props.label,
                    role: "img"
                }));
            }
        } ]), Icon;
    }(_react.PureComponent);
    Icon.propTypes = {
        /**
	   * @description (Required) The icon label
	   *              This is a required attribute.
	   *              Omitting it will make the icon inaccessible for screen readers, etc..
	   *              The text passed will be sanitized, e.g. passed HTML will be represented
	   *              as plain text.
	   *
	   * @memberof Icon
	   * @instance
	   * @type {string}
	   */
        label: _react.PropTypes.string.isRequired,
        /**
	     * @description (Optional) An icon size.
	     *
	     * Defaults to an empty string (which means it uses the default size).
	     *
	     * @memberof Icon
	     * @instance
	     * @type {size}
	     * @default small
	     */
        size: _react.PropTypes.oneOf((0, _keys2.default)(_size2.default).map(function(k) {
            return _size2.default[k];
        })),
        /**
	     * @description (Optional) A handler to execute when the icon is clicked.
	     *
	     * Defaults to a noop.
	     *
	     * @memberof Icon
	     * @instance
	     * @type {function}
	     */
        onClick: _react.PropTypes.func
    }, Icon.defaultProps = {
        onClick: function() {}
    }, exports.default = Icon, exports.NotImplementedError = _exceptions.NotImplementedError, 
    exports.size = _size2.default;
}, /* 3 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/core-js/object/keys");
}, /* 4 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/core-js/object/get-prototype-of");
}, /* 5 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/classCallCheck");
}, /* 6 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/createClass");
}, /* 7 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/possibleConstructorReturn");
}, /* 8 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/inherits");
}, /* 9 */
/***/
function(module, exports) {
    module.exports = require("react");
}, /* 10 */
/***/
function(module, exports) {
    module.exports = require("classnames");
}, /* 11 */
/***/
function(module, exports, __webpack_require__) {
    // style-loader: Adds some css to the DOM by adding a <style> tag
    // load the styles
    var content = __webpack_require__(12);
    "string" == typeof content && (content = [ [ module.id, content, "" ] ]);
    // add the styles to the DOM
    __webpack_require__(14)(content, {});
    content.locals && (module.exports = content.locals);
}, /* 12 */
/***/
function(module, exports, __webpack_require__) {
    exports = module.exports = __webpack_require__(13)(), // imports
    // module
    exports.push([ module.id, ".AzcMg-ed8zW7A3hm3KHxp{-webkit-box-align:center;align-items:center;display:-webkit-inline-box;display:inline-flex;-webkit-box-pack:center;justify-content:center;line-height:1}._25StEhM_EAeucXfVOWyLox{height:20px;width:20px}._25StEhM_EAeucXfVOWyLox .rCENnIfouu-eLFT3IxLzy{height:100%;width:100%}._3vuO1GddM7FCw6XiUl_0yI{height:30px;width:30px}._3vuO1GddM7FCw6XiUl_0yI .rCENnIfouu-eLFT3IxLzy{height:100%;width:100%}._3wzpzfUUSA_J6tyMCHicw5{height:50px;width:50px}._3wzpzfUUSA_J6tyMCHicw5 .rCENnIfouu-eLFT3IxLzy{height:100%;width:100%}._3UXj0wNRrCQaSBM_SU3-9s{height:100px;width:100px}._3UXj0wNRrCQaSBM_SU3-9s .rCENnIfouu-eLFT3IxLzy{height:100%;width:100%}.rCENnIfouu-eLFT3IxLzy{overflow:hidden;max-height:100%;max-width:100%;vertical-align:bottom}", "" ]), 
    // exports
    exports.locals = {
        iconBody: "AzcMg-ed8zW7A3hm3KHxp",
        iconBody: "AzcMg-ed8zW7A3hm3KHxp",
        small: "_25StEhM_EAeucXfVOWyLox",
        small: "_25StEhM_EAeucXfVOWyLox",
        svg: "rCENnIfouu-eLFT3IxLzy",
        svg: "rCENnIfouu-eLFT3IxLzy",
        medium: "_3vuO1GddM7FCw6XiUl_0yI",
        medium: "_3vuO1GddM7FCw6XiUl_0yI",
        large: "_3wzpzfUUSA_J6tyMCHicw5",
        large: "_3wzpzfUUSA_J6tyMCHicw5",
        xlarge: "_3UXj0wNRrCQaSBM_SU3-9s",
        xlarge: "_3UXj0wNRrCQaSBM_SU3-9s"
    };
}, /* 13 */
/***/
function(module, exports) {
    /*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
    // css base code, injected by the css-loader
    module.exports = function() {
        var list = [];
        // return the list of modules as css string
        // import a list of modules into the list
        return list.toString = function() {
            for (var result = [], i = 0; i < this.length; i++) {
                var item = this[i];
                item[2] ? result.push("@media " + item[2] + "{" + item[1] + "}") : result.push(item[1]);
            }
            return result.join("");
        }, list.i = function(modules, mediaQuery) {
            "string" == typeof modules && (modules = [ [ null, modules, "" ] ]);
            for (var alreadyImportedModules = {}, i = 0; i < this.length; i++) {
                var id = this[i][0];
                "number" == typeof id && (alreadyImportedModules[id] = !0);
            }
            for (i = 0; i < modules.length; i++) {
                var item = modules[i];
                // skip already imported module
                // this implementation is not 100% perfect for weird media query combinations
                //  when a module is imported multiple times with different media queries.
                //  I hope this will never occur (Hey this way we have smaller bundles)
                "number" == typeof item[0] && alreadyImportedModules[item[0]] || (mediaQuery && !item[2] ? item[2] = mediaQuery : mediaQuery && (item[2] = "(" + item[2] + ") and (" + mediaQuery + ")"), 
                list.push(item));
            }
        }, list;
    };
}, /* 14 */
/***/
function(module, exports, __webpack_require__) {
    function addStylesToDom(styles, options) {
        for (var i = 0; i < styles.length; i++) {
            var item = styles[i], domStyle = stylesInDom[item.id];
            if (domStyle) {
                domStyle.refs++;
                for (var j = 0; j < domStyle.parts.length; j++) domStyle.parts[j](item.parts[j]);
                for (;j < item.parts.length; j++) domStyle.parts.push(addStyle(item.parts[j], options));
            } else {
                for (var parts = [], j = 0; j < item.parts.length; j++) parts.push(addStyle(item.parts[j], options));
                stylesInDom[item.id] = {
                    id: item.id,
                    refs: 1,
                    parts: parts
                };
            }
        }
    }
    function listToStyles(list) {
        for (var styles = [], newStyles = {}, i = 0; i < list.length; i++) {
            var item = list[i], id = item[0], css = item[1], media = item[2], sourceMap = item[3], part = {
                css: css,
                media: media,
                sourceMap: sourceMap
            };
            newStyles[id] ? newStyles[id].parts.push(part) : styles.push(newStyles[id] = {
                id: id,
                parts: [ part ]
            });
        }
        return styles;
    }
    function insertStyleElement(options, styleElement) {
        var head = getHeadElement(), lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
        if ("top" === options.insertAt) lastStyleElementInsertedAtTop ? lastStyleElementInsertedAtTop.nextSibling ? head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling) : head.appendChild(styleElement) : head.insertBefore(styleElement, head.firstChild), 
        styleElementsInsertedAtTop.push(styleElement); else {
            if ("bottom" !== options.insertAt) throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
            head.appendChild(styleElement);
        }
    }
    function removeStyleElement(styleElement) {
        styleElement.parentNode.removeChild(styleElement);
        var idx = styleElementsInsertedAtTop.indexOf(styleElement);
        idx >= 0 && styleElementsInsertedAtTop.splice(idx, 1);
    }
    function createStyleElement(options) {
        var styleElement = document.createElement("style");
        return styleElement.type = "text/css", insertStyleElement(options, styleElement), 
        styleElement;
    }
    function createLinkElement(options) {
        var linkElement = document.createElement("link");
        return linkElement.rel = "stylesheet", insertStyleElement(options, linkElement), 
        linkElement;
    }
    function addStyle(obj, options) {
        var styleElement, update, remove;
        if (options.singleton) {
            var styleIndex = singletonCounter++;
            styleElement = singletonElement || (singletonElement = createStyleElement(options)), 
            update = applyToSingletonTag.bind(null, styleElement, styleIndex, !1), remove = applyToSingletonTag.bind(null, styleElement, styleIndex, !0);
        } else obj.sourceMap && "function" == typeof URL && "function" == typeof URL.createObjectURL && "function" == typeof URL.revokeObjectURL && "function" == typeof Blob && "function" == typeof btoa ? (styleElement = createLinkElement(options), 
        update = updateLink.bind(null, styleElement), remove = function() {
            removeStyleElement(styleElement), styleElement.href && URL.revokeObjectURL(styleElement.href);
        }) : (styleElement = createStyleElement(options), update = applyToTag.bind(null, styleElement), 
        remove = function() {
            removeStyleElement(styleElement);
        });
        return update(obj), function(newObj) {
            if (newObj) {
                if (newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap) return;
                update(obj = newObj);
            } else remove();
        };
    }
    function applyToSingletonTag(styleElement, index, remove, obj) {
        var css = remove ? "" : obj.css;
        if (styleElement.styleSheet) styleElement.styleSheet.cssText = replaceText(index, css); else {
            var cssNode = document.createTextNode(css), childNodes = styleElement.childNodes;
            childNodes[index] && styleElement.removeChild(childNodes[index]), childNodes.length ? styleElement.insertBefore(cssNode, childNodes[index]) : styleElement.appendChild(cssNode);
        }
    }
    function applyToTag(styleElement, obj) {
        var css = obj.css, media = obj.media;
        if (media && styleElement.setAttribute("media", media), styleElement.styleSheet) styleElement.styleSheet.cssText = css; else {
            for (;styleElement.firstChild; ) styleElement.removeChild(styleElement.firstChild);
            styleElement.appendChild(document.createTextNode(css));
        }
    }
    function updateLink(linkElement, obj) {
        var css = obj.css, sourceMap = obj.sourceMap;
        sourceMap && (// http://stackoverflow.com/a/26603875
        css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */");
        var blob = new Blob([ css ], {
            type: "text/css"
        }), oldSrc = linkElement.href;
        linkElement.href = URL.createObjectURL(blob), oldSrc && URL.revokeObjectURL(oldSrc);
    }
    /*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
    var stylesInDom = {}, memoize = function(fn) {
        var memo;
        return function() {
            return "undefined" == typeof memo && (memo = fn.apply(this, arguments)), memo;
        };
    }, isOldIE = memoize(function() {
        return /msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase());
    }), getHeadElement = memoize(function() {
        return document.head || document.getElementsByTagName("head")[0];
    }), singletonElement = null, singletonCounter = 0, styleElementsInsertedAtTop = [];
    module.exports = function(list, options) {
        options = options || {}, // Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
        // tags it will allow on a page
        "undefined" == typeof options.singleton && (options.singleton = isOldIE()), // By default, add <style> tags to the bottom of <head>.
        "undefined" == typeof options.insertAt && (options.insertAt = "bottom");
        var styles = listToStyles(list);
        return addStylesToDom(styles, options), function(newList) {
            for (var mayRemove = [], i = 0; i < styles.length; i++) {
                var item = styles[i], domStyle = stylesInDom[item.id];
                domStyle.refs--, mayRemove.push(domStyle);
            }
            if (newList) {
                var newStyles = listToStyles(newList);
                addStylesToDom(newStyles, options);
            }
            for (var i = 0; i < mayRemove.length; i++) {
                var domStyle = mayRemove[i];
                if (0 === domStyle.refs) {
                    for (var j = 0; j < domStyle.parts.length; j++) domStyle.parts[j]();
                    delete stylesInDom[domStyle.id];
                }
            }
        };
    };
    var replaceText = function() {
        var textStore = [];
        return function(index, replacement) {
            return textStore[index] = replacement, textStore.filter(Boolean).join("\n");
        };
    }();
}, /* 15 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    }), exports.NotImplementedError = void 0;
    var _createError = __webpack_require__(16), _createError2 = _interopRequireDefault(_createError);
    exports.NotImplementedError = (0, _createError2.default)("NotImplementedError");
}, /* 16 */
/***/
function(module, exports) {
    module.exports = require("create-error");
}, /* 17 */
/***/
function(module, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    /**
	 * Icon size values.
	 *
	 * @exports size
	 * @enum {string}
	 */
    var size = {
        /** small icon */
        small: "small",
        /** medium icon */
        medium: "medium",
        /** large icon */
        large: "large",
        /** xlarge icon */
        xlarge: "xlarge"
    };
    exports.default = size;
}, /* 18 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _extends2 = __webpack_require__(19), _extends3 = _interopRequireDefault(_extends2), _getPrototypeOf = __webpack_require__(4), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(5), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(6), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(7), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(8), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(9), _react2 = _interopRequireDefault(_react), _Icon2 = __webpack_require__(2), _Icon3 = _interopRequireDefault(_Icon2), _class = function(_Icon) {
        function _class() {
            return (0, _classCallCheck3.default)(this, _class), (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, 
            _getPrototypeOf2.default)(_class)).apply(this, arguments));
        }
        return (0, _inherits3.default)(_class, _Icon), (0, _createClass3.default)(_class, [ {
            key: "getGlyphTemplate",
            value: function() {
                return function(props) {
                    var title = props.label, iconProps = (0, _extends3.default)({}, props);
                    // eslint-disable-next-line max-len, react/jsx-space-before-closing
                    return delete iconProps.label, _react2.default.createElement("svg", (0, _extends3.default)({
                        width: "20",
                        height: "20",
                        viewBox: "0 0 20 20",
                        focusable: "false"
                    }, iconProps, {
                        "aria-labelledby": "title-8e4bdqy"
                    }), _react2.default.createElement("title", {
                        id: "title-8e4bdqy"
                    }, title), _react2.default.createElement("path", {
                        d: "M10.24 5.35l-3 3.5a1 1 0 0 0 0 1.3l3 3.5a1 1 0 0 0 1.52-1.3l-3-3.5v1.3l3-3.5a1 1 0 1 0-1.52-1.3z",
                        fill: "currentColor",
                        fillRule: "evenodd",
                        role: "presentation"
                    }));
                };
            }
        } ]), _class;
    }(_Icon3.default);
    _class.displayName = "ArrowleftIcon", exports.default = _class;
}, /* 19 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/extends");
}, /* 20 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _extends2 = __webpack_require__(19), _extends3 = _interopRequireDefault(_extends2), _getPrototypeOf = __webpack_require__(4), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(5), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(6), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(7), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(8), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(9), _react2 = _interopRequireDefault(_react), _Icon2 = __webpack_require__(2), _Icon3 = _interopRequireDefault(_Icon2), _class = function(_Icon) {
        function _class() {
            return (0, _classCallCheck3.default)(this, _class), (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, 
            _getPrototypeOf2.default)(_class)).apply(this, arguments));
        }
        return (0, _inherits3.default)(_class, _Icon), (0, _createClass3.default)(_class, [ {
            key: "getGlyphTemplate",
            value: function() {
                return function(props) {
                    var title = props.label, iconProps = (0, _extends3.default)({}, props);
                    // eslint-disable-next-line max-len, react/jsx-space-before-closing
                    return delete iconProps.label, _react2.default.createElement("svg", (0, _extends3.default)({
                        width: "20",
                        height: "20",
                        viewBox: "0 0 20 20",
                        focusable: "false"
                    }, iconProps, {
                        "aria-labelledby": "title-9tlglob"
                    }), _react2.default.createElement("title", {
                        id: "title-9tlglob"
                    }, title), _react2.default.createElement("path", {
                        d: "M8.76 13.65l3-3.5a1 1 0 0 0 0-1.3l-3-3.5a1 1 0 0 0-1.52 1.3l3 3.5v-1.3l-3 3.5a1 1 0 1 0 1.52 1.3z",
                        fill: "currentColor",
                        fillRule: "evenodd",
                        role: "presentation"
                    }));
                };
            }
        } ]), _class;
    }(_Icon3.default);
    _class.displayName = "ArrowrightIcon", exports.default = _class;
}, /* 21 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _extends2 = __webpack_require__(19), _extends3 = _interopRequireDefault(_extends2), _getPrototypeOf = __webpack_require__(4), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(5), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(6), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(7), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(8), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(9), _react2 = _interopRequireDefault(_react), _Icon2 = __webpack_require__(2), _Icon3 = _interopRequireDefault(_Icon2), _class = function(_Icon) {
        function _class() {
            return (0, _classCallCheck3.default)(this, _class), (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, 
            _getPrototypeOf2.default)(_class)).apply(this, arguments));
        }
        return (0, _inherits3.default)(_class, _Icon), (0, _createClass3.default)(_class, [ {
            key: "getGlyphTemplate",
            value: function() {
                return function(props) {
                    var title = props.label, iconProps = (0, _extends3.default)({}, props);
                    // eslint-disable-next-line max-len, react/jsx-space-before-closing
                    return delete iconProps.label, _react2.default.createElement("svg", (0, _extends3.default)({
                        width: "24",
                        height: "24",
                        viewBox: "0 0 24 24",
                        focusable: "false"
                    }, iconProps, {
                        "aria-labelledby": "title-6tt424a"
                    }), _react2.default.createElement("title", {
                        id: "title-6tt424a"
                    }, title), _react2.default.createElement("g", {
                        fill: "none",
                        fillRule: "evenodd"
                    }, _react2.default.createElement("path", {
                        d: "M0 0h24v24H0z",
                        role: "presentation"
                    }), _react2.default.createElement("g", {
                        stroke: "currentColor",
                        strokeWidth: "2",
                        strokeLinecap: "round"
                    }, _react2.default.createElement("path", {
                        d: "M15 14.828L17.828 12 15 9.172",
                        strokeLinejoin: "round",
                        role: "presentation"
                    }), _react2.default.createElement("path", {
                        d: "M16 12H6",
                        role: "presentation"
                    }))));
                };
            }
        } ]), _class;
    }(_Icon3.default);
    _class.displayName = "ArrowrightlongIcon", exports.default = _class;
}, /* 22 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _extends2 = __webpack_require__(19), _extends3 = _interopRequireDefault(_extends2), _getPrototypeOf = __webpack_require__(4), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(5), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(6), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(7), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(8), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(9), _react2 = _interopRequireDefault(_react), _Icon2 = __webpack_require__(2), _Icon3 = _interopRequireDefault(_Icon2), _class = function(_Icon) {
        function _class() {
            return (0, _classCallCheck3.default)(this, _class), (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, 
            _getPrototypeOf2.default)(_class)).apply(this, arguments));
        }
        return (0, _inherits3.default)(_class, _Icon), (0, _createClass3.default)(_class, [ {
            key: "getGlyphTemplate",
            value: function() {
                return function(props) {
                    var title = props.label, iconProps = (0, _extends3.default)({}, props);
                    // eslint-disable-next-line max-len, react/jsx-space-before-closing
                    return delete iconProps.label, _react2.default.createElement("svg", (0, _extends3.default)({
                        width: "20",
                        height: "19",
                        viewBox: "0 0 20 19",
                        focusable: "false"
                    }, iconProps, {
                        "aria-labelledby": "title-b5ooho4"
                    }), _react2.default.createElement("title", {
                        id: "title-b5ooho4"
                    }, title), _react2.default.createElement("path", {
                        d: "M19.888.246a.473.473 0 0 0-.377-.19.455.455 0 0 0-.218.055C16.52 1.63 13.306 2.432 9.997 2.433 6.69 2.433 3.475 1.629.702.112A.454.454 0 0 0 .484.056a.473.473 0 0 0-.378.19.463.463 0 0 0 .088.641A16.338 16.338 0 0 0 9.996 4.15h.002A16.337 16.337 0 0 0 19.802.886a.462.462 0 0 0 .086-.64zM16.702 4.57a.372.372 0 0 0-.359-.052c-.803.307-1.62.54-2.364.714a.465.465 0 0 0-.326.284C13.11 7.003 11.725 8.418 10.27 9.9c-.058.055-.14.128-.273.128-.132 0-.213-.07-.273-.128-1.454-1.483-2.84-2.893-3.382-4.38a.465.465 0 0 0-.326-.284 18.355 18.355 0 0 1-2.366-.722.375.375 0 0 0-.357.052.372.372 0 0 0-.144.328c.123 1.236.611 2.445 1.493 3.711.828 1.19 1.91 2.293 2.954 3.359 1.926 1.964 3.745 3.819 3.904 5.97a.372.372 0 0 0 .371.344h2.262a.372.372 0 0 0 .372-.39c-.071-1.439-.612-2.879-1.654-4.403-.219-.32-.453-.63-.697-.934a.27.27 0 0 1 .018-.356l.226-.231c1.046-1.066 2.126-2.168 2.955-3.359.882-1.266 1.37-2.468 1.493-3.704a.382.382 0 0 0-.144-.332zM7.57 13.638a.344.344 0 0 0-.264-.113.373.373 0 0 0-.307.174c-.952 1.448-1.443 2.815-1.511 4.188a.377.377 0 0 0 .102.276c.07.074.17.116.271.116h2.258a.375.375 0 0 0 .373-.346c.049-.662.255-1.325.63-2.022a.524.524 0 0 0-.046-.565c-.372-.484-.828-1-1.506-1.708zM10 5.678c.708 0 1.12-.043 1.264-.043a.345.345 0 0 1 .315.482c-.094.251-.523 1.156-1.32 1.931a.364.364 0 0 1-.261.104h-.001a.364.364 0 0 1-.26-.104c-.799-.775-1.227-1.68-1.321-1.931a.345.345 0 0 1 .315-.481c.144 0 .555.042 1.264.042h.004z",
                        fill: "currentColor",
                        fillRule: "evenodd",
                        role: "presentation"
                    }));
                };
            }
        } ]), _class;
    }(_Icon3.default);
    _class.displayName = "AtlassianIcon", exports.default = _class;
}, /* 23 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _extends2 = __webpack_require__(19), _extends3 = _interopRequireDefault(_extends2), _getPrototypeOf = __webpack_require__(4), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(5), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(6), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(7), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(8), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(9), _react2 = _interopRequireDefault(_react), _Icon2 = __webpack_require__(2), _Icon3 = _interopRequireDefault(_Icon2), _class = function(_Icon) {
        function _class() {
            return (0, _classCallCheck3.default)(this, _class), (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, 
            _getPrototypeOf2.default)(_class)).apply(this, arguments));
        }
        return (0, _inherits3.default)(_class, _Icon), (0, _createClass3.default)(_class, [ {
            key: "getGlyphTemplate",
            value: function() {
                return function(props) {
                    var title = props.label, iconProps = (0, _extends3.default)({}, props);
                    // eslint-disable-next-line max-len, react/jsx-space-before-closing
                    return delete iconProps.label, _react2.default.createElement("svg", (0, _extends3.default)({
                        width: "22",
                        height: "22",
                        viewBox: "-1 -1 22 22",
                        focusable: "false"
                    }, iconProps, {
                        "aria-labelledby": "title-llqjhl1"
                    }), _react2.default.createElement("title", {
                        id: "title-llqjhl1"
                    }, title), _react2.default.createElement("g", {
                        fill: "currentColor",
                        fillRule: "evenodd"
                    }, _react2.default.createElement("path", {
                        d: "M10 19c-.3 0-.7-.1-1-.3l-6-3.5c-.6-.4-1-1-1-1.7V6.6c0-.7.4-1.4 1-1.7l6-3.5c.6-.4 1.4-.4 2 0l6 3.5c.6.4 1 1 1 1.7v6.9c0 .7-.4 1.4-1 1.7l-6 3.5c-.3.2-.7.3-1 .3zm0-15.8L4 6.6v6.9l6 3.5 6-3.5.5.9-.5-.9V6.6l-6-3.4z",
                        role: "presentation"
                    }), _react2.default.createElement("path", {
                        d: "M10 13c-1.6 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3-1.4 3-3 3zm0-4c-.5 0-1 .4-1 1s.4 1 1 1 1-.4 1-1-.5-1-1-1z",
                        role: "presentation"
                    })));
                };
            }
        } ]), _class;
    }(_Icon3.default);
    _class.displayName = "BitbucketAddonsIcon", exports.default = _class;
}, /* 24 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _extends2 = __webpack_require__(19), _extends3 = _interopRequireDefault(_extends2), _getPrototypeOf = __webpack_require__(4), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(5), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(6), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(7), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(8), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(9), _react2 = _interopRequireDefault(_react), _Icon2 = __webpack_require__(2), _Icon3 = _interopRequireDefault(_Icon2), _class = function(_Icon) {
        function _class() {
            return (0, _classCallCheck3.default)(this, _class), (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, 
            _getPrototypeOf2.default)(_class)).apply(this, arguments));
        }
        return (0, _inherits3.default)(_class, _Icon), (0, _createClass3.default)(_class, [ {
            key: "getGlyphTemplate",
            value: function() {
                return function(props) {
                    var title = props.label, iconProps = (0, _extends3.default)({}, props);
                    // eslint-disable-next-line max-len, react/jsx-space-before-closing
                    return delete iconProps.label, _react2.default.createElement("svg", (0, _extends3.default)({
                        width: "17",
                        height: "17",
                        viewBox: "92 367 17 17",
                        focusable: "false"
                    }, iconProps, {
                        "aria-labelledby": "title-heg8smk"
                    }), _react2.default.createElement("title", {
                        id: "title-heg8smk"
                    }, title), _react2.default.createElement("path", {
                        d: "M107.183 375.4c0-1.049.646-1.875 1.617-2.443a8.932 8.932 0 0 0-.692-1.672c-1.089.285-1.97-.141-2.711-.883-.741-.74-.968-1.621-.683-2.711a8.732 8.732 0 0 0-1.672-.691c-.568.97-1.595 1.615-2.642 1.615-1.048 0-2.074-.645-2.643-1.615a8.697 8.697 0 0 0-1.671.691c.285 1.09.059 1.971-.684 2.711-.74.742-1.621 1.168-2.711.883a8.797 8.797 0 0 0-.691 1.672c.97.568 1.615 1.394 1.615 2.443 0 1.047-.645 2.074-1.615 2.643a8.89 8.89 0 0 0 .691 1.672c1.09-.285 1.971-.059 2.711.682.741.742.969 1.623.684 2.711a8.841 8.841 0 0 0 1.672.693c.568-.973 1.595-1.617 2.643-1.617 1.047 0 2.074.645 2.643 1.617a8.963 8.963 0 0 0 1.672-.693c-.285-1.088-.059-1.969.683-2.711.741-.74 1.622-1.166 2.711-.883a8.811 8.811 0 0 0 .692-1.672c-.973-.569-1.619-1.395-1.619-2.442zm-6.783 3.652a3.652 3.652 0 1 1 0-7.306 3.653 3.653 0 0 1 0 7.306z",
                        fill: "currentColor",
                        fillRule: "evenodd",
                        role: "presentation"
                    }));
                };
            }
        } ]), _class;
    }(_Icon3.default);
    _class.displayName = "BitbucketAdminIcon", exports.default = _class;
}, /* 25 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _extends2 = __webpack_require__(19), _extends3 = _interopRequireDefault(_extends2), _getPrototypeOf = __webpack_require__(4), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(5), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(6), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(7), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(8), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(9), _react2 = _interopRequireDefault(_react), _Icon2 = __webpack_require__(2), _Icon3 = _interopRequireDefault(_Icon2), _class = function(_Icon) {
        function _class() {
            return (0, _classCallCheck3.default)(this, _class), (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, 
            _getPrototypeOf2.default)(_class)).apply(this, arguments));
        }
        return (0, _inherits3.default)(_class, _Icon), (0, _createClass3.default)(_class, [ {
            key: "getGlyphTemplate",
            value: function() {
                return function(props) {
                    var title = props.label, iconProps = (0, _extends3.default)({}, props);
                    // eslint-disable-next-line max-len, react/jsx-space-before-closing
                    return delete iconProps.label, _react2.default.createElement("svg", (0, _extends3.default)({
                        width: "22",
                        height: "22",
                        viewBox: "-1 -1 22 22",
                        focusable: "false"
                    }, iconProps, {
                        "aria-labelledby": "title-8x0wns8"
                    }), _react2.default.createElement("title", {
                        id: "title-8x0wns8"
                    }, title), _react2.default.createElement("path", {
                        d: "M17 9c0-1.7-1.3-3-3-3s-3 1.3-3 3c0 1.3.8 2.4 2 2.8V13c0 1.1-.9 2-2 2H8.8c-.3-.9-1-1.5-1.9-1.8V6.8C8.2 6.4 9 5.3 9 4c0-1.7-1.3-3-3-3S3 2.3 3 4c0 1.3.9 2.4 2 2.8v6.4c-1.2.4-2 1.5-2 2.8 0 1.7 1.3 3 3 3 1.3 0 2.4-.8 2.8-2H11c2.2 0 4-1.8 4-4v-1.2c1.2-.4 2-1.5 2-2.8zM6 3c.6 0 1 .4 1 1s-.4 1-1 1-1-.4-1-1 .5-1 1-1zm0 14c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1zm8-7c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1z",
                        fill: "currentColor",
                        fillRule: "evenodd",
                        role: "presentation"
                    }));
                };
            }
        } ]), _class;
    }(_Icon3.default);
    _class.displayName = "BitbucketBranchesIcon", exports.default = _class;
}, /* 26 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _extends2 = __webpack_require__(19), _extends3 = _interopRequireDefault(_extends2), _getPrototypeOf = __webpack_require__(4), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(5), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(6), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(7), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(8), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(9), _react2 = _interopRequireDefault(_react), _Icon2 = __webpack_require__(2), _Icon3 = _interopRequireDefault(_Icon2), _class = function(_Icon) {
        function _class() {
            return (0, _classCallCheck3.default)(this, _class), (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, 
            _getPrototypeOf2.default)(_class)).apply(this, arguments));
        }
        return (0, _inherits3.default)(_class, _Icon), (0, _createClass3.default)(_class, [ {
            key: "getGlyphTemplate",
            value: function() {
                return function(props) {
                    var title = props.label, iconProps = (0, _extends3.default)({}, props);
                    // eslint-disable-next-line max-len, react/jsx-space-before-closing
                    return delete iconProps.label, _react2.default.createElement("svg", (0, _extends3.default)({
                        width: "16",
                        height: "16",
                        viewBox: "92 327 16 16",
                        focusable: "false"
                    }, iconProps, {
                        "aria-labelledby": "title-rtyjk8m"
                    }), _react2.default.createElement("title", {
                        id: "title-rtyjk8m"
                    }, title), _react2.default.createElement("g", {
                        fill: "none",
                        stroke: "currentColor",
                        fillRule: "evenodd",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        strokeWidth: "2"
                    }, _react2.default.createElement("path", {
                        d: "M106.277 341.635h-3.613v-3.613",
                        role: "presentation"
                    }), _react2.default.createElement("path", {
                        d: "M102.667 329a6.506 6.506 0 0 1 4.333 6.132c0 2.831-1.78 5.549-4.304 6.442m-8.797-12.223h3.612v3.613",
                        role: "presentation"
                    }), _react2.default.createElement("path", {
                        d: "M97.511 341.986a6.505 6.505 0 0 1-4.334-6.132c0-2.83 1.78-5.549 4.305-6.442",
                        role: "presentation"
                    })));
                };
            }
        } ]), _class;
    }(_Icon3.default);
    _class.displayName = "BitbucketBuildsIcon", exports.default = _class;
}, /* 27 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _extends2 = __webpack_require__(19), _extends3 = _interopRequireDefault(_extends2), _getPrototypeOf = __webpack_require__(4), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(5), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(6), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(7), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(8), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(9), _react2 = _interopRequireDefault(_react), _Icon2 = __webpack_require__(2), _Icon3 = _interopRequireDefault(_Icon2), _class = function(_Icon) {
        function _class() {
            return (0, _classCallCheck3.default)(this, _class), (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, 
            _getPrototypeOf2.default)(_class)).apply(this, arguments));
        }
        return (0, _inherits3.default)(_class, _Icon), (0, _createClass3.default)(_class, [ {
            key: "getGlyphTemplate",
            value: function() {
                return function(props) {
                    var title = props.label, iconProps = (0, _extends3.default)({}, props);
                    // eslint-disable-next-line max-len, react/jsx-space-before-closing
                    return delete iconProps.label, _react2.default.createElement("svg", (0, _extends3.default)({
                        width: "22",
                        height: "22",
                        viewBox: "-1 -1 22 22",
                        focusable: "false"
                    }, iconProps, {
                        "aria-labelledby": "title-20j3duv"
                    }), _react2.default.createElement("title", {
                        id: "title-20j3duv"
                    }, title), _react2.default.createElement("path", {
                        d: "M14 10c0-1.9-1.3-3.4-3-3.9V2c0-.6-.4-1-1-1s-1 .4-1 1v4.1c-1.7.4-3 2-3 3.9s1.3 3.4 3 3.9V18c0 .6.4 1 1 1s1-.4 1-1v-4.1c1.7-.5 3-2 3-3.9zm-4 2c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z",
                        fill: "currentColor",
                        fillRule: "evenodd",
                        role: "presentation"
                    }));
                };
            }
        } ]), _class;
    }(_Icon3.default);
    _class.displayName = "BitbucketCommitsIcon", exports.default = _class;
}, /* 28 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _extends2 = __webpack_require__(19), _extends3 = _interopRequireDefault(_extends2), _getPrototypeOf = __webpack_require__(4), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(5), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(6), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(7), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(8), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(9), _react2 = _interopRequireDefault(_react), _Icon2 = __webpack_require__(2), _Icon3 = _interopRequireDefault(_Icon2), _class = function(_Icon) {
        function _class() {
            return (0, _classCallCheck3.default)(this, _class), (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, 
            _getPrototypeOf2.default)(_class)).apply(this, arguments));
        }
        return (0, _inherits3.default)(_class, _Icon), (0, _createClass3.default)(_class, [ {
            key: "getGlyphTemplate",
            value: function() {
                return function(props) {
                    var title = props.label, iconProps = (0, _extends3.default)({}, props);
                    // eslint-disable-next-line max-len, react/jsx-space-before-closing
                    return delete iconProps.label, _react2.default.createElement("svg", (0, _extends3.default)({
                        width: "22",
                        height: "22",
                        viewBox: "-1 -1 22 22",
                        focusable: "false"
                    }, iconProps, {
                        "aria-labelledby": "title-5w8u28i"
                    }), _react2.default.createElement("title", {
                        id: "title-5w8u28i"
                    }, title), _react2.default.createElement("path", {
                        d: "M17 2H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V4c0-1.2-.8-2-2-2zM8 4h9v2H8V4zM3 4h3v12H3V4zm14 12H8V8h9v8z",
                        fill: "currentColor",
                        fillRule: "evenodd",
                        role: "presentation"
                    }));
                };
            }
        } ]), _class;
    }(_Icon3.default);
    _class.displayName = "BitbucketDashboardIcon", exports.default = _class;
}, /* 29 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _extends2 = __webpack_require__(19), _extends3 = _interopRequireDefault(_extends2), _getPrototypeOf = __webpack_require__(4), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(5), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(6), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(7), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(8), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(9), _react2 = _interopRequireDefault(_react), _Icon2 = __webpack_require__(2), _Icon3 = _interopRequireDefault(_Icon2), _class = function(_Icon) {
        function _class() {
            return (0, _classCallCheck3.default)(this, _class), (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, 
            _getPrototypeOf2.default)(_class)).apply(this, arguments));
        }
        return (0, _inherits3.default)(_class, _Icon), (0, _createClass3.default)(_class, [ {
            key: "getGlyphTemplate",
            value: function() {
                return function(props) {
                    var title = props.label, iconProps = (0, _extends3.default)({}, props);
                    // eslint-disable-next-line max-len, react/jsx-space-before-closing
                    return delete iconProps.label, _react2.default.createElement("svg", (0, _extends3.default)({
                        width: "22",
                        height: "22",
                        viewBox: "-1 -1 22 22",
                        focusable: "false"
                    }, iconProps, {
                        "aria-labelledby": "title-ubtuxuo"
                    }), _react2.default.createElement("title", {
                        id: "title-ubtuxuo"
                    }, title), _react2.default.createElement("g", {
                        fill: "currentColor",
                        fillRule: "evenodd"
                    }, _react2.default.createElement("path", {
                        d: "M14.8 3.4c-.3 0-.5 0-.8.1C12.9 1.9 11 1 9 1 6.2 1 3.8 2.9 3.1 5.6 1.3 6 0 7.7 0 9.6 0 11.9 1.9 14 4 14h4v-2H4c-1 0-2-1.1-2-2.4 0-1.2.8-2.1 2-2.1h.3c.5 0 .6-.5.6-.5v-.3C5.2 4.5 6.9 3 9 3c1.5 0 3 .8 3.7 2.1l.2.3s.3.5.9.2l.2-.1c.3-.1.6-.1 1-.1 1.6 0 3.1 1.3 3.1 3.1S16.6 12 15 12h-3v2h2.9c2.7 0 5.1-2.6 5.1-5.5s-2.4-5.1-5.2-5.1z",
                        role: "presentation"
                    }), _react2.default.createElement("path", {
                        d: "M13 15.3c-.3-.3-.8-.3-1.1 0l-.9.9V8.1c0-.6-.4-1-1-1s-1 .4-1 1v8.1l-.9-.9c-.3-.3-.8-.3-1.1 0-.3.3-.3.8 0 1.1l2.4 2.4c.4.3 1 .3 1.3 0l2.4-2.4c.2-.2.2-.4.2-.6 0-.2-.1-.3-.3-.5z",
                        role: "presentation"
                    })));
                };
            }
        } ]), _class;
    }(_Icon3.default);
    _class.displayName = "BitbucketDownloadsIcon", exports.default = _class;
}, /* 30 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _extends2 = __webpack_require__(19), _extends3 = _interopRequireDefault(_extends2), _getPrototypeOf = __webpack_require__(4), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(5), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(6), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(7), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(8), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(9), _react2 = _interopRequireDefault(_react), _Icon2 = __webpack_require__(2), _Icon3 = _interopRequireDefault(_Icon2), _class = function(_Icon) {
        function _class() {
            return (0, _classCallCheck3.default)(this, _class), (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, 
            _getPrototypeOf2.default)(_class)).apply(this, arguments));
        }
        return (0, _inherits3.default)(_class, _Icon), (0, _createClass3.default)(_class, [ {
            key: "getGlyphTemplate",
            value: function() {
                return function(props) {
                    var title = props.label, iconProps = (0, _extends3.default)({}, props);
                    // eslint-disable-next-line max-len, react/jsx-space-before-closing
                    return delete iconProps.label, _react2.default.createElement("svg", (0, _extends3.default)({
                        width: "15",
                        height: "18",
                        viewBox: "0 0 15 18",
                        focusable: "false"
                    }, iconProps, {
                        "aria-labelledby": "title-eppb7l1"
                    }), _react2.default.createElement("title", {
                        id: "title-eppb7l1"
                    }, title), _react2.default.createElement("path", {
                        d: "M6 0a4 4 0 1 0 0 8 4 4 0 0 0 0-8m0 2a2 2 0 1 1 0 4 2 2 0 0 1 0-4m3 7H3a3 3 0 0 0-3 3v3.7A9.07 9.07 0 0 0 5.9 18a9 9 0 0 0 6.1-2.4V12a3 3 0 0 0-3-3m0 2a.94.94 0 0 1 1 1v2.6a7.39 7.39 0 0 1-4.1 1.3A6.67 6.67 0 0 1 2 14.7V12a.94.94 0 0 1 1-1h6m1.78-3a1 1 0 0 1 .29-.71L12.43 6l-1.31-1.34a1 1 0 0 1 1.41-1.41l2 2a1 1 0 0 1 0 1.41l-2.04 2.08A1 1 0 0 1 10.78 8z",
                        fill: "currentColor",
                        fillRule: "evenodd",
                        role: "presentation"
                    }));
                };
            }
        } ]), _class;
    }(_Icon3.default);
    _class.displayName = "BitbucketFollowersIcon", exports.default = _class;
}, /* 31 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _extends2 = __webpack_require__(19), _extends3 = _interopRequireDefault(_extends2), _getPrototypeOf = __webpack_require__(4), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(5), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(6), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(7), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(8), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(9), _react2 = _interopRequireDefault(_react), _Icon2 = __webpack_require__(2), _Icon3 = _interopRequireDefault(_Icon2), _class = function(_Icon) {
        function _class() {
            return (0, _classCallCheck3.default)(this, _class), (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, 
            _getPrototypeOf2.default)(_class)).apply(this, arguments));
        }
        return (0, _inherits3.default)(_class, _Icon), (0, _createClass3.default)(_class, [ {
            key: "getGlyphTemplate",
            value: function() {
                return function(props) {
                    var title = props.label, iconProps = (0, _extends3.default)({}, props);
                    // eslint-disable-next-line max-len, react/jsx-space-before-closing
                    return delete iconProps.label, _react2.default.createElement("svg", (0, _extends3.default)({
                        width: "15",
                        height: "18",
                        viewBox: "0 0 15 18",
                        focusable: "false"
                    }, iconProps, {
                        "aria-labelledby": "title-gg7c9xv"
                    }), _react2.default.createElement("title", {
                        id: "title-gg7c9xv"
                    }, title), _react2.default.createElement("path", {
                        d: "M6 0a4 4 0 1 0 0 8 4 4 0 0 0 0-8m0 2a2 2 0 1 1 0 4 2 2 0 0 1 0-4m3 7H3a3 3 0 0 0-3 3v3.7A9.07 9.07 0 0 0 5.9 18a9 9 0 0 0 6.1-2.4V12a3 3 0 0 0-3-3m0 2a.94.94 0 0 1 1 1v2.6a7.39 7.39 0 0 1-4.1 1.3A6.67 6.67 0 0 1 2 14.7V12a.94.94 0 0 1 1-1h6m5.84-7a1 1 0 0 1-.29.71L13.2 6l1.3 1.32a1 1 0 1 1-1.41 1.41l-2-2a1 1 0 0 1 0-1.41l2.06-2.06a1 1 0 0 1 1.69.74z",
                        fill: "currentColor",
                        fillRule: "evenodd",
                        role: "presentation"
                    }));
                };
            }
        } ]), _class;
    }(_Icon3.default);
    _class.displayName = "BitbucketFollowingIcon", exports.default = _class;
}, /* 32 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _extends2 = __webpack_require__(19), _extends3 = _interopRequireDefault(_extends2), _getPrototypeOf = __webpack_require__(4), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(5), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(6), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(7), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(8), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(9), _react2 = _interopRequireDefault(_react), _Icon2 = __webpack_require__(2), _Icon3 = _interopRequireDefault(_Icon2), _class = function(_Icon) {
        function _class() {
            return (0, _classCallCheck3.default)(this, _class), (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, 
            _getPrototypeOf2.default)(_class)).apply(this, arguments));
        }
        return (0, _inherits3.default)(_class, _Icon), (0, _createClass3.default)(_class, [ {
            key: "getGlyphTemplate",
            value: function() {
                return function(props) {
                    var title = props.label, iconProps = (0, _extends3.default)({}, props);
                    // eslint-disable-next-line max-len, react/jsx-space-before-closing
                    return delete iconProps.label, _react2.default.createElement("svg", (0, _extends3.default)({
                        width: "22",
                        height: "22",
                        viewBox: "-1 -1 22 22",
                        focusable: "false"
                    }, iconProps, {
                        "aria-labelledby": "title-lc02272"
                    }), _react2.default.createElement("title", {
                        id: "title-lc02272"
                    }, title), _react2.default.createElement("g", {
                        fill: "currentColor",
                        fillRule: "evenodd"
                    }, _react2.default.createElement("path", {
                        d: "M17 1H3c-1.1 0-2 .9-2 2v7c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 9H3V3h14v7zm-2 4H5v-1H3v1c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2v-1h-2v1zm-9 3.2c0 1 .9 1.8 2 1.8h4c1.1 0 2-.8 2-1.8V17H6v.2z",
                        role: "presentation"
                    }), _react2.default.createElement("path", {
                        d: "M8.3 8.7c.4.4 1 .4 1.4 0l3-3c.4-.4.4-1 0-1.4-.4-.4-1-.4-1.4 0L9 6.6l-.8-.8c-.4-.4-1-.4-1.4 0-.4.4-.4 1 0 1.4l1.5 1.5z",
                        role: "presentation"
                    })));
                };
            }
        } ]), _class;
    }(_Icon3.default);
    _class.displayName = "BitbucketIssuesIcon", exports.default = _class;
}, /* 33 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _extends2 = __webpack_require__(19), _extends3 = _interopRequireDefault(_extends2), _getPrototypeOf = __webpack_require__(4), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(5), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(6), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(7), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(8), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(9), _react2 = _interopRequireDefault(_react), _Icon2 = __webpack_require__(2), _Icon3 = _interopRequireDefault(_Icon2), _class = function(_Icon) {
        function _class() {
            return (0, _classCallCheck3.default)(this, _class), (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, 
            _getPrototypeOf2.default)(_class)).apply(this, arguments));
        }
        return (0, _inherits3.default)(_class, _Icon), (0, _createClass3.default)(_class, [ {
            key: "getGlyphTemplate",
            value: function() {
                return function(props) {
                    var title = props.label, iconProps = (0, _extends3.default)({}, props);
                    // eslint-disable-next-line max-len, react/jsx-space-before-closing
                    return delete iconProps.label, _react2.default.createElement("svg", (0, _extends3.default)({
                        width: "22",
                        height: "24",
                        viewBox: "9 8 22 24",
                        focusable: "false"
                    }, iconProps, {
                        "aria-labelledby": "title-0imwlll"
                    }), _react2.default.createElement("title", {
                        id: "title-0imwlll"
                    }, title), _react2.default.createElement("path", {
                        d: "M27.57 24.874c-.16 0-.288.112-.288.112s-2.59 2.034-7.271 2.034c-4.682 0-7.272-2.034-7.272-2.034s-.128-.112-.288-.112c-.19 0-.372.127-.372.408 0 .03.003.06.008.088.402 2.133.696 3.647.748 3.877.35 1.569 3.447 2.753 7.176 2.753s6.825-1.184 7.176-2.753c.051-.23.345-1.744.747-3.877a.474.474 0 0 0 .008-.088c0-.28-.18-.408-.372-.408zM20.018 8C14.228 8 9.5 9.543 9.5 11.459c0 .505 1.263 7.74 1.763 10.61.225 1.287 3.58 3.174 8.752 3.174l.006-.015v.015c5.172 0 8.527-1.887 8.751-3.174.501-2.87 1.764-10.105 1.764-10.61C30.536 9.543 25.808 8 20.018 8zm0 14.919c-1.847 0-3.344-1.484-3.344-3.315 0-1.83 1.497-3.314 3.344-3.314 1.847 0 3.344 1.484 3.344 3.314s-1.497 3.315-3.344 3.315zm1.602-3.372c0 .917-.75 1.66-1.675 1.66a1.668 1.668 0 0 1-1.676-1.66c0-.918.75-1.661 1.676-1.661.925 0 1.675.743 1.675 1.66zm-1.604-7.019c-3.72-.006-6.735-.646-6.733-1.431 0-.785 3.018-1.416 6.738-1.41 3.72.006 6.735.646 6.733 1.431 0 .785-3.018 1.416-6.738 1.41z",
                        fill: "currentColor",
                        fillRule: "evenodd",
                        role: "presentation"
                    }));
                };
            }
        } ]), _class;
    }(_Icon3.default);
    _class.displayName = "BitbucketLogoIcon", exports.default = _class;
}, /* 34 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _extends2 = __webpack_require__(19), _extends3 = _interopRequireDefault(_extends2), _getPrototypeOf = __webpack_require__(4), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(5), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(6), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(7), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(8), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(9), _react2 = _interopRequireDefault(_react), _Icon2 = __webpack_require__(2), _Icon3 = _interopRequireDefault(_Icon2), _class = function(_Icon) {
        function _class() {
            return (0, _classCallCheck3.default)(this, _class), (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, 
            _getPrototypeOf2.default)(_class)).apply(this, arguments));
        }
        return (0, _inherits3.default)(_class, _Icon), (0, _createClass3.default)(_class, [ {
            key: "getGlyphTemplate",
            value: function() {
                return function(props) {
                    var title = props.label, iconProps = (0, _extends3.default)({}, props);
                    // eslint-disable-next-line max-len, react/jsx-space-before-closing
                    return delete iconProps.label, _react2.default.createElement("svg", (0, _extends3.default)({
                        width: "18",
                        height: "18",
                        viewBox: "0 0 18 18",
                        focusable: "false"
                    }, iconProps, {
                        "aria-labelledby": "title-bkvdt2x"
                    }), _react2.default.createElement("title", {
                        id: "title-bkvdt2x"
                    }, title), _react2.default.createElement("g", {
                        fill: "currentColor",
                        fillRule: "evenodd"
                    }, _react2.default.createElement("path", {
                        d: "M9 3C7.3 3 6 4.3 6 6s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3m0 2c.6 0 1 .4 1 1s-.4 1-1 1-1-.4-1-1c0-.5.4-1 1-1",
                        role: "presentation"
                    }), _react2.default.createElement("path", {
                        d: "M9 0C4 0 0 4 0 9s4 9 9 9 9-4 9-9-4-9-9-9m0 2c3.9 0 7 3.1 7 7s-3.1 7-7 7-7-3.1-7-7 3.1-7 7-7",
                        role: "presentation"
                    }), _react2.default.createElement("path", {
                        d: "M11.5 10h-5C5.1 10 4 11.1 4 12.5v4c1.4 1 3.1 1.5 5 1.5s3.6-.6 5-1.5v-4c0-1.4-1.1-2.5-2.5-2.5m0 2c.3 0 .5.2.5.5v2.8c-.9.4-2 .7-3 .7s-2.1-.2-3-.7v-2.8c0-.3.2-.5.5-.5h5",
                        role: "presentation"
                    })));
                };
            }
        } ]), _class;
    }(_Icon3.default);
    _class.displayName = "BitbucketMembersIcon", exports.default = _class;
}, /* 35 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _extends2 = __webpack_require__(19), _extends3 = _interopRequireDefault(_extends2), _getPrototypeOf = __webpack_require__(4), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(5), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(6), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(7), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(8), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(9), _react2 = _interopRequireDefault(_react), _Icon2 = __webpack_require__(2), _Icon3 = _interopRequireDefault(_Icon2), _class = function(_Icon) {
        function _class() {
            return (0, _classCallCheck3.default)(this, _class), (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, 
            _getPrototypeOf2.default)(_class)).apply(this, arguments));
        }
        return (0, _inherits3.default)(_class, _Icon), (0, _createClass3.default)(_class, [ {
            key: "getGlyphTemplate",
            value: function() {
                return function(props) {
                    var title = props.label, iconProps = (0, _extends3.default)({}, props);
                    // eslint-disable-next-line max-len, react/jsx-space-before-closing
                    return delete iconProps.label, _react2.default.createElement("svg", (0, _extends3.default)({
                        width: "18",
                        height: "18",
                        viewBox: "0 0 18 18",
                        focusable: "false"
                    }, iconProps, {
                        "aria-labelledby": "title-qckoe3h"
                    }), _react2.default.createElement("title", {
                        id: "title-qckoe3h"
                    }, title), _react2.default.createElement("g", {
                        fill: "none",
                        fillRule: "evenodd"
                    }, _react2.default.createElement("path", {
                        stroke: "currentColor",
                        d: "M1 12.328V5.752L5.691 1h6.577L17 5.752v6.576L12.268 17H5.691z",
                        strokeWidth: "2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        role: "presentation"
                    }), _react2.default.createElement("path", {
                        d: "M7.24 9L5.631 7.391a1.244 1.244 0 1 1 1.76-1.76L9 7.241l1.609-1.61a1.244 1.244 0 1 1 1.76 1.76L10.759 9l1.61 1.609a1.244 1.244 0 1 1-1.76 1.76L9 10.759l-1.609 1.61a1.244 1.244 0 1 1-1.76-1.76L7.241 9z",
                        fill: "currentColor",
                        role: "presentation"
                    })));
                };
            }
        } ]), _class;
    }(_Icon3.default);
    _class.displayName = "BitbucketOptoutIcon", exports.default = _class;
}, /* 36 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _extends2 = __webpack_require__(19), _extends3 = _interopRequireDefault(_extends2), _getPrototypeOf = __webpack_require__(4), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(5), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(6), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(7), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(8), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(9), _react2 = _interopRequireDefault(_react), _Icon2 = __webpack_require__(2), _Icon3 = _interopRequireDefault(_Icon2), _class = function(_Icon) {
        function _class() {
            return (0, _classCallCheck3.default)(this, _class), (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, 
            _getPrototypeOf2.default)(_class)).apply(this, arguments));
        }
        return (0, _inherits3.default)(_class, _Icon), (0, _createClass3.default)(_class, [ {
            key: "getGlyphTemplate",
            value: function() {
                return function(props) {
                    var title = props.label, iconProps = (0, _extends3.default)({}, props);
                    // eslint-disable-next-line max-len, react/jsx-space-before-closing
                    return delete iconProps.label, _react2.default.createElement("svg", (0, _extends3.default)({
                        width: "22",
                        height: "21",
                        viewBox: "-1 0 22 21",
                        focusable: "false"
                    }, iconProps, {
                        "aria-labelledby": "title-dkso08i"
                    }), _react2.default.createElement("title", {
                        id: "title-dkso08i"
                    }, title), _react2.default.createElement("path", {
                        d: "M6.9 2H3c-.6 0-1 .4-1 1s.4 1 1 1h1.7C3 5.5 2 7.7 2 10c0 3.1 1.8 5.9 4.6 7.2.1.1.3.1.4.1.4 0 .7-.2.9-.6.2-.5 0-1.1-.5-1.3C5.3 14.4 4 12.3 4 10c0-1.7.7-3.3 2-4.5V7c0 .6.4 1 1 1s1-.4 1-1V3.1C8 2.5 7.5 2 6.9 2zM17 15h-.8c1.1-1.4 1.8-3.1 1.8-5 0-3.1-1.8-5.9-4.6-7.2-.4-.2-.8-.3-1.1-.4-.5-.2-1.1.1-1.3.6-.2.5.1 1.1.7 1.2l.9.3c2.1 1 3.4 3.1 3.4 5.4 0 1.7-.7 3.3-2 4.5V12c0-.6-.4-1-1-1s-1 .4-1 1v3.9c0 .6.5 1.1 1.1 1.1H17c.6 0 1-.4 1-1 0-.5-.4-1-1-1z",
                        fill: "currentColor",
                        fillRule: "evenodd",
                        role: "presentation"
                    }));
                };
            }
        } ]), _class;
    }(_Icon3.default);
    _class.displayName = "BitbucketPipelinesIcon", exports.default = _class;
}, /* 37 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _extends2 = __webpack_require__(19), _extends3 = _interopRequireDefault(_extends2), _getPrototypeOf = __webpack_require__(4), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(5), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(6), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(7), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(8), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(9), _react2 = _interopRequireDefault(_react), _Icon2 = __webpack_require__(2), _Icon3 = _interopRequireDefault(_Icon2), _class = function(_Icon) {
        function _class() {
            return (0, _classCallCheck3.default)(this, _class), (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, 
            _getPrototypeOf2.default)(_class)).apply(this, arguments));
        }
        return (0, _inherits3.default)(_class, _Icon), (0, _createClass3.default)(_class, [ {
            key: "getGlyphTemplate",
            value: function() {
                return function(props) {
                    var title = props.label, iconProps = (0, _extends3.default)({}, props);
                    // eslint-disable-next-line max-len, react/jsx-space-before-closing
                    return delete iconProps.label, _react2.default.createElement("svg", (0, _extends3.default)({
                        width: "22",
                        height: "22",
                        viewBox: "-1 -1 22 22",
                        focusable: "false"
                    }, iconProps, {
                        "aria-labelledby": "title-493iwx4"
                    }), _react2.default.createElement("title", {
                        id: "title-493iwx4"
                    }, title), _react2.default.createElement("path", {
                        d: "M17 18H3c-1.2 0-2-.8-2-2V4c0-1.2.8-2 2-2h4.5c.5 0 1 .2 1.4.6L10.4 4H17c1.2 0 2 .8 2 2v10c0 1.2-.8 2-2 2zM3 4v12h14V6h-6.6c-.5 0-1-.2-1.4-.6L7.5 4H3z",
                        fill: "currentColor",
                        fillRule: "evenodd",
                        role: "presentation"
                    }));
                };
            }
        } ]), _class;
    }(_Icon3.default);
    _class.displayName = "BitbucketProjectsIcon", exports.default = _class;
}, /* 38 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _extends2 = __webpack_require__(19), _extends3 = _interopRequireDefault(_extends2), _getPrototypeOf = __webpack_require__(4), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(5), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(6), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(7), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(8), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(9), _react2 = _interopRequireDefault(_react), _Icon2 = __webpack_require__(2), _Icon3 = _interopRequireDefault(_Icon2), _class = function(_Icon) {
        function _class() {
            return (0, _classCallCheck3.default)(this, _class), (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, 
            _getPrototypeOf2.default)(_class)).apply(this, arguments));
        }
        return (0, _inherits3.default)(_class, _Icon), (0, _createClass3.default)(_class, [ {
            key: "getGlyphTemplate",
            value: function() {
                return function(props) {
                    var title = props.label, iconProps = (0, _extends3.default)({}, props);
                    // eslint-disable-next-line max-len, react/jsx-space-before-closing
                    return delete iconProps.label, _react2.default.createElement("svg", (0, _extends3.default)({
                        width: "22",
                        height: "22",
                        viewBox: "-1 -1 22 22",
                        focusable: "false"
                    }, iconProps, {
                        "aria-labelledby": "title-t67m3y7"
                    }), _react2.default.createElement("title", {
                        id: "title-t67m3y7"
                    }, title), _react2.default.createElement("path", {
                        d: "M16 13.2V9c0-1.7-1.3-3-3-3h-1.9l.8-.8c.3-.3.3-.8 0-1.1-.3-.3-.8-.3-1.1 0L8.5 6.4c-.3.4-.3.9 0 1.2l2.3 2.3c.2.2.3.2.5.2s.4-.1.6-.3c.3-.3.3-.8 0-1.1l-.7-.7H13c.6 0 1 .4 1 1v4.2c-1.2.4-2 1.5-2 2.8 0 1.7 1.3 3 3 3s3-1.3 3-3c0-1.3-.8-2.4-2-2.8zM15 17c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1zM5 1C3.4 1 2 2.3 2 4c0 1.3.8 2.4 2 2.8V18c0 .6.4 1 1 1s1-.4 1-1V6.8C7.2 6.4 8 5.3 8 4c0-1.7-1.3-3-3-3zm0 4c-.5 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1z",
                        fill: "currentColor",
                        fillRule: "evenodd",
                        role: "presentation"
                    }));
                };
            }
        } ]), _class;
    }(_Icon3.default);
    _class.displayName = "BitbucketPullrequestsIcon", exports.default = _class;
}, /* 39 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _extends2 = __webpack_require__(19), _extends3 = _interopRequireDefault(_extends2), _getPrototypeOf = __webpack_require__(4), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(5), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(6), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(7), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(8), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(9), _react2 = _interopRequireDefault(_react), _Icon2 = __webpack_require__(2), _Icon3 = _interopRequireDefault(_Icon2), _class = function(_Icon) {
        function _class() {
            return (0, _classCallCheck3.default)(this, _class), (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, 
            _getPrototypeOf2.default)(_class)).apply(this, arguments));
        }
        return (0, _inherits3.default)(_class, _Icon), (0, _createClass3.default)(_class, [ {
            key: "getGlyphTemplate",
            value: function() {
                return function(props) {
                    var title = props.label, iconProps = (0, _extends3.default)({}, props);
                    // eslint-disable-next-line max-len, react/jsx-space-before-closing
                    return delete iconProps.label, _react2.default.createElement("svg", (0, _extends3.default)({
                        width: "18",
                        height: "18",
                        viewBox: "0 0 18 18",
                        focusable: "false"
                    }, iconProps, {
                        "aria-labelledby": "title-t4omwh5"
                    }), _react2.default.createElement("title", {
                        id: "title-t4omwh5"
                    }, title), _react2.default.createElement("g", {
                        transform: "translate(1 1)",
                        stroke: "currentColor",
                        fill: "none",
                        strokeWidth: "2",
                        fillRule: "evenodd"
                    }, _react2.default.createElement("rect", {
                        width: "16",
                        height: "16",
                        rx: "8",
                        role: "presentation"
                    }), _react2.default.createElement("path", {
                        d: "M5.77 6L4 7.716l1.66 1.61m4.34 0l1.77-1.716L10.11 6",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        role: "presentation"
                    })));
                };
            }
        } ]), _class;
    }(_Icon3.default);
    _class.displayName = "BitbucketReposIcon", exports.default = _class;
}, /* 40 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _extends2 = __webpack_require__(19), _extends3 = _interopRequireDefault(_extends2), _getPrototypeOf = __webpack_require__(4), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(5), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(6), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(7), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(8), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(9), _react2 = _interopRequireDefault(_react), _Icon2 = __webpack_require__(2), _Icon3 = _interopRequireDefault(_Icon2), _class = function(_Icon) {
        function _class() {
            return (0, _classCallCheck3.default)(this, _class), (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, 
            _getPrototypeOf2.default)(_class)).apply(this, arguments));
        }
        return (0, _inherits3.default)(_class, _Icon), (0, _createClass3.default)(_class, [ {
            key: "getGlyphTemplate",
            value: function() {
                return function(props) {
                    var title = props.label, iconProps = (0, _extends3.default)({}, props);
                    // eslint-disable-next-line max-len, react/jsx-space-before-closing
                    return delete iconProps.label, _react2.default.createElement("svg", (0, _extends3.default)({
                        width: "16",
                        height: "20",
                        viewBox: "2 0 16 20",
                        focusable: "false"
                    }, iconProps, {
                        "aria-labelledby": "title-mg1u8jm"
                    }), _react2.default.createElement("title", {
                        id: "title-mg1u8jm"
                    }, title), _react2.default.createElement("path", {
                        d: "M6 9c-.2 0-.5-.1-.7-.3L2.4 5.8c-.4-.4-.4-1.1 0-1.6l3-3c.4-.4 1-.4 1.4 0 .4.4.4 1 0 1.4L4.4 5l2.3 2.3c.4.4.4 1 0 1.4-.2.2-.4.3-.7.3zm-.5 10c-.2 0-.3 0-.5-.1-.5-.3-.7-.9-.4-1.4l8.5-16c.3-.5.9-.6 1.4-.4.5.3.6.9.4 1.4l-8.5 16c-.2.3-.5.5-.9.5zm7.7-8c.3 0 .5.1.7.3l2.9 2.9c.4.4.4 1.1 0 1.6l-3 3c-.4.4-1 .4-1.4 0-.4-.4-.4-1 0-1.4l2.3-2.3-2.3-2.3c-.4-.4-.4-1 0-1.4.3-.3.6-.4.8-.4z",
                        fill: "currentColor",
                        fillRule: "evenodd",
                        role: "presentation"
                    }));
                };
            }
        } ]), _class;
    }(_Icon3.default);
    _class.displayName = "BitbucketRepositoriesIcon", exports.default = _class;
}, /* 41 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _extends2 = __webpack_require__(19), _extends3 = _interopRequireDefault(_extends2), _getPrototypeOf = __webpack_require__(4), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(5), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(6), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(7), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(8), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(9), _react2 = _interopRequireDefault(_react), _Icon2 = __webpack_require__(2), _Icon3 = _interopRequireDefault(_Icon2), _class = function(_Icon) {
        function _class() {
            return (0, _classCallCheck3.default)(this, _class), (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, 
            _getPrototypeOf2.default)(_class)).apply(this, arguments));
        }
        return (0, _inherits3.default)(_class, _Icon), (0, _createClass3.default)(_class, [ {
            key: "getGlyphTemplate",
            value: function() {
                return function(props) {
                    var title = props.label, iconProps = (0, _extends3.default)({}, props);
                    // eslint-disable-next-line max-len, react/jsx-space-before-closing
                    return delete iconProps.label, _react2.default.createElement("svg", (0, _extends3.default)({
                        width: "22",
                        height: "22",
                        viewBox: "-1 -1 22 22",
                        focusable: "false"
                    }, iconProps, {
                        "aria-labelledby": "title-cys0943"
                    }), _react2.default.createElement("title", {
                        id: "title-cys0943"
                    }, title), _react2.default.createElement("g", {
                        fill: "currentColor",
                        fillRule: "evenodd"
                    }, _react2.default.createElement("path", {
                        d: "M14 7c.8 0 1.6-.3 2.1-.9.6-.6.9-1.3.9-2.1s-.3-1.6-.9-2.1C15 .8 13 .8 11.9 1.9c-.6.5-.9 1.3-.9 2.1s.3 1.5.8 2L10 9.1 8.2 6c.5-.5.8-1.2.8-2s-.3-1.6-.9-2.1C7 .7 5 .7 3.9 1.9 3.3 2.4 3 3.2 3 4s.3 1.6.9 2.1c.6.6 1.3.9 2.1.9h.4l6.7 11.5c.2.3.5.5.9.5.2 0 .3 0 .5-.1.5-.3.6-.9.4-1.4l-3.7-6.4 2.4-4.2c.1.1.3.1.4.1zM6.7 4.7c-.4.4-1 .4-1.4 0-.2-.2-.3-.4-.3-.7 0-.3.1-.5.3-.7.2-.2.4-.3.7-.3.3 0 .5.1.7.3.2.2.3.4.3.7 0 .3-.1.5-.3.7zm6.6-1.4c.2-.2.4-.3.7-.3.3 0 .5.1.7.3.2.2.3.4.3.7 0 .3-.1.5-.3.7-.4.4-1 .4-1.4 0-.2-.2-.3-.4-.3-.7 0-.3.1-.5.3-.7z",
                        role: "presentation"
                    }), _react2.default.createElement("path", {
                        d: "M8.3 12.1l-3.1 5.4c-.3.5-.2 1.1.3 1.3.2.1.3.2.5.2.3 0 .7-.2.9-.5l2.6-4.4-1.2-2z",
                        role: "presentation"
                    })));
                };
            }
        } ]), _class;
    }(_Icon3.default);
    _class.displayName = "BitbucketSnippetsIcon", exports.default = _class;
}, /* 42 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _extends2 = __webpack_require__(19), _extends3 = _interopRequireDefault(_extends2), _getPrototypeOf = __webpack_require__(4), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(5), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(6), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(7), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(8), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(9), _react2 = _interopRequireDefault(_react), _Icon2 = __webpack_require__(2), _Icon3 = _interopRequireDefault(_Icon2), _class = function(_Icon) {
        function _class() {
            return (0, _classCallCheck3.default)(this, _class), (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, 
            _getPrototypeOf2.default)(_class)).apply(this, arguments));
        }
        return (0, _inherits3.default)(_class, _Icon), (0, _createClass3.default)(_class, [ {
            key: "getGlyphTemplate",
            value: function() {
                return function(props) {
                    var title = props.label, iconProps = (0, _extends3.default)({}, props);
                    // eslint-disable-next-line max-len, react/jsx-space-before-closing
                    return delete iconProps.label, _react2.default.createElement("svg", (0, _extends3.default)({
                        width: "16",
                        height: "20",
                        viewBox: "2 0 16 20",
                        focusable: "false"
                    }, iconProps, {
                        "aria-labelledby": "title-t5ofy9o"
                    }), _react2.default.createElement("title", {
                        id: "title-t5ofy9o"
                    }, title), _react2.default.createElement("path", {
                        d: "M6 9c-.2 0-.5-.1-.7-.3L2.4 5.8c-.4-.4-.4-1.1 0-1.6l3-3c.4-.4 1-.4 1.4 0 .4.4.4 1 0 1.4L4.4 5l2.3 2.3c.4.4.4 1 0 1.4-.2.2-.4.3-.7.3zm-.5 10c-.2 0-.3 0-.5-.1-.5-.3-.7-.9-.4-1.4l8.5-16c.3-.5.9-.6 1.4-.4.5.3.6.9.4 1.4l-8.5 16c-.2.3-.5.5-.9.5zm7.7-8c.3 0 .5.1.7.3l2.9 2.9c.4.4.4 1.1 0 1.6l-3 3c-.4.4-1 .4-1.4 0-.4-.4-.4-1 0-1.4l2.3-2.3-2.3-2.3c-.4-.4-.4-1 0-1.4.3-.3.6-.4.8-.4z",
                        fill: "currentColor",
                        fillRule: "evenodd",
                        role: "presentation"
                    }));
                };
            }
        } ]), _class;
    }(_Icon3.default);
    _class.displayName = "BitbucketSourceIcon", exports.default = _class;
}, /* 43 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _extends2 = __webpack_require__(19), _extends3 = _interopRequireDefault(_extends2), _getPrototypeOf = __webpack_require__(4), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(5), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(6), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(7), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(8), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(9), _react2 = _interopRequireDefault(_react), _Icon2 = __webpack_require__(2), _Icon3 = _interopRequireDefault(_Icon2), _class = function(_Icon) {
        function _class() {
            return (0, _classCallCheck3.default)(this, _class), (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, 
            _getPrototypeOf2.default)(_class)).apply(this, arguments));
        }
        return (0, _inherits3.default)(_class, _Icon), (0, _createClass3.default)(_class, [ {
            key: "getGlyphTemplate",
            value: function() {
                return function(props) {
                    var title = props.label, iconProps = (0, _extends3.default)({}, props);
                    // eslint-disable-next-line max-len, react/jsx-space-before-closing
                    return delete iconProps.label, _react2.default.createElement("svg", (0, _extends3.default)({
                        width: "18",
                        height: "18",
                        viewBox: "0 0 18 18",
                        focusable: "false"
                    }, iconProps, {
                        "aria-labelledby": "title-b9qr4ie"
                    }), _react2.default.createElement("title", {
                        id: "title-b9qr4ie"
                    }, title), _react2.default.createElement("g", {
                        fill: "currentColor",
                        fillRule: "evenodd"
                    }, _react2.default.createElement("path", {
                        d: "M16 15a5.44 5.44 0 0 1-6 .05V12.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 .5.5V15zm-.5-5h-5A2.5 2.5 0 0 0 8 12.5V16a7.52 7.52 0 0 0 5 2 7.54 7.54 0 0 0 5-2.07V12.5a2.5 2.5 0 0 0-2.5-2.5zM13 5a1 1 0 1 1 0 2 1 1 0 0 1 0-2m0 4a3 3 0 1 0 0-6 3 3 0 0 0 0 6M5 2a1 1 0 1 1 0 2 1 1 0 0 1 0-2m0 4a3 3 0 1 0 0-6 3 3 0 0 0 0 6",
                        role: "presentation"
                    }), _react2.default.createElement("path", {
                        d: "M7.5 7h-5A2.5 2.5 0 0 0 0 9.5v2.35a7.63 7.63 0 0 0 5 2.09 7.42 7.42 0 0 0 2-.29v-2.12a5.36 5.36 0 0 1-5-.46V9.5a.5.5 0 0 1 .5-.5h7.45A2.5 2.5 0 0 0 7.5 7",
                        role: "presentation"
                    })));
                };
            }
        } ]), _class;
    }(_Icon3.default);
    _class.displayName = "BitbucketTeamsIcon", exports.default = _class;
}, /* 44 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _extends2 = __webpack_require__(19), _extends3 = _interopRequireDefault(_extends2), _getPrototypeOf = __webpack_require__(4), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(5), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(6), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(7), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(8), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(9), _react2 = _interopRequireDefault(_react), _Icon2 = __webpack_require__(2), _Icon3 = _interopRequireDefault(_Icon2), _class = function(_Icon) {
        function _class() {
            return (0, _classCallCheck3.default)(this, _class), (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, 
            _getPrototypeOf2.default)(_class)).apply(this, arguments));
        }
        return (0, _inherits3.default)(_class, _Icon), (0, _createClass3.default)(_class, [ {
            key: "getGlyphTemplate",
            value: function() {
                return function(props) {
                    var title = props.label, iconProps = (0, _extends3.default)({}, props);
                    // eslint-disable-next-line max-len, react/jsx-space-before-closing
                    return delete iconProps.label, _react2.default.createElement("svg", (0, _extends3.default)({
                        width: "22",
                        height: "22",
                        viewBox: "-1 -1 22 22",
                        focusable: "false"
                    }, iconProps, {
                        "aria-labelledby": "title-qbpb58r"
                    }), _react2.default.createElement("title", {
                        id: "title-qbpb58r"
                    }, title), _react2.default.createElement("path", {
                        d: "M15 8v9H5V3h6v2.5c0 .8.7 1.5 1.5 1.5H17v-.5c0-.3-.1-.6-.4-.8l-5.1-4.2c-.3-.3-.8-.5-1.2-.5H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V8h-2z",
                        fill: "currentColor",
                        fillRule: "evenodd",
                        role: "presentation"
                    }));
                };
            }
        } ]), _class;
    }(_Icon3.default);
    _class.displayName = "BitbucketWikiIcon", exports.default = _class;
}, /* 45 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _extends2 = __webpack_require__(19), _extends3 = _interopRequireDefault(_extends2), _getPrototypeOf = __webpack_require__(4), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(5), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(6), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(7), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(8), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(9), _react2 = _interopRequireDefault(_react), _Icon2 = __webpack_require__(2), _Icon3 = _interopRequireDefault(_Icon2), _class = function(_Icon) {
        function _class() {
            return (0, _classCallCheck3.default)(this, _class), (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, 
            _getPrototypeOf2.default)(_class)).apply(this, arguments));
        }
        return (0, _inherits3.default)(_class, _Icon), (0, _createClass3.default)(_class, [ {
            key: "getGlyphTemplate",
            value: function() {
                return function(props) {
                    var title = props.label, iconProps = (0, _extends3.default)({}, props);
                    // eslint-disable-next-line max-len, react/jsx-space-before-closing
                    return delete iconProps.label, _react2.default.createElement("svg", (0, _extends3.default)({
                        width: "20",
                        height: "20",
                        viewBox: "0 0 20 20",
                        focusable: "false"
                    }, iconProps, {
                        "aria-labelledby": "title-n6xroej"
                    }), _react2.default.createElement("title", {
                        id: "title-n6xroej"
                    }, title), _react2.default.createElement("path", {
                        d: "M13.364 11.95a.999.999 0 1 1-1.415 1.413l-2.12-2.12-2.123 2.12a.997.997 0 0 1-1.413 0 1 1 0 0 1 0-1.414l2.12-2.12-2.12-2.122a1 1 0 0 1 1.413-1.414l2.122 2.121 2.122-2.12a.999.999 0 1 1 1.414 1.413l-2.122 2.121 2.121 2.121z",
                        fill: "currentColor",
                        fillRule: "evenodd",
                        role: "presentation"
                    }));
                };
            }
        } ]), _class;
    }(_Icon3.default);
    _class.displayName = "CancelIcon", exports.default = _class;
}, /* 46 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _extends2 = __webpack_require__(19), _extends3 = _interopRequireDefault(_extends2), _getPrototypeOf = __webpack_require__(4), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(5), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(6), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(7), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(8), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(9), _react2 = _interopRequireDefault(_react), _Icon2 = __webpack_require__(2), _Icon3 = _interopRequireDefault(_Icon2), _class = function(_Icon) {
        function _class() {
            return (0, _classCallCheck3.default)(this, _class), (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, 
            _getPrototypeOf2.default)(_class)).apply(this, arguments));
        }
        return (0, _inherits3.default)(_class, _Icon), (0, _createClass3.default)(_class, [ {
            key: "getGlyphTemplate",
            value: function() {
                return function(props) {
                    var title = props.label, iconProps = (0, _extends3.default)({}, props);
                    // eslint-disable-next-line max-len, react/jsx-space-before-closing
                    return delete iconProps.label, _react2.default.createElement("svg", (0, _extends3.default)({
                        width: "12",
                        height: "12",
                        viewBox: "0 0 12 12",
                        focusable: "false"
                    }, iconProps, {
                        "aria-labelledby": "title-8nm9d8m"
                    }), _react2.default.createElement("title", {
                        id: "title-8nm9d8m"
                    }, title), _react2.default.createElement("defs", null, _react2.default.createElement("mask", {
                        id: "a",
                        x: "0",
                        y: "0",
                        width: "12",
                        height: "12",
                        fill: "#fff"
                    }, _react2.default.createElement("use", null))), _react2.default.createElement("rect", {
                        width: "12",
                        height: "12",
                        rx: "2",
                        fill: "currentColor",
                        fillRule: "evenodd",
                        role: "presentation"
                    }), _react2.default.createElement("use", {
                        mask: "url(#a)",
                        strokeWidth: "2"
                    }), _react2.default.createElement("path", {
                        fill: "inherit",
                        d: "M9.374 4.914L5.456 8.832a.769.769 0 0 1-1.088 0L2.626 7.091a.769.769 0 1 1 1.088-1.089L4.912 7.2l3.374-3.374a.769.769 0 1 1 1.088 1.088",
                        role: "presentation"
                    }));
                };
            }
        } ]), _class;
    }(_Icon3.default);
    _class.displayName = "CheckboxIcon", exports.default = _class;
}, /* 47 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _extends2 = __webpack_require__(19), _extends3 = _interopRequireDefault(_extends2), _getPrototypeOf = __webpack_require__(4), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(5), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(6), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(7), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(8), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(9), _react2 = _interopRequireDefault(_react), _Icon2 = __webpack_require__(2), _Icon3 = _interopRequireDefault(_Icon2), _class = function(_Icon) {
        function _class() {
            return (0, _classCallCheck3.default)(this, _class), (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, 
            _getPrototypeOf2.default)(_class)).apply(this, arguments));
        }
        return (0, _inherits3.default)(_class, _Icon), (0, _createClass3.default)(_class, [ {
            key: "getGlyphTemplate",
            value: function() {
                return function(props) {
                    var title = props.label, iconProps = (0, _extends3.default)({}, props);
                    // eslint-disable-next-line max-len, react/jsx-space-before-closing
                    return delete iconProps.label, _react2.default.createElement("svg", (0, _extends3.default)({
                        width: "20",
                        height: "20",
                        viewBox: "0 0 20 20",
                        focusable: "false"
                    }, iconProps, {
                        "aria-labelledby": "title-a34bis5"
                    }), _react2.default.createElement("title", {
                        id: "title-a34bis5"
                    }, title), _react2.default.createElement("path", {
                        d: "M15.061 7.707l-5.09 5.091a.999.999 0 0 1-1.415 0l-2.263-2.263a.999.999 0 1 1 1.414-1.414l1.556 1.556 4.384-4.384a.999.999 0 1 1 1.414 1.414",
                        fill: "currentColor",
                        fillRule: "evenodd",
                        role: "presentation"
                    }));
                };
            }
        } ]), _class;
    }(_Icon3.default);
    _class.displayName = "ConfirmIcon", exports.default = _class;
}, /* 48 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _extends2 = __webpack_require__(19), _extends3 = _interopRequireDefault(_extends2), _getPrototypeOf = __webpack_require__(4), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(5), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(6), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(7), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(8), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(9), _react2 = _interopRequireDefault(_react), _Icon2 = __webpack_require__(2), _Icon3 = _interopRequireDefault(_Icon2), _class = function(_Icon) {
        function _class() {
            return (0, _classCallCheck3.default)(this, _class), (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, 
            _getPrototypeOf2.default)(_class)).apply(this, arguments));
        }
        return (0, _inherits3.default)(_class, _Icon), (0, _createClass3.default)(_class, [ {
            key: "getGlyphTemplate",
            value: function() {
                return function(props) {
                    var title = props.label, iconProps = (0, _extends3.default)({}, props);
                    // eslint-disable-next-line max-len, react/jsx-space-before-closing
                    return delete iconProps.label, _react2.default.createElement("svg", (0, _extends3.default)({
                        width: "20",
                        height: "20",
                        viewBox: "31 364 18 18",
                        focusable: "false"
                    }, iconProps, {
                        "aria-labelledby": "title-ue69a13"
                    }), _react2.default.createElement("title", {
                        id: "title-ue69a13"
                    }, title), _react2.default.createElement("path", {
                        fill: "currentColor",
                        d: "M47 366h-1v2h-3v-2h-6v2h-3v-2h-1c-1.101 0-2 .9-2 2v12c0 1.1.899 2 2 2h14c1.1 0 2-.9 2-2v-12c0-1.1-.9-2-2-2zm0 14H33v-8h14v8zm-10.5-16h-2v3.5h2V364zm9 0h-2v3.5h2V364z",
                        fillRule: "evenodd",
                        role: "presentation"
                    }));
                };
            }
        } ]), _class;
    }(_Icon3.default);
    _class.displayName = "ConfluenceCalendarIcon", exports.default = _class;
}, /* 49 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _extends2 = __webpack_require__(19), _extends3 = _interopRequireDefault(_extends2), _getPrototypeOf = __webpack_require__(4), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(5), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(6), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(7), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(8), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(9), _react2 = _interopRequireDefault(_react), _Icon2 = __webpack_require__(2), _Icon3 = _interopRequireDefault(_Icon2), _class = function(_Icon) {
        function _class() {
            return (0, _classCallCheck3.default)(this, _class), (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, 
            _getPrototypeOf2.default)(_class)).apply(this, arguments));
        }
        return (0, _inherits3.default)(_class, _Icon), (0, _createClass3.default)(_class, [ {
            key: "getGlyphTemplate",
            value: function() {
                return function(props) {
                    var title = props.label, iconProps = (0, _extends3.default)({}, props);
                    // eslint-disable-next-line max-len, react/jsx-space-before-closing
                    return delete iconProps.label, _react2.default.createElement("svg", (0, _extends3.default)({
                        width: "20",
                        height: "20",
                        viewBox: "31 324 19 17",
                        focusable: "false"
                    }, iconProps, {
                        "aria-labelledby": "title-wynbe60"
                    }), _react2.default.createElement("title", {
                        id: "title-wynbe60"
                    }, title), _react2.default.createElement("path", {
                        fill: "currentColor",
                        d: "M45.94 324.71c-3.528-1.187-7.066-.962-10.72 1.273-2.853 1.743-4.718 6.076-4.103 9.182.728 3.671 4.351 5.995 9.243 4.651 5.275-1.449 6.55-4.546 6.38-5.334-.17-.788-2.666-1.652-1.719-3.498 1.188-2.313 3.13-1.149 3.982-1.622.855-.472.54-3.442-3.063-4.653zm-3.646 10.705a1.504 1.504 0 0 1-1.843-1.059 1.5 1.5 0 0 1 1.046-1.849 1.503 1.503 0 0 1 1.843 1.06 1.501 1.501 0 0 1-1.046 1.848z",
                        fillRule: "evenodd",
                        role: "presentation"
                    }));
                };
            }
        } ]), _class;
    }(_Icon3.default);
    _class.displayName = "ConfluenceCanvasIcon", exports.default = _class;
}, /* 50 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _extends2 = __webpack_require__(19), _extends3 = _interopRequireDefault(_extends2), _getPrototypeOf = __webpack_require__(4), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(5), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(6), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(7), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(8), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(9), _react2 = _interopRequireDefault(_react), _Icon2 = __webpack_require__(2), _Icon3 = _interopRequireDefault(_Icon2), _class = function(_Icon) {
        function _class() {
            return (0, _classCallCheck3.default)(this, _class), (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, 
            _getPrototypeOf2.default)(_class)).apply(this, arguments));
        }
        return (0, _inherits3.default)(_class, _Icon), (0, _createClass3.default)(_class, [ {
            key: "getGlyphTemplate",
            value: function() {
                return function(props) {
                    var title = props.label, iconProps = (0, _extends3.default)({}, props);
                    // eslint-disable-next-line max-len, react/jsx-space-before-closing
                    return delete iconProps.label, _react2.default.createElement("svg", (0, _extends3.default)({
                        width: "20",
                        height: "20",
                        viewBox: "33 203 14 18",
                        focusable: "false"
                    }, iconProps, {
                        "aria-labelledby": "title-k57rfq6"
                    }), _react2.default.createElement("title", {
                        id: "title-k57rfq6"
                    }, title), _react2.default.createElement("g", {
                        transform: "translate(33 203)"
                    }, _react2.default.createElement("mask", {
                        id: "a"
                    }, _react2.default.createElement("rect", {
                        width: "100%",
                        height: "100%",
                        fill: "#fff",
                        role: "presentation"
                    }), _react2.default.createElement("rect", {
                        x: "2",
                        y: "3",
                        width: "6",
                        height: "2",
                        rx: ".5",
                        role: "presentation"
                    }), _react2.default.createElement("rect", {
                        x: "2",
                        y: "7",
                        width: "10",
                        height: "2",
                        rx: ".5",
                        fillOpacity: ".5",
                        role: "presentation"
                    }), _react2.default.createElement("rect", {
                        x: "2",
                        y: "10",
                        width: "10",
                        height: "2",
                        rx: ".5",
                        fillOpacity: ".5",
                        role: "presentation"
                    }), _react2.default.createElement("rect", {
                        x: "2",
                        y: "13",
                        width: "10",
                        height: "2",
                        rx: ".5",
                        fillOpacity: ".5",
                        role: "presentation"
                    })), _react2.default.createElement("rect", {
                        fill: "currentColor",
                        width: "14",
                        height: "18",
                        rx: "2",
                        mask: "url(#a)",
                        role: "presentation"
                    })));
                };
            }
        } ]), _class;
    }(_Icon3.default);
    _class.displayName = "ConfluencePageIcon", exports.default = _class;
}, /* 51 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _extends2 = __webpack_require__(19), _extends3 = _interopRequireDefault(_extends2), _getPrototypeOf = __webpack_require__(4), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(5), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(6), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(7), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(8), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(9), _react2 = _interopRequireDefault(_react), _Icon2 = __webpack_require__(2), _Icon3 = _interopRequireDefault(_Icon2), _class = function(_Icon) {
        function _class() {
            return (0, _classCallCheck3.default)(this, _class), (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, 
            _getPrototypeOf2.default)(_class)).apply(this, arguments));
        }
        return (0, _inherits3.default)(_class, _Icon), (0, _createClass3.default)(_class, [ {
            key: "getGlyphTemplate",
            value: function() {
                return function(props) {
                    var title = props.label, iconProps = (0, _extends3.default)({}, props);
                    // eslint-disable-next-line max-len, react/jsx-space-before-closing
                    return delete iconProps.label, _react2.default.createElement("svg", (0, _extends3.default)({
                        width: "20",
                        height: "20",
                        viewBox: "0 0 20 20",
                        focusable: "false"
                    }, iconProps, {
                        "aria-labelledby": "title-39fah16"
                    }), _react2.default.createElement("title", {
                        id: "title-39fah16"
                    }, title), _react2.default.createElement("g", {
                        fill: "currentColor",
                        fillRule: "evenodd"
                    }, _react2.default.createElement("path", {
                        d: "M10 20c5.523 0 10-4.477 10-10S15.523 0 10 0 0 4.477 0 10s4.477 10 10 10z",
                        fillOpacity: ".2",
                        role: "presentation"
                    }), _react2.default.createElement("path", {
                        d: "M17.022 17.12A9.968 9.968 0 0 1 10 20a9.968 9.968 0 0 1-7.022-2.88c.708-.455 1.533-.842 2.348-1.193 2.123-.914 2.803-1.685 2.803-3.334 0-.99-.649-.667-.933-2.481-.118-.753-.692-.012-.801-1.729 0-.684.313-.854.313-.854s-.158-1.014-.222-1.793c-.05-.637.223-1.834 1.239-2.59 1.193-.862 3.155-.845 3.488-.505 1.902.535 2.365 2.279 2.3 3.096a29.717 29.717 0 0 1-.221 1.793s.314.17.314.854c-.111 1.717-.684.976-.803 1.729-.285 1.814-.932 1.491-.932 2.481 0 1.65.678 2.42 2.801 3.334.816.351 1.642.737 2.35 1.192z",
                        role: "presentation"
                    })));
                };
            }
        } ]), _class;
    }(_Icon3.default);
    _class.displayName = "ConfluencePersonIcon", exports.default = _class;
}, /* 52 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _extends2 = __webpack_require__(19), _extends3 = _interopRequireDefault(_extends2), _getPrototypeOf = __webpack_require__(4), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(5), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(6), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(7), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(8), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(9), _react2 = _interopRequireDefault(_react), _Icon2 = __webpack_require__(2), _Icon3 = _interopRequireDefault(_Icon2), _class = function(_Icon) {
        function _class() {
            return (0, _classCallCheck3.default)(this, _class), (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, 
            _getPrototypeOf2.default)(_class)).apply(this, arguments));
        }
        return (0, _inherits3.default)(_class, _Icon), (0, _createClass3.default)(_class, [ {
            key: "getGlyphTemplate",
            value: function() {
                return function(props) {
                    var title = props.label, iconProps = (0, _extends3.default)({}, props);
                    // eslint-disable-next-line max-len, react/jsx-space-before-closing
                    return delete iconProps.label, _react2.default.createElement("svg", (0, _extends3.default)({
                        width: "20",
                        height: "20",
                        viewBox: "32 244 16 14",
                        focusable: "false"
                    }, iconProps, {
                        "aria-labelledby": "title-clnj27x"
                    }), _react2.default.createElement("title", {
                        id: "title-clnj27x"
                    }, title), _react2.default.createElement("path", {
                        d: "M35.315 244.401c-1.61 0-2.916 1.343-2.916 3 0 1.656 1.306 3 2.916 3 2.915 0 .972 5.799-2.916 5.799v1.4c6.939.001 9.658-13.199 2.916-13.199zm8.4 0c-1.609 0-2.915 1.343-2.915 3 0 1.656 1.306 3 2.915 3 2.916 0 .973 5.799-2.915 5.799v1.4c6.938.001 9.657-13.199 2.915-13.199z",
                        fill: "currentColor",
                        fillRule: "evenodd",
                        role: "presentation"
                    }));
                };
            }
        } ]), _class;
    }(_Icon3.default);
    _class.displayName = "ConfluenceQuoteIcon", exports.default = _class;
}, /* 53 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _extends2 = __webpack_require__(19), _extends3 = _interopRequireDefault(_extends2), _getPrototypeOf = __webpack_require__(4), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(5), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(6), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(7), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(8), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(9), _react2 = _interopRequireDefault(_react), _Icon2 = __webpack_require__(2), _Icon3 = _interopRequireDefault(_Icon2), _class = function(_Icon) {
        function _class() {
            return (0, _classCallCheck3.default)(this, _class), (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, 
            _getPrototypeOf2.default)(_class)).apply(this, arguments));
        }
        return (0, _inherits3.default)(_class, _Icon), (0, _createClass3.default)(_class, [ {
            key: "getGlyphTemplate",
            value: function() {
                return function(props) {
                    var title = props.label, iconProps = (0, _extends3.default)({}, props);
                    // eslint-disable-next-line max-len, react/jsx-space-before-closing
                    return delete iconProps.label, _react2.default.createElement("svg", (0, _extends3.default)({
                        width: "16",
                        height: "16",
                        viewBox: "7 7 16 16",
                        focusable: "false"
                    }, iconProps, {
                        "aria-labelledby": "title-1fcto4p"
                    }), _react2.default.createElement("title", {
                        id: "title-1fcto4p"
                    }, title), _react2.default.createElement("g", {
                        fill: "currentColor",
                        transform: "translate(7 7)",
                        fillRule: "evenodd"
                    }, _react2.default.createElement("rect", {
                        x: "7",
                        width: "2",
                        height: "16",
                        rx: "1",
                        role: "presentation"
                    }), _react2.default.createElement("rect", {
                        y: "7",
                        width: "16",
                        height: "2",
                        rx: "1",
                        role: "presentation"
                    })));
                };
            }
        } ]), _class;
    }(_Icon3.default);
    _class.displayName = "CreateIcon", exports.default = _class;
}, /* 54 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _extends2 = __webpack_require__(19), _extends3 = _interopRequireDefault(_extends2), _getPrototypeOf = __webpack_require__(4), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(5), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(6), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(7), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(8), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(9), _react2 = _interopRequireDefault(_react), _Icon2 = __webpack_require__(2), _Icon3 = _interopRequireDefault(_Icon2), _class = function(_Icon) {
        function _class() {
            return (0, _classCallCheck3.default)(this, _class), (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, 
            _getPrototypeOf2.default)(_class)).apply(this, arguments));
        }
        return (0, _inherits3.default)(_class, _Icon), (0, _createClass3.default)(_class, [ {
            key: "getGlyphTemplate",
            value: function() {
                return function(props) {
                    var title = props.label, iconProps = (0, _extends3.default)({}, props);
                    // eslint-disable-next-line max-len, react/jsx-space-before-closing
                    return delete iconProps.label, _react2.default.createElement("svg", (0, _extends3.default)({
                        width: "18",
                        height: "18",
                        viewBox: "32 12 18 18",
                        focusable: "false"
                    }, iconProps, {
                        "aria-labelledby": "title-ndlxcqj"
                    }), _react2.default.createElement("title", {
                        id: "title-ndlxcqj"
                    }, title), _react2.default.createElement("path", {
                        d: "M48 12H33.99c-1.11 0-1.98.89-1.98 2L32 28c0 1.1.88 2 1.99 2H48c1.1 0 2-.9 2-2V14a2 2 0 0 0-2-2zm-4 12c0 2-1.01 3-3.005 3C39 27 38 26 38 24h-4.01V14H48v10h-4zm-8-4h10v2H36v-2zm0-4h10v2H36v-2z",
                        fill: "currentColor",
                        fillRule: "evenodd",
                        role: "presentation"
                    }));
                };
            }
        } ]), _class;
    }(_Icon3.default);
    _class.displayName = "DashboardIcon", exports.default = _class;
}, /* 55 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _extends2 = __webpack_require__(19), _extends3 = _interopRequireDefault(_extends2), _getPrototypeOf = __webpack_require__(4), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(5), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(6), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(7), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(8), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(9), _react2 = _interopRequireDefault(_react), _Icon2 = __webpack_require__(2), _Icon3 = _interopRequireDefault(_Icon2), _class = function(_Icon) {
        function _class() {
            return (0, _classCallCheck3.default)(this, _class), (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, 
            _getPrototypeOf2.default)(_class)).apply(this, arguments));
        }
        return (0, _inherits3.default)(_class, _Icon), (0, _createClass3.default)(_class, [ {
            key: "getGlyphTemplate",
            value: function() {
                return function(props) {
                    var title = props.label, iconProps = (0, _extends3.default)({}, props);
                    // eslint-disable-next-line max-len, react/jsx-space-before-closing
                    return delete iconProps.label, _react2.default.createElement("svg", (0, _extends3.default)({
                        width: "20",
                        height: "20",
                        viewBox: "0 0 20 20",
                        focusable: "false"
                    }, iconProps, {
                        "aria-labelledby": "title-auaelpa"
                    }), _react2.default.createElement("title", {
                        id: "title-auaelpa"
                    }, title), _react2.default.createElement("path", {
                        d: "M2.02 17.23a1 1 0 0 0 1.18 1.18l3.81-.78-4.21-4.21-.78 3.81zM17.844 4.707l-2.12-2.12A1.994 1.994 0 0 0 14.307 2c-.51 0-1.023.195-1.414.586l-9.757 9.757 4.95 4.95 9.757-9.758a2 2 0 0 0 0-2.828",
                        fill: "currentColor",
                        fillRule: "evenodd",
                        role: "presentation"
                    }));
                };
            }
        } ]), _class;
    }(_Icon3.default);
    _class.displayName = "EditIcon", exports.default = _class;
}, /* 56 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _extends2 = __webpack_require__(19), _extends3 = _interopRequireDefault(_extends2), _getPrototypeOf = __webpack_require__(4), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(5), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(6), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(7), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(8), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(9), _react2 = _interopRequireDefault(_react), _Icon2 = __webpack_require__(2), _Icon3 = _interopRequireDefault(_Icon2), _class = function(_Icon) {
        function _class() {
            return (0, _classCallCheck3.default)(this, _class), (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, 
            _getPrototypeOf2.default)(_class)).apply(this, arguments));
        }
        return (0, _inherits3.default)(_class, _Icon), (0, _createClass3.default)(_class, [ {
            key: "getGlyphTemplate",
            value: function() {
                return function(props) {
                    var title = props.label, iconProps = (0, _extends3.default)({}, props);
                    // eslint-disable-next-line max-len, react/jsx-space-before-closing
                    return delete iconProps.label, _react2.default.createElement("svg", (0, _extends3.default)({
                        width: "24",
                        height: "24",
                        viewBox: "0 0 24 24",
                        focusable: "false"
                    }, iconProps, {
                        "aria-labelledby": "title-om5hhyc"
                    }), _react2.default.createElement("title", {
                        id: "title-om5hhyc"
                    }, title), _react2.default.createElement("path", {
                        d: "M13 11V6.5c0-.271-.226-.5-.505-.5h-.99a.495.495 0 0 0-.505.5V11H6.5c-.271 0-.5.226-.5.505v.99c0 .291.224.505.5.505H11v4.5c0 .271.226.5.505.5h.99a.495.495 0 0 0 .505-.5V13h4.5c.271 0 .5-.226.5-.505v-.99a.495.495 0 0 0-.5-.505H13z",
                        fill: "currentColor",
                        fillRule: "evenodd",
                        role: "presentation"
                    }));
                };
            }
        } ]), _class;
    }(_Icon3.default);
    _class.displayName = "EditorAddIcon", exports.default = _class;
}, /* 57 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _extends2 = __webpack_require__(19), _extends3 = _interopRequireDefault(_extends2), _getPrototypeOf = __webpack_require__(4), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(5), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(6), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(7), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(8), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(9), _react2 = _interopRequireDefault(_react), _Icon2 = __webpack_require__(2), _Icon3 = _interopRequireDefault(_Icon2), _class = function(_Icon) {
        function _class() {
            return (0, _classCallCheck3.default)(this, _class), (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, 
            _getPrototypeOf2.default)(_class)).apply(this, arguments));
        }
        return (0, _inherits3.default)(_class, _Icon), (0, _createClass3.default)(_class, [ {
            key: "getGlyphTemplate",
            value: function() {
                return function(props) {
                    var title = props.label, iconProps = (0, _extends3.default)({}, props);
                    // eslint-disable-next-line max-len, react/jsx-space-before-closing
                    return delete iconProps.label, _react2.default.createElement("svg", (0, _extends3.default)({
                        width: "24",
                        height: "24",
                        viewBox: "0 0 24 24",
                        focusable: "false"
                    }, iconProps, {
                        "aria-labelledby": "title-q7xlxup"
                    }), _react2.default.createElement("title", {
                        id: "title-q7xlxup"
                    }, title), _react2.default.createElement("path", {
                        d: "M8.691 14.932c-.184.546-.336.797-.719 1.011-.851.478-1.54.299-2.033-.532-.498-.837-.31-1.52.547-2 .388-.218.673-.217 1.251-.1.078.017.139.029.19.038l-1.434-2.414a.333.333 0 0 1 .123-.461L8.64 9.339a.333.333 0 0 1 .49.222c.023.113.065.22.127.325.439.737 1.006.885 1.769.457.757-.425.906-.962.47-1.694a1.075 1.075 0 0 0-.226-.271.333.333 0 0 1 .054-.544l2.023-1.135a.333.333 0 0 1 .45.12l1.447 2.437c.019-.05.04-.11.066-.187.184-.546.336-.797.719-1.012.851-.477 1.54-.298 2.033.533.498.837.31 1.52-.547 2-.26.146-.521.193-.816.169a3.345 3.345 0 0 1-.435-.07 7.374 7.374 0 0 0-.19-.037l1.434 2.413c.095.16.04.369-.124.46l-2.11 1.184a.333.333 0 0 1-.496-.28 1.03 1.03 0 0 0-.15-.51c-.438-.738-1.005-.886-1.768-.458-.758.425-.906.963-.471 1.694.1.168.225.29.384.386a.333.333 0 0 1-.009.576l-2.11 1.184a.333.333 0 0 1-.449-.12l-1.447-2.436c-.019.05-.04.11-.066.187z",
                        fill: "currentColor",
                        fillRule: "evenodd",
                        role: "presentation"
                    }));
                };
            }
        } ]), _class;
    }(_Icon3.default);
    _class.displayName = "EditorAddonIcon", exports.default = _class;
}, /* 58 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _extends2 = __webpack_require__(19), _extends3 = _interopRequireDefault(_extends2), _getPrototypeOf = __webpack_require__(4), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(5), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(6), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(7), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(8), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(9), _react2 = _interopRequireDefault(_react), _Icon2 = __webpack_require__(2), _Icon3 = _interopRequireDefault(_Icon2), _class = function(_Icon) {
        function _class() {
            return (0, _classCallCheck3.default)(this, _class), (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, 
            _getPrototypeOf2.default)(_class)).apply(this, arguments));
        }
        return (0, _inherits3.default)(_class, _Icon), (0, _createClass3.default)(_class, [ {
            key: "getGlyphTemplate",
            value: function() {
                return function(props) {
                    var title = props.label, iconProps = (0, _extends3.default)({}, props);
                    // eslint-disable-next-line max-len, react/jsx-space-before-closing
                    return delete iconProps.label, _react2.default.createElement("svg", (0, _extends3.default)({
                        width: "24",
                        height: "24",
                        viewBox: "0 0 24 24",
                        focusable: "false"
                    }, iconProps, {
                        "aria-labelledby": "title-cnmp6cv"
                    }), _react2.default.createElement("title", {
                        id: "title-cnmp6cv"
                    }, title), _react2.default.createElement("path", {
                        d: "M14.2 17l.8 2h2l-.763-2H14.2zm.893-3l-1.907-5h-2.372l-1.907 5h1.926L12 10.5l1.167 3.5h1.926zm-7.33 3L7 19h2l.8-2H7.763zM5 15h14v1H5v-1zM18 5h-3v4h3V8h-2V6h2V5zm0 1h1v2h-1V6z",
                        fill: "currentColor",
                        fillRule: "evenodd",
                        role: "presentation"
                    }));
                };
            }
        } ]), _class;
    }(_Icon3.default);
    _class.displayName = "EditorAdvancedIcon", exports.default = _class;
}, /* 59 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _extends2 = __webpack_require__(19), _extends3 = _interopRequireDefault(_extends2), _getPrototypeOf = __webpack_require__(4), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(5), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(6), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(7), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(8), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(9), _react2 = _interopRequireDefault(_react), _Icon2 = __webpack_require__(2), _Icon3 = _interopRequireDefault(_Icon2), _class = function(_Icon) {
        function _class() {
            return (0, _classCallCheck3.default)(this, _class), (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, 
            _getPrototypeOf2.default)(_class)).apply(this, arguments));
        }
        return (0, _inherits3.default)(_class, _Icon), (0, _createClass3.default)(_class, [ {
            key: "getGlyphTemplate",
            value: function() {
                return function(props) {
                    var title = props.label, iconProps = (0, _extends3.default)({}, props);
                    // eslint-disable-next-line max-len, react/jsx-space-before-closing
                    return delete iconProps.label, _react2.default.createElement("svg", (0, _extends3.default)({
                        width: "24",
                        height: "24",
                        viewBox: "0 0 24 24",
                        focusable: "false"
                    }, iconProps, {
                        "aria-labelledby": "title-usrwk5n"
                    }), _react2.default.createElement("title", {
                        id: "title-usrwk5n"
                    }, title), _react2.default.createElement("path", {
                        d: "M9 7.505C9 7.226 9.228 7 9.491 7h5.018a.49.49 0 0 1 .491.505v.99a.503.503 0 0 1-.491.505H9.491A.49.49 0 0 1 9 8.495v-.99zm-3 4c0-.279.229-.505.5-.505h11c.276 0 .5.214.5.505v.99a.506.506 0 0 1-.5.505h-11a.495.495 0 0 1-.5-.505v-.99zm3 4c0-.279.228-.505.491-.505h5.018a.49.49 0 0 1 .491.505v.99a.503.503 0 0 1-.491.505H9.491A.49.49 0 0 1 9 16.495v-.99z",
                        fill: "currentColor",
                        fillRule: "evenodd",
                        role: "presentation"
                    }));
                };
            }
        } ]), _class;
    }(_Icon3.default);
    _class.displayName = "EditorAlignCenterIcon", exports.default = _class;
}, /* 60 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _extends2 = __webpack_require__(19), _extends3 = _interopRequireDefault(_extends2), _getPrototypeOf = __webpack_require__(4), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(5), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(6), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(7), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(8), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(9), _react2 = _interopRequireDefault(_react), _Icon2 = __webpack_require__(2), _Icon3 = _interopRequireDefault(_Icon2), _class = function(_Icon) {
        function _class() {
            return (0, _classCallCheck3.default)(this, _class), (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, 
            _getPrototypeOf2.default)(_class)).apply(this, arguments));
        }
        return (0, _inherits3.default)(_class, _Icon), (0, _createClass3.default)(_class, [ {
            key: "getGlyphTemplate",
            value: function() {
                return function(props) {
                    var title = props.label, iconProps = (0, _extends3.default)({}, props);
                    // eslint-disable-next-line max-len, react/jsx-space-before-closing
                    return delete iconProps.label, _react2.default.createElement("svg", (0, _extends3.default)({
                        width: "24",
                        height: "24",
                        viewBox: "0 0 24 24",
                        focusable: "false"
                    }, iconProps, {
                        "aria-labelledby": "title-yafvm44"
                    }), _react2.default.createElement("title", {
                        id: "title-yafvm44"
                    }, title), _react2.default.createElement("path", {
                        d: "M6 7.505C6 7.226 6.229 7 6.5 7h11c.276 0 .5.214.5.505v.99a.506.506 0 0 1-.5.505h-11a.495.495 0 0 1-.5-.505v-.99zm0 4c0-.279.229-.505.5-.505h11c.276 0 .5.214.5.505v.99a.506.506 0 0 1-.5.505h-11a.495.495 0 0 1-.5-.505v-.99zm0 4c0-.279.228-.505.491-.505h5.018a.49.49 0 0 1 .491.505v.99a.503.503 0 0 1-.491.505H6.491A.49.49 0 0 1 6 16.495v-.99z",
                        fill: "currentColor",
                        fillRule: "evenodd",
                        role: "presentation"
                    }));
                };
            }
        } ]), _class;
    }(_Icon3.default);
    _class.displayName = "EditorAlignLeftIcon", exports.default = _class;
}, /* 61 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _extends2 = __webpack_require__(19), _extends3 = _interopRequireDefault(_extends2), _getPrototypeOf = __webpack_require__(4), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(5), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(6), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(7), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(8), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(9), _react2 = _interopRequireDefault(_react), _Icon2 = __webpack_require__(2), _Icon3 = _interopRequireDefault(_Icon2), _class = function(_Icon) {
        function _class() {
            return (0, _classCallCheck3.default)(this, _class), (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, 
            _getPrototypeOf2.default)(_class)).apply(this, arguments));
        }
        return (0, _inherits3.default)(_class, _Icon), (0, _createClass3.default)(_class, [ {
            key: "getGlyphTemplate",
            value: function() {
                return function(props) {
                    var title = props.label, iconProps = (0, _extends3.default)({}, props);
                    // eslint-disable-next-line max-len, react/jsx-space-before-closing
                    return delete iconProps.label, _react2.default.createElement("svg", (0, _extends3.default)({
                        width: "24",
                        height: "24",
                        viewBox: "0 0 24 24",
                        focusable: "false"
                    }, iconProps, {
                        "aria-labelledby": "title-jmtfyfb"
                    }), _react2.default.createElement("title", {
                        id: "title-jmtfyfb"
                    }, title), _react2.default.createElement("path", {
                        d: "M6 7.505C6 7.226 6.229 7 6.5 7h11c.276 0 .5.214.5.505v.99a.506.506 0 0 1-.5.505h-11a.495.495 0 0 1-.5-.505v-.99zm0 4c0-.279.229-.505.5-.505h11c.276 0 .5.214.5.505v.99a.506.506 0 0 1-.5.505h-11a.495.495 0 0 1-.5-.505v-.99zm6 4c0-.279.228-.505.491-.505h5.018a.49.49 0 0 1 .491.505v.99a.503.503 0 0 1-.491.505h-5.018a.49.49 0 0 1-.491-.505v-.99z",
                        fill: "currentColor",
                        fillRule: "evenodd",
                        role: "presentation"
                    }));
                };
            }
        } ]), _class;
    }(_Icon3.default);
    _class.displayName = "EditorAlignRightIcon", exports.default = _class;
}, /* 62 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _extends2 = __webpack_require__(19), _extends3 = _interopRequireDefault(_extends2), _getPrototypeOf = __webpack_require__(4), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(5), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(6), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(7), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(8), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(9), _react2 = _interopRequireDefault(_react), _Icon2 = __webpack_require__(2), _Icon3 = _interopRequireDefault(_Icon2), _class = function(_Icon) {
        function _class() {
            return (0, _classCallCheck3.default)(this, _class), (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, 
            _getPrototypeOf2.default)(_class)).apply(this, arguments));
        }
        return (0, _inherits3.default)(_class, _Icon), (0, _createClass3.default)(_class, [ {
            key: "getGlyphTemplate",
            value: function() {
                return function(props) {
                    var title = props.label, iconProps = (0, _extends3.default)({}, props);
                    // eslint-disable-next-line max-len, react/jsx-space-before-closing
                    return delete iconProps.label, _react2.default.createElement("svg", (0, _extends3.default)({
                        width: "24",
                        height: "24",
                        viewBox: "0 0 24 24",
                        focusable: "false"
                    }, iconProps, {
                        "aria-labelledby": "title-bi1tmwc"
                    }), _react2.default.createElement("title", {
                        id: "title-bi1tmwc"
                    }, title), _react2.default.createElement("path", {
                        d: "M12.077 17.416a3.005 3.005 0 0 1-4.246.003 3.007 3.007 0 0 1 0-4.243l5.478-5.477a1.745 1.745 0 0 1 2.477-.002c.684.684.685 1.79.002 2.472l-5.136 5.136a.492.492 0 0 1-.7-.007.494.494 0 0 1 0-.707l4.773-4.773a.75.75 0 1 0-1.06-1.06L8.89 13.53a1.994 1.994 0 0 0 0 2.829 1.992 1.992 0 0 0 2.822.007l5.136-5.137a3.247 3.247 0 0 0-.003-4.593 3.245 3.245 0 0 0-4.598.002L6.77 12.115a4.507 4.507 0 0 0-.001 6.365 4.505 4.505 0 0 0 6.367-.003l5.123-5.123a.75.75 0 1 0-1.06-1.061l-5.123 5.123z",
                        fill: "currentColor",
                        fillRule: "evenodd",
                        role: "presentation"
                    }));
                };
            }
        } ]), _class;
    }(_Icon3.default);
    _class.displayName = "EditorAttachmentIcon", exports.default = _class;
}, /* 63 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _extends2 = __webpack_require__(19), _extends3 = _interopRequireDefault(_extends2), _getPrototypeOf = __webpack_require__(4), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(5), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(6), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(7), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(8), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(9), _react2 = _interopRequireDefault(_react), _Icon2 = __webpack_require__(2), _Icon3 = _interopRequireDefault(_Icon2), _class = function(_Icon) {
        function _class() {
            return (0, _classCallCheck3.default)(this, _class), (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, 
            _getPrototypeOf2.default)(_class)).apply(this, arguments));
        }
        return (0, _inherits3.default)(_class, _Icon), (0, _createClass3.default)(_class, [ {
            key: "getGlyphTemplate",
            value: function() {
                return function(props) {
                    var title = props.label, iconProps = (0, _extends3.default)({}, props);
                    // eslint-disable-next-line max-len, react/jsx-space-before-closing
                    return delete iconProps.label, _react2.default.createElement("svg", (0, _extends3.default)({
                        width: "24",
                        height: "24",
                        viewBox: "0 0 24 24",
                        focusable: "false"
                    }, iconProps, {
                        "aria-labelledby": "title-b4jkqx3"
                    }), _react2.default.createElement("title", {
                        id: "title-b4jkqx3"
                    }, title), _react2.default.createElement("path", {
                        d: "M7 6.5c0-.276.221-.5.497-.5h5.335C13.908 6 16 6.5 16 9c0 2-1 2.5-1 2.5s2 .5 2 3c0 .5 0 3.5-4 3.5H7.491A.499.499 0 0 1 7 17.5v-11zM9 16h3.5c1 0 2-.25 2-1.5s-1.104-1.5-2-1.5H9v3zm0-4.975h3c.504 0 2 0 2-1.525S12 8 12 8H9v3.025z",
                        fill: "currentColor",
                        fillRule: "evenodd",
                        role: "presentation"
                    }));
                };
            }
        } ]), _class;
    }(_Icon3.default);
    _class.displayName = "EditorBoldIcon", exports.default = _class;
}, /* 64 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _extends2 = __webpack_require__(19), _extends3 = _interopRequireDefault(_extends2), _getPrototypeOf = __webpack_require__(4), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(5), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(6), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(7), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(8), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(9), _react2 = _interopRequireDefault(_react), _Icon2 = __webpack_require__(2), _Icon3 = _interopRequireDefault(_Icon2), _class = function(_Icon) {
        function _class() {
            return (0, _classCallCheck3.default)(this, _class), (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, 
            _getPrototypeOf2.default)(_class)).apply(this, arguments));
        }
        return (0, _inherits3.default)(_class, _Icon), (0, _createClass3.default)(_class, [ {
            key: "getGlyphTemplate",
            value: function() {
                return function(props) {
                    var title = props.label, iconProps = (0, _extends3.default)({}, props);
                    // eslint-disable-next-line max-len, react/jsx-space-before-closing
                    return delete iconProps.label, _react2.default.createElement("svg", (0, _extends3.default)({
                        width: "24",
                        height: "24",
                        viewBox: "0 0 24 24",
                        focusable: "false"
                    }, iconProps, {
                        "aria-labelledby": "title-0j1ecmw"
                    }), _react2.default.createElement("title", {
                        id: "title-0j1ecmw"
                    }, title), _react2.default.createElement("path", {
                        d: "M6 8c0-.552.444-1 1-1 .552 0 1 .444 1 1 0 .552-.444 1-1 1-.552 0-1-.444-1-1zm4-.495c0-.279.23-.505.5-.505h7c.276 0 .5.214.5.505v.99c0 .279-.23.505-.5.505h-7a.495.495 0 0 1-.5-.505v-.99zM6 12c0-.552.444-1 1-1 .552 0 1 .444 1 1 0 .552-.444 1-1 1-.552 0-1-.444-1-1zm4-.495c0-.279.23-.505.5-.505h7c.276 0 .5.214.5.505v.99c0 .279-.23.505-.5.505h-7a.495.495 0 0 1-.5-.505v-.99zM6 16c0-.552.444-1 1-1 .552 0 1 .444 1 1 0 .552-.444 1-1 1-.552 0-1-.444-1-1zm4-.495c0-.279.23-.505.5-.505h7c.276 0 .5.214.5.505v.99c0 .279-.23.505-.5.505h-7a.495.495 0 0 1-.5-.505v-.99z",
                        fill: "currentColor",
                        fillRule: "evenodd",
                        role: "presentation"
                    }));
                };
            }
        } ]), _class;
    }(_Icon3.default);
    _class.displayName = "EditorBulletListIcon", exports.default = _class;
}, /* 65 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _extends2 = __webpack_require__(19), _extends3 = _interopRequireDefault(_extends2), _getPrototypeOf = __webpack_require__(4), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(5), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(6), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(7), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(8), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(9), _react2 = _interopRequireDefault(_react), _Icon2 = __webpack_require__(2), _Icon3 = _interopRequireDefault(_Icon2), _class = function(_Icon) {
        function _class() {
            return (0, _classCallCheck3.default)(this, _class), (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, 
            _getPrototypeOf2.default)(_class)).apply(this, arguments));
        }
        return (0, _inherits3.default)(_class, _Icon), (0, _createClass3.default)(_class, [ {
            key: "getGlyphTemplate",
            value: function() {
                return function(props) {
                    var title = props.label, iconProps = (0, _extends3.default)({}, props);
                    // eslint-disable-next-line max-len, react/jsx-space-before-closing
                    return delete iconProps.label, _react2.default.createElement("svg", (0, _extends3.default)({
                        width: "24",
                        height: "24",
                        viewBox: "0 0 24 24",
                        focusable: "false"
                    }, iconProps, {
                        "aria-labelledby": "title-kr7je54"
                    }), _react2.default.createElement("title", {
                        id: "title-kr7je54"
                    }, title), _react2.default.createElement("path", {
                        d: "M7.356 10.942a.497.497 0 0 0-.713 0l-.7.701a.501.501 0 0 0-.003.71l3.706 3.707a.501.501 0 0 0 .705.003l7.712-7.712a.493.493 0 0 0-.006-.708l-.7-.7a.504.504 0 0 0-.714 0l-6.286 6.286a.506.506 0 0 1-.713 0l-2.288-2.287z",
                        fill: "currentColor",
                        fillRule: "evenodd",
                        role: "presentation"
                    }));
                };
            }
        } ]), _class;
    }(_Icon3.default);
    _class.displayName = "EditorCheckIcon", exports.default = _class;
}, /* 66 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _extends2 = __webpack_require__(19), _extends3 = _interopRequireDefault(_extends2), _getPrototypeOf = __webpack_require__(4), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(5), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(6), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(7), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(8), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(9), _react2 = _interopRequireDefault(_react), _Icon2 = __webpack_require__(2), _Icon3 = _interopRequireDefault(_Icon2), _class = function(_Icon) {
        function _class() {
            return (0, _classCallCheck3.default)(this, _class), (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, 
            _getPrototypeOf2.default)(_class)).apply(this, arguments));
        }
        return (0, _inherits3.default)(_class, _Icon), (0, _createClass3.default)(_class, [ {
            key: "getGlyphTemplate",
            value: function() {
                return function(props) {
                    var title = props.label, iconProps = (0, _extends3.default)({}, props);
                    // eslint-disable-next-line max-len, react/jsx-space-before-closing
                    return delete iconProps.label, _react2.default.createElement("svg", (0, _extends3.default)({
                        width: "24",
                        height: "24",
                        viewBox: "0 0 24 24",
                        focusable: "false"
                    }, iconProps, {
                        "aria-labelledby": "title-e7fbtdi"
                    }), _react2.default.createElement("title", {
                        id: "title-e7fbtdi"
                    }, title), _react2.default.createElement("path", {
                        d: "M12 10.586L8.818 7.404a.506.506 0 0 0-.71.003l-.7.7a.495.495 0 0 0-.004.711L10.586 12l-3.182 3.182a.506.506 0 0 0 .003.71l.7.7a.495.495 0 0 0 .711.004L12 13.414l3.182 3.182a.506.506 0 0 0 .71-.003l.7-.7a.495.495 0 0 0 .004-.711L13.414 12l3.182-3.182a.506.506 0 0 0-.003-.71l-.7-.7a.495.495 0 0 0-.711-.004L12 10.586z",
                        fill: "currentColor",
                        fillRule: "evenodd",
                        role: "presentation"
                    }));
                };
            }
        } ]), _class;
    }(_Icon3.default);
    _class.displayName = "EditorCloseIcon", exports.default = _class;
}, /* 67 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _extends2 = __webpack_require__(19), _extends3 = _interopRequireDefault(_extends2), _getPrototypeOf = __webpack_require__(4), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(5), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(6), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(7), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(8), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(9), _react2 = _interopRequireDefault(_react), _Icon2 = __webpack_require__(2), _Icon3 = _interopRequireDefault(_Icon2), _class = function(_Icon) {
        function _class() {
            return (0, _classCallCheck3.default)(this, _class), (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, 
            _getPrototypeOf2.default)(_class)).apply(this, arguments));
        }
        return (0, _inherits3.default)(_class, _Icon), (0, _createClass3.default)(_class, [ {
            key: "getGlyphTemplate",
            value: function() {
                return function(props) {
                    var title = props.label, iconProps = (0, _extends3.default)({}, props);
                    // eslint-disable-next-line max-len, react/jsx-space-before-closing
                    return delete iconProps.label, _react2.default.createElement("svg", (0, _extends3.default)({
                        width: "24",
                        height: "24",
                        viewBox: "0 0 24 24",
                        focusable: "false"
                    }, iconProps, {
                        "aria-labelledby": "title-jl4lqri"
                    }), _react2.default.createElement("title", {
                        id: "title-jl4lqri"
                    }, title), _react2.default.createElement("path", {
                        d: "M13.294 15.645a.501.501 0 0 0 .004.714l.343.343a.501.501 0 0 0 .707.01l4.365-4.364a.493.493 0 0 0 0-.696l-4.365-4.365a.496.496 0 0 0-.707.011l-.343.343a.499.499 0 0 0-.004.714l3.29 3.29a.496.496 0 0 1 0 .71l-3.29 3.29zm-2.588-7.29a.501.501 0 0 0-.004-.714l-.343-.343a.501.501 0 0 0-.707-.01l-4.365 4.364a.493.493 0 0 0 0 .696l4.365 4.365a.496.496 0 0 0 .707-.011l.343-.343a.499.499 0 0 0 .004-.714l-3.29-3.29a.496.496 0 0 1 0-.71l3.29-3.29z",
                        fill: "currentColor",
                        fillRule: "evenodd",
                        role: "presentation"
                    }));
                };
            }
        } ]), _class;
    }(_Icon3.default);
    _class.displayName = "EditorCodeIcon", exports.default = _class;
}, /* 68 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _extends2 = __webpack_require__(19), _extends3 = _interopRequireDefault(_extends2), _getPrototypeOf = __webpack_require__(4), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(5), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(6), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(7), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(8), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(9), _react2 = _interopRequireDefault(_react), _Icon2 = __webpack_require__(2), _Icon3 = _interopRequireDefault(_Icon2), _class = function(_Icon) {
        function _class() {
            return (0, _classCallCheck3.default)(this, _class), (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, 
            _getPrototypeOf2.default)(_class)).apply(this, arguments));
        }
        return (0, _inherits3.default)(_class, _Icon), (0, _createClass3.default)(_class, [ {
            key: "getGlyphTemplate",
            value: function() {
                return function(props) {
                    var title = props.label, iconProps = (0, _extends3.default)({}, props);
                    // eslint-disable-next-line max-len, react/jsx-space-before-closing
                    return delete iconProps.label, _react2.default.createElement("svg", (0, _extends3.default)({
                        width: "24",
                        height: "24",
                        viewBox: "0 0 24 24",
                        focusable: "false"
                    }, iconProps, {
                        "aria-labelledby": "title-9s8ipfp"
                    }), _react2.default.createElement("title", {
                        id: "title-9s8ipfp"
                    }, title), _react2.default.createElement("path", {
                        d: "M6 8.51c0-.282.229-.51.5-.51h11c.276 0 .5.228.5.51v8.98c0 .282-.229.51-.5.51h-11a.505.505 0 0 1-.5-.51V8.51zm2 2.995c0-.279.214-.505.505-.505h.99c.279 0 .505.214.505.505v.99a.497.497 0 0 1-.505.505h-.99A.497.497 0 0 1 8 12.495v-.99zm3 0c0-.279.214-.505.505-.505h.99c.279 0 .505.214.505.505v.99a.497.497 0 0 1-.505.505h-.99a.497.497 0 0 1-.505-.505v-.99zm-3 3c0-.279.214-.505.505-.505h.99c.279 0 .505.214.505.505v.99a.497.497 0 0 1-.505.505h-.99A.497.497 0 0 1 8 15.495v-.99zM7.5 8h3v1h-3V8zm6 0h3v1h-3V8zm.5-1.495c0-.279.214-.505.505-.505h.99c.279 0 .505.214.505.505V8h-2V6.505zm-6 0C8 6.226 8.214 6 8.505 6h.99c.279 0 .505.214.505.505V8H8V6.505z",
                        fill: "currentColor",
                        fillRule: "evenodd",
                        role: "presentation"
                    }));
                };
            }
        } ]), _class;
    }(_Icon3.default);
    _class.displayName = "EditorDateIcon", exports.default = _class;
}, /* 69 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _extends2 = __webpack_require__(19), _extends3 = _interopRequireDefault(_extends2), _getPrototypeOf = __webpack_require__(4), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(5), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(6), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(7), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(8), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(9), _react2 = _interopRequireDefault(_react), _Icon2 = __webpack_require__(2), _Icon3 = _interopRequireDefault(_Icon2), _class = function(_Icon) {
        function _class() {
            return (0, _classCallCheck3.default)(this, _class), (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, 
            _getPrototypeOf2.default)(_class)).apply(this, arguments));
        }
        return (0, _inherits3.default)(_class, _Icon), (0, _createClass3.default)(_class, [ {
            key: "getGlyphTemplate",
            value: function() {
                return function(props) {
                    var title = props.label, iconProps = (0, _extends3.default)({}, props);
                    // eslint-disable-next-line max-len, react/jsx-space-before-closing
                    return delete iconProps.label, _react2.default.createElement("svg", (0, _extends3.default)({
                        width: "24",
                        height: "24",
                        viewBox: "0 0 24 24",
                        focusable: "false"
                    }, iconProps, {
                        "aria-labelledby": "title-gigxrqc"
                    }), _react2.default.createElement("title", {
                        id: "title-gigxrqc"
                    }, title), _react2.default.createElement("path", {
                        d: "M9.717 8.283L13 11.5v6.009a.503.503 0 0 1-.505.491h-.99a.499.499 0 0 1-.505-.508V12.5L8.281 9.719l-1.924 1.924C6.16 11.84 6 11.78 6 11.509V6.491C6 6.228 6.22 6 6.491 6h5.018c.263 0 .331.16.134.357L9.717 8.283zm5.927-1.927a.502.502 0 0 1 .704-.008l.804.804a.5.5 0 0 1-.008.704L14.5 10.5 13 9l2.644-2.644z",
                        fill: "currentColor",
                        fillRule: "evenodd",
                        role: "presentation"
                    }));
                };
            }
        } ]), _class;
    }(_Icon3.default);
    _class.displayName = "EditorDecisionIcon", exports.default = _class;
}, /* 70 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _extends2 = __webpack_require__(19), _extends3 = _interopRequireDefault(_extends2), _getPrototypeOf = __webpack_require__(4), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(5), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(6), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(7), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(8), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(9), _react2 = _interopRequireDefault(_react), _Icon2 = __webpack_require__(2), _Icon3 = _interopRequireDefault(_Icon2), _class = function(_Icon) {
        function _class() {
            return (0, _classCallCheck3.default)(this, _class), (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, 
            _getPrototypeOf2.default)(_class)).apply(this, arguments));
        }
        return (0, _inherits3.default)(_class, _Icon), (0, _createClass3.default)(_class, [ {
            key: "getGlyphTemplate",
            value: function() {
                return function(props) {
                    var title = props.label, iconProps = (0, _extends3.default)({}, props);
                    // eslint-disable-next-line max-len, react/jsx-space-before-closing
                    return delete iconProps.label, _react2.default.createElement("svg", (0, _extends3.default)({
                        width: "24",
                        height: "24",
                        viewBox: "0 0 24 24",
                        focusable: "false"
                    }, iconProps, {
                        "aria-labelledby": "title-vevo0gu"
                    }), _react2.default.createElement("title", {
                        id: "title-vevo0gu"
                    }, title), _react2.default.createElement("path", {
                        d: "M12 18.75a6.75 6.75 0 1 0 0-13.5 6.75 6.75 0 0 0 0 13.5zm0-1.5a5.25 5.25 0 1 1 0-10.5 5.25 5.25 0 0 1 0 10.5zm-1.5-5.75a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm-4.093 2.198c.085.255.259.602.55.952.502.602 1.186.975 2.043.975.857 0 1.54-.373 2.043-.975.291-.35.465-.697.55-.952a.625.625 0 1 0-1.186-.396c-.04.12-.147.335-.325.548-.28.335-.627.525-1.082.525-.455 0-.803-.19-1.082-.525a1.864 1.864 0 0 1-.325-.548.625.625 0 1 0-1.186.396z",
                        fill: "currentColor",
                        fillRule: "evenodd",
                        role: "presentation"
                    }));
                };
            }
        } ]), _class;
    }(_Icon3.default);
    _class.displayName = "EditorEmojiIcon", exports.default = _class;
}, /* 71 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _extends2 = __webpack_require__(19), _extends3 = _interopRequireDefault(_extends2), _getPrototypeOf = __webpack_require__(4), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(5), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(6), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(7), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(8), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(9), _react2 = _interopRequireDefault(_react), _Icon2 = __webpack_require__(2), _Icon3 = _interopRequireDefault(_Icon2), _class = function(_Icon) {
        function _class() {
            return (0, _classCallCheck3.default)(this, _class), (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, 
            _getPrototypeOf2.default)(_class)).apply(this, arguments));
        }
        return (0, _inherits3.default)(_class, _Icon), (0, _createClass3.default)(_class, [ {
            key: "getGlyphTemplate",
            value: function() {
                return function(props) {
                    var title = props.label, iconProps = (0, _extends3.default)({}, props);
                    // eslint-disable-next-line max-len, react/jsx-space-before-closing
                    return delete iconProps.label, _react2.default.createElement("svg", (0, _extends3.default)({
                        width: "24",
                        height: "24",
                        viewBox: "0 0 24 24",
                        focusable: "false"
                    }, iconProps, {
                        "aria-labelledby": "title-jc0imob"
                    }), _react2.default.createElement("title", {
                        id: "title-jc0imob"
                    }, title), _react2.default.createElement("path", {
                        d: "M12.706 3.706a1.003 1.003 0 0 0-1.412 0l-7.588 7.588a1.003 1.003 0 0 0 0 1.412l7.588 7.588c.39.39 1.026.386 1.412 0l7.588-7.588c.39-.39.386-1.026 0-1.412l-7.588-7.588zM13 12.208v-3.71A.496.496 0 0 0 12.495 8h-.99a.494.494 0 0 0-.505.498v3.71A2.492 2.492 0 0 1 12 12c.356 0 .694.074 1 .208zM12 16a1 1 0 1 0 0-2 1 1 0 0 0 0 2z",
                        fill: "currentColor",
                        fillRule: "evenodd",
                        role: "presentation"
                    }));
                };
            }
        } ]), _class;
    }(_Icon3.default);
    _class.displayName = "EditorErrorIcon", exports.default = _class;
}, /* 72 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _extends2 = __webpack_require__(19), _extends3 = _interopRequireDefault(_extends2), _getPrototypeOf = __webpack_require__(4), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(5), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(6), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(7), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(8), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(9), _react2 = _interopRequireDefault(_react), _Icon2 = __webpack_require__(2), _Icon3 = _interopRequireDefault(_Icon2), _class = function(_Icon) {
        function _class() {
            return (0, _classCallCheck3.default)(this, _class), (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, 
            _getPrototypeOf2.default)(_class)).apply(this, arguments));
        }
        return (0, _inherits3.default)(_class, _Icon), (0, _createClass3.default)(_class, [ {
            key: "getGlyphTemplate",
            value: function() {
                return function(props) {
                    var title = props.label, iconProps = (0, _extends3.default)({}, props);
                    // eslint-disable-next-line max-len, react/jsx-space-before-closing
                    return delete iconProps.label, _react2.default.createElement("svg", (0, _extends3.default)({
                        width: "24",
                        height: "24",
                        viewBox: "0 0 24 24",
                        focusable: "false"
                    }, iconProps, {
                        "aria-labelledby": "title-evh3q0h"
                    }), _react2.default.createElement("title", {
                        id: "title-evh3q0h"
                    }, title), _react2.default.createElement("path", {
                        d: "M9.211 10.24a.502.502 0 0 0-.7.142l-.27.403a.503.503 0 0 0 .136.701l3.206 2.137c.23.154.601.156.834 0l3.206-2.137a.5.5 0 0 0 .135-.7l-.268-.404a.509.509 0 0 0-.701-.142l-2.37 1.579a.822.822 0 0 1-.838 0l-2.37-1.58z",
                        fill: "currentColor",
                        fillRule: "evenodd",
                        role: "presentation"
                    }));
                };
            }
        } ]), _class;
    }(_Icon3.default);
    _class.displayName = "EditorExpandIcon", exports.default = _class;
}, /* 73 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _extends2 = __webpack_require__(19), _extends3 = _interopRequireDefault(_extends2), _getPrototypeOf = __webpack_require__(4), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(5), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(6), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(7), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(8), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(9), _react2 = _interopRequireDefault(_react), _Icon2 = __webpack_require__(2), _Icon3 = _interopRequireDefault(_Icon2), _class = function(_Icon) {
        function _class() {
            return (0, _classCallCheck3.default)(this, _class), (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, 
            _getPrototypeOf2.default)(_class)).apply(this, arguments));
        }
        return (0, _inherits3.default)(_class, _Icon), (0, _createClass3.default)(_class, [ {
            key: "getGlyphTemplate",
            value: function() {
                return function(props) {
                    var title = props.label, iconProps = (0, _extends3.default)({}, props);
                    // eslint-disable-next-line max-len, react/jsx-space-before-closing
                    return delete iconProps.label, _react2.default.createElement("svg", (0, _extends3.default)({
                        width: "24",
                        height: "24",
                        viewBox: "0 0 24 24",
                        focusable: "false"
                    }, iconProps, {
                        "aria-labelledby": "title-u0dbssm"
                    }), _react2.default.createElement("title", {
                        id: "title-u0dbssm"
                    }, title), _react2.default.createElement("path", {
                        d: "M5.87 12.68l-.932-.339C4.418 12.151 4 11.552 4 11c0-.556.42-1.153.938-1.341l9.124-3.318c.52-.19.938.105.938.654v8.01c0 .54-.42.842-.938.654l-3.14-1.142L5.87 12.68zM8 14.955V17c0 .552-.405 1.202-.895 1.447l-.21.106C6.4 18.8 6 18.549 6 18.009v-3.782l2 .728zm9.224-5.508l2-1a.5.5 0 0 0-.448-.894l-2 1a.5.5 0 0 0 .448.894zm-.448 4l2 1a.5.5 0 1 0 .448-.894l-2-1a.5.5 0 1 0-.448.894zM17 11.5h3a.5.5 0 1 0 0-1h-3a.5.5 0 1 0 0 1z",
                        fill: "currentColor",
                        fillRule: "evenodd",
                        role: "presentation"
                    }));
                };
            }
        } ]), _class;
    }(_Icon3.default);
    _class.displayName = "EditorFeedbackIcon", exports.default = _class;
}, /* 74 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _extends2 = __webpack_require__(19), _extends3 = _interopRequireDefault(_extends2), _getPrototypeOf = __webpack_require__(4), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(5), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(6), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(7), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(8), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(9), _react2 = _interopRequireDefault(_react), _Icon2 = __webpack_require__(2), _Icon3 = _interopRequireDefault(_Icon2), _class = function(_Icon) {
        function _class() {
            return (0, _classCallCheck3.default)(this, _class), (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, 
            _getPrototypeOf2.default)(_class)).apply(this, arguments));
        }
        return (0, _inherits3.default)(_class, _Icon), (0, _createClass3.default)(_class, [ {
            key: "getGlyphTemplate",
            value: function() {
                return function(props) {
                    var title = props.label, iconProps = (0, _extends3.default)({}, props);
                    // eslint-disable-next-line max-len, react/jsx-space-before-closing
                    return delete iconProps.label, _react2.default.createElement("svg", (0, _extends3.default)({
                        width: "24",
                        height: "24",
                        viewBox: "0 0 24 24",
                        focusable: "false"
                    }, iconProps, {
                        "aria-labelledby": "title-tt3p7wl"
                    }), _react2.default.createElement("title", {
                        id: "title-tt3p7wl"
                    }, title), _react2.default.createElement("path", {
                        d: "M7 6.5c0-.276.228-.5.491-.5H13l4 4v7.5c0 .276-.228.5-.51.5H7.51a.508.508 0 0 1-.51-.5v-11zm5 1l3.5 3.5h-2.999a.505.505 0 0 1-.501-.501V7.5z",
                        fill: "currentColor",
                        fillRule: "evenodd",
                        role: "presentation"
                    }));
                };
            }
        } ]), _class;
    }(_Icon3.default);
    _class.displayName = "EditorFileIcon", exports.default = _class;
}, /* 75 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _extends2 = __webpack_require__(19), _extends3 = _interopRequireDefault(_extends2), _getPrototypeOf = __webpack_require__(4), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(5), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(6), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(7), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(8), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(9), _react2 = _interopRequireDefault(_react), _Icon2 = __webpack_require__(2), _Icon3 = _interopRequireDefault(_Icon2), _class = function(_Icon) {
        function _class() {
            return (0, _classCallCheck3.default)(this, _class), (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, 
            _getPrototypeOf2.default)(_class)).apply(this, arguments));
        }
        return (0, _inherits3.default)(_class, _Icon), (0, _createClass3.default)(_class, [ {
            key: "getGlyphTemplate",
            value: function() {
                return function(props) {
                    var title = props.label, iconProps = (0, _extends3.default)({}, props);
                    // eslint-disable-next-line max-len, react/jsx-space-before-closing
                    return delete iconProps.label, _react2.default.createElement("svg", (0, _extends3.default)({
                        width: "24",
                        height: "24",
                        viewBox: "0 0 24 24",
                        focusable: "false"
                    }, iconProps, {
                        "aria-labelledby": "title-k7erere"
                    }), _react2.default.createElement("title", {
                        id: "title-k7erere"
                    }, title), _react2.default.createElement("path", {
                        d: "M8 10h2.5c0-2 1.5-2 1.5-2 1.5 0 2.5 1.5.5 3-1.5 1-1.5 1.5-1.5 3 0 .144-.016.824 0 1h2c0-1.568 0-2 1.5-3 1.446-.964 1.5-1.896 1.5-3 0-2-1.5-3-4-3-2 0-4 1-4 4zm5 8v-2h-2v2h2z",
                        fill: "currentColor",
                        fillRule: "evenodd",
                        role: "presentation"
                    }));
                };
            }
        } ]), _class;
    }(_Icon3.default);
    _class.displayName = "EditorHelpIcon", exports.default = _class;
}, /* 76 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _extends2 = __webpack_require__(19), _extends3 = _interopRequireDefault(_extends2), _getPrototypeOf = __webpack_require__(4), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(5), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(6), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(7), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(8), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(9), _react2 = _interopRequireDefault(_react), _Icon2 = __webpack_require__(2), _Icon3 = _interopRequireDefault(_Icon2), _class = function(_Icon) {
        function _class() {
            return (0, _classCallCheck3.default)(this, _class), (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, 
            _getPrototypeOf2.default)(_class)).apply(this, arguments));
        }
        return (0, _inherits3.default)(_class, _Icon), (0, _createClass3.default)(_class, [ {
            key: "getGlyphTemplate",
            value: function() {
                return function(props) {
                    var title = props.label, iconProps = (0, _extends3.default)({}, props);
                    // eslint-disable-next-line max-len, react/jsx-space-before-closing
                    return delete iconProps.label, _react2.default.createElement("svg", (0, _extends3.default)({
                        width: "24",
                        height: "24",
                        viewBox: "0 0 24 24",
                        focusable: "false"
                    }, iconProps, {
                        "aria-labelledby": "title-j3owbp0"
                    }), _react2.default.createElement("title", {
                        id: "title-j3owbp0"
                    }, title), _react2.default.createElement("path", {
                        d: "M14 16s0-.5 1-2 2.5-3 2.5-5S17 4 12 4 6.5 7 6.5 9 8 12.5 9 14s1 2 1 2h4zm-4 1h4v1l-1.5 2h-1L10 18v-1z",
                        fill: "currentColor",
                        fillRule: "evenodd",
                        role: "presentation"
                    }));
                };
            }
        } ]), _class;
    }(_Icon3.default);
    _class.displayName = "EditorHintIcon", exports.default = _class;
}, /* 77 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _extends2 = __webpack_require__(19), _extends3 = _interopRequireDefault(_extends2), _getPrototypeOf = __webpack_require__(4), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(5), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(6), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(7), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(8), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(9), _react2 = _interopRequireDefault(_react), _Icon2 = __webpack_require__(2), _Icon3 = _interopRequireDefault(_Icon2), _class = function(_Icon) {
        function _class() {
            return (0, _classCallCheck3.default)(this, _class), (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, 
            _getPrototypeOf2.default)(_class)).apply(this, arguments));
        }
        return (0, _inherits3.default)(_class, _Icon), (0, _createClass3.default)(_class, [ {
            key: "getGlyphTemplate",
            value: function() {
                return function(props) {
                    var title = props.label, iconProps = (0, _extends3.default)({}, props);
                    // eslint-disable-next-line max-len, react/jsx-space-before-closing
                    return delete iconProps.label, _react2.default.createElement("svg", (0, _extends3.default)({
                        width: "24",
                        height: "24",
                        viewBox: "0 0 24 24",
                        focusable: "false"
                    }, iconProps, {
                        "aria-labelledby": "title-q4x319x"
                    }), _react2.default.createElement("title", {
                        id: "title-q4x319x"
                    }, title), _react2.default.createElement("path", {
                        d: "M17 9h1v3h-1V9zm0 4h1v2h-1v-2zM6 9h1v2H6V9zm0 3h1v3H6v-3zm3 5h2v1H9v-1zm3 0h3v1h-3v-1zM9 6h3v1H9V6zm4 0h2v1h-2V6zm-7 .505C6 6.226 6.214 6 6.505 6H8v1H7v1H6V6.505zm12 0A.497.497 0 0 0 17.495 6H16v1h1v1h1V6.505zM6 17.495c0 .279.214.505.505.505H8v-1H7v-1H6v1.495zm12 0a.497.497 0 0 1-.505.505H16v-1h1v-1h1v1.495z",
                        fill: "currentColor",
                        fillRule: "evenodd",
                        role: "presentation"
                    }));
                };
            }
        } ]), _class;
    }(_Icon3.default);
    _class.displayName = "EditorImageBorderIcon", exports.default = _class;
}, /* 78 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _extends2 = __webpack_require__(19), _extends3 = _interopRequireDefault(_extends2), _getPrototypeOf = __webpack_require__(4), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(5), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(6), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(7), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(8), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(9), _react2 = _interopRequireDefault(_react), _Icon2 = __webpack_require__(2), _Icon3 = _interopRequireDefault(_Icon2), _class = function(_Icon) {
        function _class() {
            return (0, _classCallCheck3.default)(this, _class), (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, 
            _getPrototypeOf2.default)(_class)).apply(this, arguments));
        }
        return (0, _inherits3.default)(_class, _Icon), (0, _createClass3.default)(_class, [ {
            key: "getGlyphTemplate",
            value: function() {
                return function(props) {
                    var title = props.label, iconProps = (0, _extends3.default)({}, props);
                    // eslint-disable-next-line max-len, react/jsx-space-before-closing
                    return delete iconProps.label, _react2.default.createElement("svg", (0, _extends3.default)({
                        width: "24",
                        height: "24",
                        viewBox: "0 0 24 24",
                        focusable: "false"
                    }, iconProps, {
                        "aria-labelledby": "title-vpavfep"
                    }), _react2.default.createElement("title", {
                        id: "title-vpavfep"
                    }, title), _react2.default.createElement("path", {
                        d: "M14.293 9L9 14.293V13H8v3h3v-1H9.707L15 9.707V11h1V8h-3v1h1.293zM6 6.5c0-.276.229-.5.5-.5h11c.276 0 .5.229.5.5v11c0 .276-.229.5-.5.5h-11a.504.504 0 0 1-.5-.5v-11z",
                        fill: "currentColor",
                        fillRule: "evenodd",
                        role: "presentation"
                    }));
                };
            }
        } ]), _class;
    }(_Icon3.default);
    _class.displayName = "EditorImageResizeIcon", exports.default = _class;
}, /* 79 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _extends2 = __webpack_require__(19), _extends3 = _interopRequireDefault(_extends2), _getPrototypeOf = __webpack_require__(4), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(5), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(6), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(7), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(8), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(9), _react2 = _interopRequireDefault(_react), _Icon2 = __webpack_require__(2), _Icon3 = _interopRequireDefault(_Icon2), _class = function(_Icon) {
        function _class() {
            return (0, _classCallCheck3.default)(this, _class), (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, 
            _getPrototypeOf2.default)(_class)).apply(this, arguments));
        }
        return (0, _inherits3.default)(_class, _Icon), (0, _createClass3.default)(_class, [ {
            key: "getGlyphTemplate",
            value: function() {
                return function(props) {
                    var title = props.label, iconProps = (0, _extends3.default)({}, props);
                    // eslint-disable-next-line max-len, react/jsx-space-before-closing
                    return delete iconProps.label, _react2.default.createElement("svg", (0, _extends3.default)({
                        width: "24",
                        height: "24",
                        viewBox: "0 0 24 24",
                        focusable: "false"
                    }, iconProps, {
                        "aria-labelledby": "title-tp05avb"
                    }), _react2.default.createElement("title", {
                        id: "title-tp05avb"
                    }, title), _react2.default.createElement("path", {
                        d: "M11 15l-1-1-2 2h8v-1.8L14 12l-3 3zM6 6.5c0-.276.229-.5.5-.5h11c.276 0 .5.229.5.5v11c0 .276-.229.5-.5.5h-11a.504.504 0 0 1-.5-.5v-11zM9.5 11a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z",
                        fill: "currentColor",
                        fillRule: "evenodd",
                        role: "presentation"
                    }));
                };
            }
        } ]), _class;
    }(_Icon3.default);
    _class.displayName = "EditorImageIcon", exports.default = _class;
}, /* 80 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _extends2 = __webpack_require__(19), _extends3 = _interopRequireDefault(_extends2), _getPrototypeOf = __webpack_require__(4), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(5), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(6), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(7), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(8), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(9), _react2 = _interopRequireDefault(_react), _Icon2 = __webpack_require__(2), _Icon3 = _interopRequireDefault(_Icon2), _class = function(_Icon) {
        function _class() {
            return (0, _classCallCheck3.default)(this, _class), (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, 
            _getPrototypeOf2.default)(_class)).apply(this, arguments));
        }
        return (0, _inherits3.default)(_class, _Icon), (0, _createClass3.default)(_class, [ {
            key: "getGlyphTemplate",
            value: function() {
                return function(props) {
                    var title = props.label, iconProps = (0, _extends3.default)({}, props);
                    // eslint-disable-next-line max-len, react/jsx-space-before-closing
                    return delete iconProps.label, _react2.default.createElement("svg", (0, _extends3.default)({
                        width: "24",
                        height: "24",
                        viewBox: "0 0 24 24",
                        focusable: "false"
                    }, iconProps, {
                        "aria-labelledby": "title-kcjmb1c"
                    }), _react2.default.createElement("title", {
                        id: "title-kcjmb1c"
                    }, title), _react2.default.createElement("path", {
                        d: "M9 9H6.49a.495.495 0 0 0-.49.505v.99c0 .291.22.505.49.505H9v2l3-3-3-3v2zm4-1.495c0-.279.228-.505.491-.505h5.018a.49.49 0 0 1 .491.505v.99a.503.503 0 0 1-.491.505h-5.018A.49.49 0 0 1 13 8.495v-.99zm0 4c0-.279.228-.505.491-.505h5.018a.49.49 0 0 1 .491.505v.99a.503.503 0 0 1-.491.505h-5.018a.49.49 0 0 1-.491-.505v-.99zm-6 4c0-.279.229-.505.5-.505h11c.276 0 .5.214.5.505v.99a.506.506 0 0 1-.5.505h-11a.495.495 0 0 1-.5-.505v-.99z",
                        fill: "currentColor",
                        fillRule: "evenodd",
                        role: "presentation"
                    }));
                };
            }
        } ]), _class;
    }(_Icon3.default);
    _class.displayName = "EditorIndentIcon", exports.default = _class;
}, /* 81 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _extends2 = __webpack_require__(19), _extends3 = _interopRequireDefault(_extends2), _getPrototypeOf = __webpack_require__(4), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(5), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(6), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(7), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(8), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(9), _react2 = _interopRequireDefault(_react), _Icon2 = __webpack_require__(2), _Icon3 = _interopRequireDefault(_Icon2), _class = function(_Icon) {
        function _class() {
            return (0, _classCallCheck3.default)(this, _class), (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, 
            _getPrototypeOf2.default)(_class)).apply(this, arguments));
        }
        return (0, _inherits3.default)(_class, _Icon), (0, _createClass3.default)(_class, [ {
            key: "getGlyphTemplate",
            value: function() {
                return function(props) {
                    var title = props.label, iconProps = (0, _extends3.default)({}, props);
                    // eslint-disable-next-line max-len, react/jsx-space-before-closing
                    return delete iconProps.label, _react2.default.createElement("svg", (0, _extends3.default)({
                        width: "24",
                        height: "24",
                        viewBox: "0 0 24 24",
                        focusable: "false"
                    }, iconProps, {
                        "aria-labelledby": "title-g5m8gtn"
                    }), _react2.default.createElement("title", {
                        id: "title-g5m8gtn"
                    }, title), _react2.default.createElement("path", {
                        d: "M13 11.792v4.717a.49.49 0 0 1-.505.491h-.99a.503.503 0 0 1-.505-.491v-4.717c.306.134.644.208 1 .208s.694-.074 1-.208zM12 20a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm0-10a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z",
                        fill: "currentColor",
                        fillRule: "evenodd",
                        role: "presentation"
                    }));
                };
            }
        } ]), _class;
    }(_Icon3.default);
    _class.displayName = "EditorInfoIcon", exports.default = _class;
}, /* 82 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _extends2 = __webpack_require__(19), _extends3 = _interopRequireDefault(_extends2), _getPrototypeOf = __webpack_require__(4), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(5), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(6), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(7), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(8), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(9), _react2 = _interopRequireDefault(_react), _Icon2 = __webpack_require__(2), _Icon3 = _interopRequireDefault(_Icon2), _class = function(_Icon) {
        function _class() {
            return (0, _classCallCheck3.default)(this, _class), (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, 
            _getPrototypeOf2.default)(_class)).apply(this, arguments));
        }
        return (0, _inherits3.default)(_class, _Icon), (0, _createClass3.default)(_class, [ {
            key: "getGlyphTemplate",
            value: function() {
                return function(props) {
                    var title = props.label, iconProps = (0, _extends3.default)({}, props);
                    // eslint-disable-next-line max-len, react/jsx-space-before-closing
                    return delete iconProps.label, _react2.default.createElement("svg", (0, _extends3.default)({
                        width: "24",
                        height: "24",
                        viewBox: "0 0 24 24",
                        focusable: "false"
                    }, iconProps, {
                        "aria-labelledby": "title-g7wx55j"
                    }), _react2.default.createElement("title", {
                        id: "title-g7wx55j"
                    }, title), _react2.default.createElement("g", {
                        transform: "translate(7 6)",
                        fill: "currentColor",
                        fillRule: "evenodd"
                    }, _react2.default.createElement("rect", {
                        x: "2",
                        width: "8",
                        height: "2",
                        rx: ".5",
                        role: "presentation"
                    }), _react2.default.createElement("rect", {
                        y: "10",
                        width: "8",
                        height: "2",
                        rx: ".5",
                        role: "presentation"
                    }), _react2.default.createElement("path", {
                        d: "M5 2h2l-2 8H3z",
                        role: "presentation"
                    })));
                };
            }
        } ]), _class;
    }(_Icon3.default);
    _class.displayName = "EditorItalicIcon", exports.default = _class;
}, /* 83 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _extends2 = __webpack_require__(19), _extends3 = _interopRequireDefault(_extends2), _getPrototypeOf = __webpack_require__(4), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(5), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(6), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(7), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(8), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(9), _react2 = _interopRequireDefault(_react), _Icon2 = __webpack_require__(2), _Icon3 = _interopRequireDefault(_Icon2), _class = function(_Icon) {
        function _class() {
            return (0, _classCallCheck3.default)(this, _class), (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, 
            _getPrototypeOf2.default)(_class)).apply(this, arguments));
        }
        return (0, _inherits3.default)(_class, _Icon), (0, _createClass3.default)(_class, [ {
            key: "getGlyphTemplate",
            value: function() {
                return function(props) {
                    var title = props.label, iconProps = (0, _extends3.default)({}, props);
                    // eslint-disable-next-line max-len, react/jsx-space-before-closing
                    return delete iconProps.label, _react2.default.createElement("svg", (0, _extends3.default)({
                        width: "24",
                        height: "24",
                        viewBox: "0 0 24 24",
                        focusable: "false"
                    }, iconProps, {
                        "aria-labelledby": "title-xverh9d"
                    }), _react2.default.createElement("title", {
                        id: "title-xverh9d"
                    }, title), _react2.default.createElement("path", {
                        d: "M12.604 9.172l1.06-1.062a1.749 1.749 0 0 1 2.475 0c.685.686.686 1.79 0 2.475l-1.06 1.061-.703.703a1.753 1.753 0 0 1-2.48.005.75.75 0 0 0-1.06 1.06 3.253 3.253 0 0 0 4.6-.004l.703-.703 1.061-1.061a3.247 3.247 0 0 0 0-4.596 3.249 3.249 0 0 0-4.596 0l-1.061 1.06a.75.75 0 0 0 1.06 1.062zm-.708 5.656l-1.06 1.062a1.749 1.749 0 0 1-2.475 0 1.747 1.747 0 0 1 0-2.475l1.06-1.061.703-.703a1.753 1.753 0 0 1 2.48-.005.75.75 0 0 0 1.06-1.06 3.253 3.253 0 0 0-4.6.004l-.703.703L7.3 12.354a3.247 3.247 0 0 0 0 4.596 3.249 3.249 0 0 0 4.596 0l1.061-1.06a.75.75 0 1 0-1.06-1.062z",
                        fill: "currentColor",
                        fillRule: "evenodd",
                        role: "presentation"
                    }));
                };
            }
        } ]), _class;
    }(_Icon3.default);
    _class.displayName = "EditorLinkIcon", exports.default = _class;
}, /* 84 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _extends2 = __webpack_require__(19), _extends3 = _interopRequireDefault(_extends2), _getPrototypeOf = __webpack_require__(4), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(5), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(6), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(7), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(8), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(9), _react2 = _interopRequireDefault(_react), _Icon2 = __webpack_require__(2), _Icon3 = _interopRequireDefault(_Icon2), _class = function(_Icon) {
        function _class() {
            return (0, _classCallCheck3.default)(this, _class), (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, 
            _getPrototypeOf2.default)(_class)).apply(this, arguments));
        }
        return (0, _inherits3.default)(_class, _Icon), (0, _createClass3.default)(_class, [ {
            key: "getGlyphTemplate",
            value: function() {
                return function(props) {
                    var title = props.label, iconProps = (0, _extends3.default)({}, props);
                    // eslint-disable-next-line max-len, react/jsx-space-before-closing
                    return delete iconProps.label, _react2.default.createElement("svg", (0, _extends3.default)({
                        width: "24",
                        height: "24",
                        viewBox: "0 0 24 24",
                        focusable: "false"
                    }, iconProps, {
                        "aria-labelledby": "title-lajr1p3"
                    }), _react2.default.createElement("title", {
                        id: "title-lajr1p3"
                    }, title), _react2.default.createElement("path", {
                        d: "M16.74 11.573a5.09 5.09 0 0 0 .181-.73c.113-.598.072-.896.072-.896h-.001A4.995 4.995 0 0 0 12 5a4.995 4.995 0 0 0-4.992 4.947s-.04.288.065.863c.044.27.11.531.194.784.448 1.464 1.63 3.903 4.7 7.319.01.037.02.05.033.037.012.013.024 0 .033-.037 3.086-3.432 4.263-5.88 4.706-7.34zm-4.74.924a2.498 2.498 0 0 0 2.496-2.499A2.498 2.498 0 0 0 12 7.499a2.498 2.498 0 0 0-2.496 2.499A2.498 2.498 0 0 0 12 12.497z",
                        fill: "currentColor",
                        fillRule: "evenodd",
                        role: "presentation"
                    }));
                };
            }
        } ]), _class;
    }(_Icon3.default);
    _class.displayName = "EditorLocationIcon", exports.default = _class;
}, /* 85 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _extends2 = __webpack_require__(19), _extends3 = _interopRequireDefault(_extends2), _getPrototypeOf = __webpack_require__(4), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(5), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(6), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(7), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(8), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(9), _react2 = _interopRequireDefault(_react), _Icon2 = __webpack_require__(2), _Icon3 = _interopRequireDefault(_Icon2), _class = function(_Icon) {
        function _class() {
            return (0, _classCallCheck3.default)(this, _class), (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, 
            _getPrototypeOf2.default)(_class)).apply(this, arguments));
        }
        return (0, _inherits3.default)(_class, _Icon), (0, _createClass3.default)(_class, [ {
            key: "getGlyphTemplate",
            value: function() {
                return function(props) {
                    var title = props.label, iconProps = (0, _extends3.default)({}, props);
                    // eslint-disable-next-line max-len, react/jsx-space-before-closing
                    return delete iconProps.label, _react2.default.createElement("svg", (0, _extends3.default)({
                        width: "24",
                        height: "24",
                        viewBox: "0 0 24 24",
                        focusable: "false"
                    }, iconProps, {
                        "aria-labelledby": "title-j2f34qu"
                    }), _react2.default.createElement("title", {
                        id: "title-j2f34qu"
                    }, title), _react2.default.createElement("path", {
                        d: "M9.5 10a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5zm1.5 2H6.749C5.783 12 5 12.768 5 13.714v2.457a6.158 6.158 0 0 0 5.87 1.648A4.977 4.977 0 0 1 10 15c0-1.126.372-2.164 1-3zm7.384.544C17.652 11.592 16.363 11 15.02 11 12.802 11 11 12.794 11 15s1.802 4 4.019 4c.347 0 .628-.28.628-.625a.627.627 0 0 0-.628-.626A2.758 2.758 0 0 1 12.258 15a2.757 2.757 0 0 1 2.76-2.748c.947 0 1.877.413 2.368 1.052.345.45.441.966.288 1.532-.14.513-.347.843-.596.955-.27.117-.575-.022-.578-.022-.278-.165-.038-.811.28-1.576l.053-.126a.618.618 0 1 0-.93-.744c-.039-.025-.065-.065-.107-.085-.773-.398-1.827.034-2.35.97-.317.571-.412 1.196-.259 1.715.107.362.335.652.642.816.19.101.395.15.606.15.347 0 .704-.14 1.03-.38.109.128.242.248.418.351.084.046.856.437 1.684.083.628-.268 1.072-.867 1.32-1.779.255-.936.076-1.866-.503-2.62zm-2.835 2.732c-.3.536-.834.817-1.19.627-.358-.19-.404-.777-.103-1.313.264-.47.811-.759 1.19-.564.36.184.404.714.103 1.25z",
                        fill: "currentColor",
                        fillRule: "evenodd",
                        role: "presentation"
                    }));
                };
            }
        } ]), _class;
    }(_Icon3.default);
    _class.displayName = "EditorMentionIcon", exports.default = _class;
}, /* 86 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _extends2 = __webpack_require__(19), _extends3 = _interopRequireDefault(_extends2), _getPrototypeOf = __webpack_require__(4), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(5), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(6), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(7), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(8), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(9), _react2 = _interopRequireDefault(_react), _Icon2 = __webpack_require__(2), _Icon3 = _interopRequireDefault(_Icon2), _class = function(_Icon) {
        function _class() {
            return (0, _classCallCheck3.default)(this, _class), (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, 
            _getPrototypeOf2.default)(_class)).apply(this, arguments));
        }
        return (0, _inherits3.default)(_class, _Icon), (0, _createClass3.default)(_class, [ {
            key: "getGlyphTemplate",
            value: function() {
                return function(props) {
                    var title = props.label, iconProps = (0, _extends3.default)({}, props);
                    // eslint-disable-next-line max-len, react/jsx-space-before-closing
                    return delete iconProps.label, _react2.default.createElement("svg", (0, _extends3.default)({
                        width: "24",
                        height: "24",
                        viewBox: "0 0 24 24",
                        focusable: "false"
                    }, iconProps, {
                        "aria-labelledby": "title-c02g32l"
                    }), _react2.default.createElement("title", {
                        id: "title-c02g32l"
                    }, title), _react2.default.createElement("path", {
                        d: "M6.5 13.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zm5.5 0a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zm5.5 0a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z",
                        fill: "currentColor",
                        fillRule: "evenodd",
                        role: "presentation"
                    }));
                };
            }
        } ]), _class;
    }(_Icon3.default);
    _class.displayName = "EditorMoreIcon", exports.default = _class;
}, /* 87 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _extends2 = __webpack_require__(19), _extends3 = _interopRequireDefault(_extends2), _getPrototypeOf = __webpack_require__(4), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(5), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(6), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(7), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(8), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(9), _react2 = _interopRequireDefault(_react), _Icon2 = __webpack_require__(2), _Icon3 = _interopRequireDefault(_Icon2), _class = function(_Icon) {
        function _class() {
            return (0, _classCallCheck3.default)(this, _class), (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, 
            _getPrototypeOf2.default)(_class)).apply(this, arguments));
        }
        return (0, _inherits3.default)(_class, _Icon), (0, _createClass3.default)(_class, [ {
            key: "getGlyphTemplate",
            value: function() {
                return function(props) {
                    var title = props.label, iconProps = (0, _extends3.default)({}, props);
                    // eslint-disable-next-line max-len, react/jsx-space-before-closing
                    return delete iconProps.label, _react2.default.createElement("svg", (0, _extends3.default)({
                        width: "24",
                        height: "24",
                        viewBox: "0 0 24 24",
                        focusable: "false"
                    }, iconProps, {
                        "aria-labelledby": "title-ngjo6bv"
                    }), _react2.default.createElement("title", {
                        id: "title-ngjo6bv"
                    }, title), _react2.default.createElement("path", {
                        d: "M6 4.496C6 4.222 6.229 4 6.5 4h11a.5.5 0 0 1 .5.496v15.008a.502.502 0 0 1-.5.496h-11a.5.5 0 0 1-.5-.496V4.496zM8 7.5c0-.276.23-.5.5-.5h7c.276 0 .5.232.5.5 0 .276-.23.5-.5.5h-7a.505.505 0 0 1-.5-.5zm0 3c0-.276.23-.5.5-.5h7c.276 0 .5.232.5.5 0 .276-.23.5-.5.5h-7a.505.505 0 0 1-.5-.5zm0 3c0-.276.215-.5.49-.5h3.02a.5.5 0 0 1 .49.5c0 .276-.215.5-.49.5H8.49a.5.5 0 0 1-.49-.5z",
                        fill: "currentColor",
                        fillRule: "evenodd",
                        role: "presentation"
                    }));
                };
            }
        } ]), _class;
    }(_Icon3.default);
    _class.displayName = "EditorNoteIcon", exports.default = _class;
}, /* 88 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _extends2 = __webpack_require__(19), _extends3 = _interopRequireDefault(_extends2), _getPrototypeOf = __webpack_require__(4), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(5), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(6), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(7), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(8), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(9), _react2 = _interopRequireDefault(_react), _Icon2 = __webpack_require__(2), _Icon3 = _interopRequireDefault(_Icon2), _class = function(_Icon) {
        function _class() {
            return (0, _classCallCheck3.default)(this, _class), (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, 
            _getPrototypeOf2.default)(_class)).apply(this, arguments));
        }
        return (0, _inherits3.default)(_class, _Icon), (0, _createClass3.default)(_class, [ {
            key: "getGlyphTemplate",
            value: function() {
                return function(props) {
                    var title = props.label, iconProps = (0, _extends3.default)({}, props);
                    // eslint-disable-next-line max-len, react/jsx-space-before-closing
                    return delete iconProps.label, _react2.default.createElement("svg", (0, _extends3.default)({
                        width: "24",
                        height: "24",
                        viewBox: "0 0 24 24",
                        focusable: "false"
                    }, iconProps, {
                        "aria-labelledby": "title-a842etq"
                    }), _react2.default.createElement("title", {
                        id: "title-a842etq"
                    }, title), _react2.default.createElement("path", {
                        d: "M10 7.505c0-.279.23-.505.5-.505h7c.276 0 .5.214.5.505v.99c0 .279-.23.505-.5.505h-7a.495.495 0 0 1-.5-.505v-.99zm0 4c0-.279.23-.505.5-.505h7c.276 0 .5.214.5.505v.99c0 .279-.23.505-.5.505h-7a.495.495 0 0 1-.5-.505v-.99zm0 4c0-.279.23-.505.5-.505h7c.276 0 .5.214.5.505v.99c0 .279-.23.505-.5.505h-7a.495.495 0 0 1-.5-.505v-.99zM6 15v1h2.5v-1H6zm0 2v1h2.5v-1H6zm1-9v2h1V7H6v1h1zm-1 3v1h1v.5h1V12h.5v-1H6zm0 2v1h3v-1H6zm1.5 3H9v1H7.5v-1z",
                        fill: "currentColor",
                        fillRule: "evenodd",
                        role: "presentation"
                    }));
                };
            }
        } ]), _class;
    }(_Icon3.default);
    _class.displayName = "EditorNumberListIcon", exports.default = _class;
}, /* 89 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _extends2 = __webpack_require__(19), _extends3 = _interopRequireDefault(_extends2), _getPrototypeOf = __webpack_require__(4), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(5), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(6), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(7), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(8), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(9), _react2 = _interopRequireDefault(_react), _Icon2 = __webpack_require__(2), _Icon3 = _interopRequireDefault(_Icon2), _class = function(_Icon) {
        function _class() {
            return (0, _classCallCheck3.default)(this, _class), (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, 
            _getPrototypeOf2.default)(_class)).apply(this, arguments));
        }
        return (0, _inherits3.default)(_class, _Icon), (0, _createClass3.default)(_class, [ {
            key: "getGlyphTemplate",
            value: function() {
                return function(props) {
                    var title = props.label, iconProps = (0, _extends3.default)({}, props);
                    // eslint-disable-next-line max-len, react/jsx-space-before-closing
                    return delete iconProps.label, _react2.default.createElement("svg", (0, _extends3.default)({
                        width: "24",
                        height: "24",
                        viewBox: "0 0 24 24",
                        focusable: "false"
                    }, iconProps, {
                        "aria-labelledby": "title-elbu3eb"
                    }), _react2.default.createElement("title", {
                        id: "title-elbu3eb"
                    }, title), _react2.default.createElement("path", {
                        d: "M13.207 12.207L8.82 16.594a.497.497 0 0 1-.712-.001l-.7-.7a.509.509 0 0 1-.002-.713l4.387-4.387-2.436-2.436C9.159 8.159 9.225 8 9.503 8h5.994c.27 0 .503.225.503.503v5.994c0 .27-.16.343-.357.146l-2.436-2.436z",
                        fill: "currentColor",
                        fillRule: "evenodd",
                        role: "presentation"
                    }));
                };
            }
        } ]), _class;
    }(_Icon3.default);
    _class.displayName = "EditorOpenIcon", exports.default = _class;
}, /* 90 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _extends2 = __webpack_require__(19), _extends3 = _interopRequireDefault(_extends2), _getPrototypeOf = __webpack_require__(4), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(5), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(6), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(7), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(8), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(9), _react2 = _interopRequireDefault(_react), _Icon2 = __webpack_require__(2), _Icon3 = _interopRequireDefault(_Icon2), _class = function(_Icon) {
        function _class() {
            return (0, _classCallCheck3.default)(this, _class), (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, 
            _getPrototypeOf2.default)(_class)).apply(this, arguments));
        }
        return (0, _inherits3.default)(_class, _Icon), (0, _createClass3.default)(_class, [ {
            key: "getGlyphTemplate",
            value: function() {
                return function(props) {
                    var title = props.label, iconProps = (0, _extends3.default)({}, props);
                    // eslint-disable-next-line max-len, react/jsx-space-before-closing
                    return delete iconProps.label, _react2.default.createElement("svg", (0, _extends3.default)({
                        width: "24",
                        height: "24",
                        viewBox: "0 0 24 24",
                        focusable: "false"
                    }, iconProps, {
                        "aria-labelledby": "title-7w5w765"
                    }), _react2.default.createElement("title", {
                        id: "title-7w5w765"
                    }, title), _react2.default.createElement("path", {
                        d: "M9 9V7l-3 3 3 3v-2h2.51a.49.49 0 0 0 .49-.505v-.99A.495.495 0 0 0 11.51 9H9zm4-1.495c0-.279.228-.505.491-.505h5.018a.49.49 0 0 1 .491.505v.99a.503.503 0 0 1-.491.505h-5.018A.49.49 0 0 1 13 8.495v-.99zm0 4c0-.279.228-.505.491-.505h5.018a.49.49 0 0 1 .491.505v.99a.503.503 0 0 1-.491.505h-5.018a.49.49 0 0 1-.491-.505v-.99zm-6 4c0-.279.229-.505.5-.505h11c.276 0 .5.214.5.505v.99a.506.506 0 0 1-.5.505h-11a.495.495 0 0 1-.5-.505v-.99z",
                        fill: "currentColor",
                        fillRule: "evenodd",
                        role: "presentation"
                    }));
                };
            }
        } ]), _class;
    }(_Icon3.default);
    _class.displayName = "EditorOutdentIcon", exports.default = _class;
}, /* 91 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _extends2 = __webpack_require__(19), _extends3 = _interopRequireDefault(_extends2), _getPrototypeOf = __webpack_require__(4), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(5), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(6), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(7), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(8), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(9), _react2 = _interopRequireDefault(_react), _Icon2 = __webpack_require__(2), _Icon3 = _interopRequireDefault(_Icon2), _class = function(_Icon) {
        function _class() {
            return (0, _classCallCheck3.default)(this, _class), (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, 
            _getPrototypeOf2.default)(_class)).apply(this, arguments));
        }
        return (0, _inherits3.default)(_class, _Icon), (0, _createClass3.default)(_class, [ {
            key: "getGlyphTemplate",
            value: function() {
                return function(props) {
                    var title = props.label, iconProps = (0, _extends3.default)({}, props);
                    // eslint-disable-next-line max-len, react/jsx-space-before-closing
                    return delete iconProps.label, _react2.default.createElement("svg", (0, _extends3.default)({
                        width: "24",
                        height: "24",
                        viewBox: "0 0 24 24",
                        focusable: "false"
                    }, iconProps, {
                        "aria-labelledby": "title-g63hytl"
                    }), _react2.default.createElement("title", {
                        id: "title-g63hytl"
                    }, title), _react2.default.createElement("path", {
                        d: "M12 19a7 7 0 1 0 0-14 7 7 0 0 0 0 14zm1-6.208v2.71a.494.494 0 0 1-.505.498h-.99a.496.496 0 0 1-.505-.498v-2.71c.306.134.644.208 1 .208s.694-.074 1-.208zM12 11a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z",
                        fill: "currentColor",
                        fillRule: "evenodd",
                        role: "presentation"
                    }));
                };
            }
        } ]), _class;
    }(_Icon3.default);
    _class.displayName = "EditorPanelIcon", exports.default = _class;
}, /* 92 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _extends2 = __webpack_require__(19), _extends3 = _interopRequireDefault(_extends2), _getPrototypeOf = __webpack_require__(4), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(5), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(6), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(7), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(8), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(9), _react2 = _interopRequireDefault(_react), _Icon2 = __webpack_require__(2), _Icon3 = _interopRequireDefault(_Icon2), _class = function(_Icon) {
        function _class() {
            return (0, _classCallCheck3.default)(this, _class), (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, 
            _getPrototypeOf2.default)(_class)).apply(this, arguments));
        }
        return (0, _inherits3.default)(_class, _Icon), (0, _createClass3.default)(_class, [ {
            key: "getGlyphTemplate",
            value: function() {
                return function(props) {
                    var title = props.label, iconProps = (0, _extends3.default)({}, props);
                    // eslint-disable-next-line max-len, react/jsx-space-before-closing
                    return delete iconProps.label, _react2.default.createElement("svg", (0, _extends3.default)({
                        width: "24",
                        height: "24",
                        viewBox: "0 0 24 24",
                        focusable: "false"
                    }, iconProps, {
                        "aria-labelledby": "title-nry2mod"
                    }), _react2.default.createElement("title", {
                        id: "title-nry2mod"
                    }, title), _react2.default.createElement("path", {
                        d: "M5 8.51c0-.282.22-.51.498-.51h13.004c.275 0 .498.228.498.51v8.98c0 .282-.22.51-.498.51H5.498A.504.504 0 0 1 5 17.49V8.51zm5-1.01c0-.276.215-.5.49-.5h3.02a.5.5 0 0 1 .49.5V8h-4v-.5zm2 9a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7zm0-1.5a2 2 0 1 0 0-4 2 2 0 0 0 0 4z",
                        fill: "currentColor",
                        fillRule: "evenodd",
                        role: "presentation"
                    }));
                };
            }
        } ]), _class;
    }(_Icon3.default);
    _class.displayName = "EditorPhotoIcon", exports.default = _class;
}, /* 93 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _extends2 = __webpack_require__(19), _extends3 = _interopRequireDefault(_extends2), _getPrototypeOf = __webpack_require__(4), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(5), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(6), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(7), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(8), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(9), _react2 = _interopRequireDefault(_react), _Icon2 = __webpack_require__(2), _Icon3 = _interopRequireDefault(_Icon2), _class = function(_Icon) {
        function _class() {
            return (0, _classCallCheck3.default)(this, _class), (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, 
            _getPrototypeOf2.default)(_class)).apply(this, arguments));
        }
        return (0, _inherits3.default)(_class, _Icon), (0, _createClass3.default)(_class, [ {
            key: "getGlyphTemplate",
            value: function() {
                return function(props) {
                    var title = props.label, iconProps = (0, _extends3.default)({}, props);
                    // eslint-disable-next-line max-len, react/jsx-space-before-closing
                    return delete iconProps.label, _react2.default.createElement("svg", (0, _extends3.default)({
                        width: "24",
                        height: "24",
                        viewBox: "0 0 24 24",
                        focusable: "false"
                    }, iconProps, {
                        "aria-labelledby": "title-80bdpp8"
                    }), _react2.default.createElement("title", {
                        id: "title-80bdpp8"
                    }, title), _react2.default.createElement("path", {
                        d: "M12.75 11.69l1.78 1.78a.75.75 0 0 1-1.06 1.06l-2-2a.748.748 0 0 1-.22-.53V9a.75.75 0 0 1 1.5 0v2.69zM12 6a6 6 0 1 0 0 12 6 6 0 0 0 0-12z",
                        fill: "currentColor",
                        fillRule: "evenodd",
                        role: "presentation"
                    }));
                };
            }
        } ]), _class;
    }(_Icon3.default);
    _class.displayName = "EditorRecentIcon", exports.default = _class;
}, /* 94 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _extends2 = __webpack_require__(19), _extends3 = _interopRequireDefault(_extends2), _getPrototypeOf = __webpack_require__(4), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(5), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(6), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(7), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(8), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(9), _react2 = _interopRequireDefault(_react), _Icon2 = __webpack_require__(2), _Icon3 = _interopRequireDefault(_Icon2), _class = function(_Icon) {
        function _class() {
            return (0, _classCallCheck3.default)(this, _class), (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, 
            _getPrototypeOf2.default)(_class)).apply(this, arguments));
        }
        return (0, _inherits3.default)(_class, _Icon), (0, _createClass3.default)(_class, [ {
            key: "getGlyphTemplate",
            value: function() {
                return function(props) {
                    var title = props.label, iconProps = (0, _extends3.default)({}, props);
                    // eslint-disable-next-line max-len, react/jsx-space-before-closing
                    return delete iconProps.label, _react2.default.createElement("svg", (0, _extends3.default)({
                        width: "24",
                        height: "24",
                        viewBox: "0 0 24 24",
                        focusable: "false"
                    }, iconProps, {
                        "aria-labelledby": "title-d1qf1yq"
                    }), _react2.default.createElement("title", {
                        id: "title-d1qf1yq"
                    }, title), _react2.default.createElement("path", {
                        d: "M16.702 11.658C15.714 10.055 14.037 9 12.133 9c-3.037 0-5.492 2.686-5.5 6h1.5c0-2.513 1.821-4.5 4-4.5 1.337 0 2.54.749 3.27 1.908l-2.03 1.172c-.24.139-.219.325.03.41l2.73.93V15v-.08l1.372.467a.422.422 0 0 0 .56-.323l.84-4.251c.052-.266-.107-.365-.341-.23l-1.862 1.075z",
                        fill: "currentColor",
                        fillRule: "evenodd",
                        role: "presentation"
                    }));
                };
            }
        } ]), _class;
    }(_Icon3.default);
    _class.displayName = "EditorRedoIcon", exports.default = _class;
}, /* 95 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _extends2 = __webpack_require__(19), _extends3 = _interopRequireDefault(_extends2), _getPrototypeOf = __webpack_require__(4), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(5), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(6), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(7), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(8), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(9), _react2 = _interopRequireDefault(_react), _Icon2 = __webpack_require__(2), _Icon3 = _interopRequireDefault(_Icon2), _class = function(_Icon) {
        function _class() {
            return (0, _classCallCheck3.default)(this, _class), (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, 
            _getPrototypeOf2.default)(_class)).apply(this, arguments));
        }
        return (0, _inherits3.default)(_class, _Icon), (0, _createClass3.default)(_class, [ {
            key: "getGlyphTemplate",
            value: function() {
                return function(props) {
                    var title = props.label, iconProps = (0, _extends3.default)({}, props);
                    // eslint-disable-next-line max-len, react/jsx-space-before-closing
                    return delete iconProps.label, _react2.default.createElement("svg", (0, _extends3.default)({
                        width: "24",
                        height: "24",
                        viewBox: "0 0 24 24",
                        focusable: "false"
                    }, iconProps, {
                        "aria-labelledby": "title-u7h8t0f"
                    }), _react2.default.createElement("title", {
                        id: "title-u7h8t0f"
                    }, title), _react2.default.createElement("path", {
                        d: "M16.778 10l-1.67 7.516a.65.65 0 0 1-.599.484H9.491a.649.649 0 0 1-.599-.484L7.222 10h9.556zM6 7.505C6 7.226 6.229 7 6.5 7h11c.276 0 .5.214.5.505v.99a.506.506 0 0 1-.5.505h-11a.495.495 0 0 1-.5-.505v-.99zM10 6.5c0-.276.215-.5.49-.5h3.02a.5.5 0 0 1 .49.5V7h-4v-.5z",
                        fill: "currentColor",
                        fillRule: "evenodd",
                        role: "presentation"
                    }));
                };
            }
        } ]), _class;
    }(_Icon3.default);
    _class.displayName = "EditorRemoveIcon", exports.default = _class;
}, /* 96 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _extends2 = __webpack_require__(19), _extends3 = _interopRequireDefault(_extends2), _getPrototypeOf = __webpack_require__(4), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(5), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(6), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(7), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(8), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(9), _react2 = _interopRequireDefault(_react), _Icon2 = __webpack_require__(2), _Icon3 = _interopRequireDefault(_Icon2), _class = function(_Icon) {
        function _class() {
            return (0, _classCallCheck3.default)(this, _class), (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, 
            _getPrototypeOf2.default)(_class)).apply(this, arguments));
        }
        return (0, _inherits3.default)(_class, _Icon), (0, _createClass3.default)(_class, [ {
            key: "getGlyphTemplate",
            value: function() {
                return function(props) {
                    var title = props.label, iconProps = (0, _extends3.default)({}, props);
                    // eslint-disable-next-line max-len, react/jsx-space-before-closing
                    return delete iconProps.label, _react2.default.createElement("svg", (0, _extends3.default)({
                        width: "24",
                        height: "24",
                        viewBox: "0 0 24 24",
                        focusable: "false"
                    }, iconProps, {
                        "aria-labelledby": "title-euc7lqg"
                    }), _react2.default.createElement("title", {
                        id: "title-euc7lqg"
                    }, title), _react2.default.createElement("path", {
                        d: "M15.883 14.823l2.647 2.647c.293.293.53.59 0 1.06-.53.47-.767.293-1.06 0l-2.647-2.647a5.5 5.5 0 1 1 1.06-1.06zM11.5 15.5a4 4 0 1 0 0-8 4 4 0 0 0 0 8z",
                        fill: "currentColor",
                        fillRule: "evenodd",
                        role: "presentation"
                    }));
                };
            }
        } ]), _class;
    }(_Icon3.default);
    _class.displayName = "EditorSearchIcon", exports.default = _class;
}, /* 97 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _extends2 = __webpack_require__(19), _extends3 = _interopRequireDefault(_extends2), _getPrototypeOf = __webpack_require__(4), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(5), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(6), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(7), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(8), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(9), _react2 = _interopRequireDefault(_react), _Icon2 = __webpack_require__(2), _Icon3 = _interopRequireDefault(_Icon2), _class = function(_Icon) {
        function _class() {
            return (0, _classCallCheck3.default)(this, _class), (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, 
            _getPrototypeOf2.default)(_class)).apply(this, arguments));
        }
        return (0, _inherits3.default)(_class, _Icon), (0, _createClass3.default)(_class, [ {
            key: "getGlyphTemplate",
            value: function() {
                return function(props) {
                    var title = props.label, iconProps = (0, _extends3.default)({}, props);
                    // eslint-disable-next-line max-len, react/jsx-space-before-closing
                    return delete iconProps.label, _react2.default.createElement("svg", (0, _extends3.default)({
                        width: "24",
                        height: "24",
                        viewBox: "0 0 24 24",
                        focusable: "false"
                    }, iconProps, {
                        "aria-labelledby": "title-a7yorot"
                    }), _react2.default.createElement("title", {
                        id: "title-a7yorot"
                    }, title), _react2.default.createElement("path", {
                        d: "M6 6.5c0-.276.229-.5.5-.5h11c.276 0 .5.229.5.5v11c0 .276-.229.5-.5.5h-11a.504.504 0 0 1-.5-.5v-11zM8 13h3v3H8v-3zm5-5h3v3h-3V8zm0 5h3v3h-3v-3zM8 8h3v3H8V8z",
                        fill: "currentColor",
                        fillRule: "evenodd",
                        role: "presentation"
                    }));
                };
            }
        } ]), _class;
    }(_Icon3.default);
    _class.displayName = "EditorTableIcon", exports.default = _class;
}, /* 98 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _extends2 = __webpack_require__(19), _extends3 = _interopRequireDefault(_extends2), _getPrototypeOf = __webpack_require__(4), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(5), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(6), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(7), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(8), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(9), _react2 = _interopRequireDefault(_react), _Icon2 = __webpack_require__(2), _Icon3 = _interopRequireDefault(_Icon2), _class = function(_Icon) {
        function _class() {
            return (0, _classCallCheck3.default)(this, _class), (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, 
            _getPrototypeOf2.default)(_class)).apply(this, arguments));
        }
        return (0, _inherits3.default)(_class, _Icon), (0, _createClass3.default)(_class, [ {
            key: "getGlyphTemplate",
            value: function() {
                return function(props) {
                    var title = props.label, iconProps = (0, _extends3.default)({}, props);
                    // eslint-disable-next-line max-len, react/jsx-space-before-closing
                    return delete iconProps.label, _react2.default.createElement("svg", (0, _extends3.default)({
                        width: "24",
                        height: "24",
                        viewBox: "0 0 24 24",
                        focusable: "false"
                    }, iconProps, {
                        "aria-labelledby": "title-9pj0coc"
                    }), _react2.default.createElement("title", {
                        id: "title-9pj0coc"
                    }, title), _react2.default.createElement("path", {
                        d: "M6 6.5c0-.276.229-.5.5-.5h11c.276 0 .5.229.5.5v11c0 .276-.229.5-.5.5h-11a.504.504 0 0 1-.5-.5v-11zm4.47 8.53l.592.593.524-.654 4-5a.75.75 0 0 0-1.172-.938l-3.475 4.347L9.53 11.97a.75.75 0 0 0-1.06 1.06l2 2z",
                        fill: "currentColor",
                        fillRule: "evenodd",
                        role: "presentation"
                    }));
                };
            }
        } ]), _class;
    }(_Icon3.default);
    _class.displayName = "EditorTaskIcon", exports.default = _class;
}, /* 99 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _extends2 = __webpack_require__(19), _extends3 = _interopRequireDefault(_extends2), _getPrototypeOf = __webpack_require__(4), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(5), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(6), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(7), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(8), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(9), _react2 = _interopRequireDefault(_react), _Icon2 = __webpack_require__(2), _Icon3 = _interopRequireDefault(_Icon2), _class = function(_Icon) {
        function _class() {
            return (0, _classCallCheck3.default)(this, _class), (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, 
            _getPrototypeOf2.default)(_class)).apply(this, arguments));
        }
        return (0, _inherits3.default)(_class, _Icon), (0, _createClass3.default)(_class, [ {
            key: "getGlyphTemplate",
            value: function() {
                return function(props) {
                    var title = props.label, iconProps = (0, _extends3.default)({}, props);
                    // eslint-disable-next-line max-len, react/jsx-space-before-closing
                    return delete iconProps.label, _react2.default.createElement("svg", (0, _extends3.default)({
                        width: "24",
                        height: "24",
                        viewBox: "0 0 24 24",
                        focusable: "false"
                    }, iconProps, {
                        "aria-labelledby": "title-jsifrsr"
                    }), _react2.default.createElement("title", {
                        id: "title-jsifrsr"
                    }, title), _react2.default.createElement("path", {
                        d: "M6 17.505c0-.279.229-.505.5-.505h11c.276 0 .5.214.5.505v.99a.506.506 0 0 1-.5.505h-11a.495.495 0 0 1-.5-.505v-.99zm8-4.005l1 2.5h2L13.186 6h-2.372L7 16h2l1-2.5h4zm-.5-1.5h-3s1.073-3.1 1.5-4.5l1.5 4.5z",
                        fill: "currentColor",
                        fillRule: "evenodd",
                        role: "presentation"
                    }));
                };
            }
        } ]), _class;
    }(_Icon3.default);
    _class.displayName = "EditorTextColorIcon", exports.default = _class;
}, /* 100 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _extends2 = __webpack_require__(19), _extends3 = _interopRequireDefault(_extends2), _getPrototypeOf = __webpack_require__(4), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(5), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(6), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(7), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(8), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(9), _react2 = _interopRequireDefault(_react), _Icon2 = __webpack_require__(2), _Icon3 = _interopRequireDefault(_Icon2), _class = function(_Icon) {
        function _class() {
            return (0, _classCallCheck3.default)(this, _class), (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, 
            _getPrototypeOf2.default)(_class)).apply(this, arguments));
        }
        return (0, _inherits3.default)(_class, _Icon), (0, _createClass3.default)(_class, [ {
            key: "getGlyphTemplate",
            value: function() {
                return function(props) {
                    var title = props.label, iconProps = (0, _extends3.default)({}, props);
                    // eslint-disable-next-line max-len, react/jsx-space-before-closing
                    return delete iconProps.label, _react2.default.createElement("svg", (0, _extends3.default)({
                        width: "24",
                        height: "24",
                        viewBox: "0 0 24 24",
                        focusable: "false"
                    }, iconProps, {
                        "aria-labelledby": "title-ly8gxse"
                    }), _react2.default.createElement("title", {
                        id: "title-ly8gxse"
                    }, title), _react2.default.createElement("path", {
                        d: "M7 6v5c0 2.916 1.737 5 5 5s5-2.084 5-5V6h-2v5c0 1.884-.93 3-3 3s-3-1.116-3-3V6H7zM6 17.505c0-.279.229-.505.5-.505h11c.276 0 .5.214.5.505v.99a.506.506 0 0 1-.5.505h-11a.495.495 0 0 1-.5-.505v-.99z",
                        fill: "currentColor",
                        fillRule: "evenodd",
                        role: "presentation"
                    }));
                };
            }
        } ]), _class;
    }(_Icon3.default);
    _class.displayName = "EditorUnderlineIcon", exports.default = _class;
}, /* 101 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _extends2 = __webpack_require__(19), _extends3 = _interopRequireDefault(_extends2), _getPrototypeOf = __webpack_require__(4), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(5), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(6), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(7), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(8), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(9), _react2 = _interopRequireDefault(_react), _Icon2 = __webpack_require__(2), _Icon3 = _interopRequireDefault(_Icon2), _class = function(_Icon) {
        function _class() {
            return (0, _classCallCheck3.default)(this, _class), (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, 
            _getPrototypeOf2.default)(_class)).apply(this, arguments));
        }
        return (0, _inherits3.default)(_class, _Icon), (0, _createClass3.default)(_class, [ {
            key: "getGlyphTemplate",
            value: function() {
                return function(props) {
                    var title = props.label, iconProps = (0, _extends3.default)({}, props);
                    // eslint-disable-next-line max-len, react/jsx-space-before-closing
                    return delete iconProps.label, _react2.default.createElement("svg", (0, _extends3.default)({
                        width: "24",
                        height: "24",
                        viewBox: "0 0 24 24",
                        focusable: "false"
                    }, iconProps, {
                        "aria-labelledby": "title-ix84hp4"
                    }), _react2.default.createElement("title", {
                        id: "title-ix84hp4"
                    }, title), _react2.default.createElement("path", {
                        d: "M8.931 11.658C9.92 10.055 11.596 9 13.5 9c3.038 0 5.492 2.686 5.5 6h-1.5c0-2.513-1.821-4.5-4-4.5-1.337 0-2.54.749-3.27 1.908l2.03 1.172c.24.139.22.325-.029.41l-2.73.93L9.5 15v-.08l-1.372.467a.422.422 0 0 1-.559-.323l-.84-4.251c-.053-.266.106-.365.34-.23l1.862 1.075z",
                        fill: "currentColor",
                        fillRule: "evenodd",
                        role: "presentation"
                    }));
                };
            }
        } ]), _class;
    }(_Icon3.default);
    _class.displayName = "EditorUndoIcon", exports.default = _class;
}, /* 102 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _extends2 = __webpack_require__(19), _extends3 = _interopRequireDefault(_extends2), _getPrototypeOf = __webpack_require__(4), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(5), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(6), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(7), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(8), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(9), _react2 = _interopRequireDefault(_react), _Icon2 = __webpack_require__(2), _Icon3 = _interopRequireDefault(_Icon2), _class = function(_Icon) {
        function _class() {
            return (0, _classCallCheck3.default)(this, _class), (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, 
            _getPrototypeOf2.default)(_class)).apply(this, arguments));
        }
        return (0, _inherits3.default)(_class, _Icon), (0, _createClass3.default)(_class, [ {
            key: "getGlyphTemplate",
            value: function() {
                return function(props) {
                    var title = props.label, iconProps = (0, _extends3.default)({}, props);
                    // eslint-disable-next-line max-len, react/jsx-space-before-closing
                    return delete iconProps.label, _react2.default.createElement("svg", (0, _extends3.default)({
                        width: "24",
                        height: "24",
                        viewBox: "0 0 24 24",
                        focusable: "false"
                    }, iconProps, {
                        "aria-labelledby": "title-py29t51"
                    }), _react2.default.createElement("title", {
                        id: "title-py29t51"
                    }, title), _react2.default.createElement("path", {
                        d: "M5 10h2V9H5v1zm4-5v2h1V5H9zm7.646 12.354l2 2 .708-.708-2-2-.708.708zM17 15h2v-1h-2v1zm-3 2v2h1v-2h-1zM7.354 6.646l-2-2-.708.708 2 2 .708-.708zm3.567 9.037a1.749 1.749 0 0 1-2.474-.001 1.747 1.747 0 0 1 0-2.474l1.06-1.062.703-.702c.712-.712-.268-1.692-1.06-1.06l-.703.702-1.062 1.061a3.247 3.247 0 0 0 .001 4.596 3.249 3.249 0 0 0 4.596 0l1.06-1.061a.75.75 0 1 0-1.06-1.06l-1.061 1.06zm2.658-7.608a1.749 1.749 0 0 1 2.474 0c.685.685.686 1.79 0 2.475l-1.06 1.06-.703.703c-.52.61.496 1.626 1.06 1.061l.703-.702 1.062-1.062a3.247 3.247 0 0 0-.001-4.595 3.249 3.249 0 0 0-4.596 0l-1.06 1.06a.75.75 0 0 0 1.06 1.061l1.061-1.061z",
                        fill: "currentColor",
                        fillRule: "evenodd",
                        role: "presentation"
                    }));
                };
            }
        } ]), _class;
    }(_Icon3.default);
    _class.displayName = "EditorUnlinkIcon", exports.default = _class;
}, /* 103 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _extends2 = __webpack_require__(19), _extends3 = _interopRequireDefault(_extends2), _getPrototypeOf = __webpack_require__(4), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(5), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(6), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(7), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(8), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(9), _react2 = _interopRequireDefault(_react), _Icon2 = __webpack_require__(2), _Icon3 = _interopRequireDefault(_Icon2), _class = function(_Icon) {
        function _class() {
            return (0, _classCallCheck3.default)(this, _class), (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, 
            _getPrototypeOf2.default)(_class)).apply(this, arguments));
        }
        return (0, _inherits3.default)(_class, _Icon), (0, _createClass3.default)(_class, [ {
            key: "getGlyphTemplate",
            value: function() {
                return function(props) {
                    var title = props.label, iconProps = (0, _extends3.default)({}, props);
                    // eslint-disable-next-line max-len, react/jsx-space-before-closing
                    return delete iconProps.label, _react2.default.createElement("svg", (0, _extends3.default)({
                        width: "24",
                        height: "24",
                        viewBox: "0 0 24 24",
                        focusable: "false"
                    }, iconProps, {
                        "aria-labelledby": "title-r9l3ijk"
                    }), _react2.default.createElement("title", {
                        id: "title-r9l3ijk"
                    }, title), _react2.default.createElement("path", {
                        d: "M13 14.208v-3.71a.496.496 0 0 0-.505-.498h-.99a.494.494 0 0 0-.505.498v3.71A2.492 2.492 0 0 1 12 14c.356 0 .694.074 1 .208zm-1.49-9.336c.27-.482.712-.476.98 0l8.02 14.256c.27.482.045.872-.503.872H3.993c-.548 0-.77-.396-.503-.872l8.02-14.256zM12 18a1 1 0 1 0 0-2 1 1 0 0 0 0 2z",
                        fill: "currentColor",
                        fillRule: "evenodd",
                        role: "presentation"
                    }));
                };
            }
        } ]), _class;
    }(_Icon3.default);
    _class.displayName = "EditorWarningIcon", exports.default = _class;
}, /* 104 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _extends2 = __webpack_require__(19), _extends3 = _interopRequireDefault(_extends2), _getPrototypeOf = __webpack_require__(4), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(5), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(6), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(7), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(8), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(9), _react2 = _interopRequireDefault(_react), _Icon2 = __webpack_require__(2), _Icon3 = _interopRequireDefault(_Icon2), _class = function(_Icon) {
        function _class() {
            return (0, _classCallCheck3.default)(this, _class), (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, 
            _getPrototypeOf2.default)(_class)).apply(this, arguments));
        }
        return (0, _inherits3.default)(_class, _Icon), (0, _createClass3.default)(_class, [ {
            key: "getGlyphTemplate",
            value: function() {
                return function(props) {
                    var title = props.label, iconProps = (0, _extends3.default)({}, props);
                    // eslint-disable-next-line max-len, react/jsx-space-before-closing
                    return delete iconProps.label, _react2.default.createElement("svg", (0, _extends3.default)({
                        width: "24",
                        height: "24",
                        viewBox: "0 0 24 24",
                        focusable: "false"
                    }, iconProps, {
                        "aria-labelledby": "title-0si7sal"
                    }), _react2.default.createElement("title", {
                        id: "title-0si7sal"
                    }, title), _react2.default.createElement("path", {
                        d: "M15.677 16.738A5.97 5.97 0 0 1 12 18a5.97 5.97 0 0 1-3.677-1.262 6.329 6.329 0 0 0 1.982-4.589 6.33 6.33 0 0 0-2.157-4.746A5.973 5.973 0 0 1 12 6c1.465 0 2.808.528 3.851 1.403a6.33 6.33 0 0 0-2.156 4.746c0 1.751.736 3.41 1.982 4.589zm1.354-1.472c.613-.94.969-2.063.969-3.266 0-1.124-.31-2.176-.85-3.076a4.321 4.321 0 0 0-1.455 3.225c0 1.187.495 2.313 1.336 3.117zm-10.062 0A5.964 5.964 0 0 1 6 12c0-1.124.31-2.176.85-3.076a4.324 4.324 0 0 1 1.455 3.225 4.323 4.323 0 0 1-1.336 3.117zM12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16z",
                        fill: "currentColor",
                        fillRule: "evenodd",
                        role: "presentation"
                    }));
                };
            }
        } ]), _class;
    }(_Icon3.default);
    _class.displayName = "EmojiActivityIcon", exports.default = _class;
}, /* 105 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _extends2 = __webpack_require__(19), _extends3 = _interopRequireDefault(_extends2), _getPrototypeOf = __webpack_require__(4), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(5), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(6), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(7), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(8), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(9), _react2 = _interopRequireDefault(_react), _Icon2 = __webpack_require__(2), _Icon3 = _interopRequireDefault(_Icon2), _class = function(_Icon) {
        function _class() {
            return (0, _classCallCheck3.default)(this, _class), (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, 
            _getPrototypeOf2.default)(_class)).apply(this, arguments));
        }
        return (0, _inherits3.default)(_class, _Icon), (0, _createClass3.default)(_class, [ {
            key: "getGlyphTemplate",
            value: function() {
                return function(props) {
                    var title = props.label, iconProps = (0, _extends3.default)({}, props);
                    // eslint-disable-next-line max-len, react/jsx-space-before-closing
                    return delete iconProps.label, _react2.default.createElement("svg", (0, _extends3.default)({
                        width: "24",
                        height: "24",
                        viewBox: "0 0 24 24",
                        focusable: "false"
                    }, iconProps, {
                        "aria-labelledby": "title-c27tf3y"
                    }), _react2.default.createElement("title", {
                        id: "title-c27tf3y"
                    }, title), _react2.default.createElement("path", {
                        d: "M19.91 5.197a.379.379 0 0 0-.302-.152.364.364 0 0 0-.174.044c-2.218 1.215-4.79 1.857-7.436 1.857-2.647 0-5.218-.642-7.437-1.857a.363.363 0 0 0-.174-.044.37.37 0 0 0-.232.665 13.07 13.07 0 0 0 7.842 2.61h.001a13.07 13.07 0 0 0 7.844-2.611.37.37 0 0 0 .069-.512zm-2.548 3.459a.298.298 0 0 0-.287-.042c-.643.246-1.296.433-1.892.572a.372.372 0 0 0-.26.227c-.435 1.189-1.543 2.321-2.707 3.508-.046.044-.112.102-.218.102s-.171-.056-.219-.102c-1.163-1.187-2.271-2.315-2.706-3.504a.372.372 0 0 0-.26-.227 14.684 14.684 0 0 1-1.893-.578.3.3 0 0 0-.286.041.297.297 0 0 0-.115.263c.098.989.49 1.956 1.194 2.969.663.952 1.528 1.834 2.364 2.687 1.54 1.571 2.996 3.055 3.123 4.776a.298.298 0 0 0 .297.275h1.81a.298.298 0 0 0 .297-.312c-.057-1.15-.49-2.303-1.323-3.522a12.055 12.055 0 0 0-.558-.748.216.216 0 0 1 .015-.284l.18-.185c.837-.853 1.701-1.735 2.365-2.687.705-1.013 1.095-1.974 1.194-2.963a.305.305 0 0 0-.115-.266zm-7.306 7.254a.276.276 0 0 0-.211-.09.298.298 0 0 0-.246.14c-.761 1.158-1.154 2.251-1.209 3.35a.301.301 0 0 0 .082.22.301.301 0 0 0 .217.093h1.807a.3.3 0 0 0 .297-.277c.04-.529.204-1.06.505-1.618a.419.419 0 0 0-.037-.451c-.298-.387-.663-.8-1.205-1.367zM12 9.542c.567 0 .896-.034 1.011-.034a.276.276 0 0 1 .252.385c-.075.202-.418.925-1.056 1.546a.291.291 0 0 1-.209.082.29.29 0 0 1-.209-.082c-.638-.621-.981-1.344-1.056-1.546a.276.276 0 0 1 .252-.385c.115 0 .444.034 1.01.034H12z",
                        fill: "currentColor",
                        fillRule: "evenodd",
                        role: "presentation"
                    }));
                };
            }
        } ]), _class;
    }(_Icon3.default);
    _class.displayName = "EmojiAtlassianIcon", exports.default = _class;
}, /* 106 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _extends2 = __webpack_require__(19), _extends3 = _interopRequireDefault(_extends2), _getPrototypeOf = __webpack_require__(4), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(5), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(6), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(7), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(8), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(9), _react2 = _interopRequireDefault(_react), _Icon2 = __webpack_require__(2), _Icon3 = _interopRequireDefault(_Icon2), _class = function(_Icon) {
        function _class() {
            return (0, _classCallCheck3.default)(this, _class), (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, 
            _getPrototypeOf2.default)(_class)).apply(this, arguments));
        }
        return (0, _inherits3.default)(_class, _Icon), (0, _createClass3.default)(_class, [ {
            key: "getGlyphTemplate",
            value: function() {
                return function(props) {
                    var title = props.label, iconProps = (0, _extends3.default)({}, props);
                    // eslint-disable-next-line max-len, react/jsx-space-before-closing
                    return delete iconProps.label, _react2.default.createElement("svg", (0, _extends3.default)({
                        width: "24",
                        height: "24",
                        viewBox: "0 0 24 24",
                        focusable: "false"
                    }, iconProps, {
                        "aria-labelledby": "title-g6emccp"
                    }), _react2.default.createElement("title", {
                        id: "title-g6emccp"
                    }, title), _react2.default.createElement("path", {
                        d: "M13 11V7.002a.999.999 0 1 0-2 0V11H7.002a.999.999 0 1 0 0 2H11v3.998a.999.999 0 1 0 2 0V13h3.998a.999.999 0 1 0 0-2H13z",
                        fill: "currentColor",
                        fillRule: "evenodd",
                        role: "presentation"
                    }));
                };
            }
        } ]), _class;
    }(_Icon3.default);
    _class.displayName = "EmojiCustomIcon", exports.default = _class;
}, /* 107 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _extends2 = __webpack_require__(19), _extends3 = _interopRequireDefault(_extends2), _getPrototypeOf = __webpack_require__(4), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(5), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(6), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(7), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(8), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(9), _react2 = _interopRequireDefault(_react), _Icon2 = __webpack_require__(2), _Icon3 = _interopRequireDefault(_Icon2), _class = function(_Icon) {
        function _class() {
            return (0, _classCallCheck3.default)(this, _class), (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, 
            _getPrototypeOf2.default)(_class)).apply(this, arguments));
        }
        return (0, _inherits3.default)(_class, _Icon), (0, _createClass3.default)(_class, [ {
            key: "getGlyphTemplate",
            value: function() {
                return function(props) {
                    var title = props.label, iconProps = (0, _extends3.default)({}, props);
                    // eslint-disable-next-line max-len, react/jsx-space-before-closing
                    return delete iconProps.label, _react2.default.createElement("svg", (0, _extends3.default)({
                        width: "24",
                        height: "24",
                        viewBox: "0 0 24 24",
                        focusable: "false"
                    }, iconProps, {
                        "aria-labelledby": "title-ks0t607"
                    }), _react2.default.createElement("title", {
                        id: "title-ks0t607"
                    }, title), _react2.default.createElement("path", {
                        d: "M6 12.577v6.446c0 .537.45.977 1 .977s1-.44 1-.977v-5.778c1.17-.34 2.389-.045 3.768.29.982.238 2.036.495 3.13.495a5.73 5.73 0 0 0 2.547-.567 1 1 0 0 0 .563-.9V5.808a.998.998 0 0 0-1.437-.9c-1.345.654-2.731.317-4.331-.071-1.729-.42-3.687-.895-5.678.072A1 1 0 0 0 6 5.808v6.769zm3.111-1.48c1.094 0 2.148.256 3.129.495 1.381.335 2.6.63 3.768.289V7.178c-1.488.27-2.93-.08-4.24-.398C10.389 6.445 9.17 6.148 8 6.49v4.704a6.195 6.195 0 0 1 1.111-.097z",
                        fill: "currentColor",
                        fillRule: "evenodd",
                        role: "presentation"
                    }));
                };
            }
        } ]), _class;
    }(_Icon3.default);
    _class.displayName = "EmojiFlagsIcon", exports.default = _class;
}, /* 108 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _extends2 = __webpack_require__(19), _extends3 = _interopRequireDefault(_extends2), _getPrototypeOf = __webpack_require__(4), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(5), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(6), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(7), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(8), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(9), _react2 = _interopRequireDefault(_react), _Icon2 = __webpack_require__(2), _Icon3 = _interopRequireDefault(_Icon2), _class = function(_Icon) {
        function _class() {
            return (0, _classCallCheck3.default)(this, _class), (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, 
            _getPrototypeOf2.default)(_class)).apply(this, arguments));
        }
        return (0, _inherits3.default)(_class, _Icon), (0, _createClass3.default)(_class, [ {
            key: "getGlyphTemplate",
            value: function() {
                return function(props) {
                    var title = props.label, iconProps = (0, _extends3.default)({}, props);
                    // eslint-disable-next-line max-len, react/jsx-space-before-closing
                    return delete iconProps.label, _react2.default.createElement("svg", (0, _extends3.default)({
                        width: "24",
                        height: "24",
                        viewBox: "0 0 24 24",
                        focusable: "false"
                    }, iconProps, {
                        "aria-labelledby": "title-1r64sw4"
                    }), _react2.default.createElement("title", {
                        id: "title-1r64sw4"
                    }, title), _react2.default.createElement("path", {
                        d: "M9.425 4.798v.005L9.271 7H4.995a.881.881 0 0 0-.885.999L5.319 19c.06.552.556.999 1.108.999H17.99A2.006 2.006 0 0 0 20 18v-3.99A3.998 3.998 0 0 0 16.004 10H13.56l.294-2.001c.08-.552-.3-.999-.85-.999h-1.728l.075-1.07 3.002.21a1 1 0 0 0 1.058-.928.993.993 0 0 0-.919-1.067l-4.008-.28a1 1 0 0 0-1.059.933zM18 15v-1.002A2 2 0 0 0 16.002 12h-4.004A1.993 1.993 0 0 0 10 13.998V15h8zm0 2v1h-8v-1h8zm-6.111-6.999L12 9H6l1 9h1v-3.99A4.008 4.008 0 0 1 11.889 10z",
                        fill: "currentColor",
                        fillRule: "evenodd",
                        role: "presentation"
                    }));
                };
            }
        } ]), _class;
    }(_Icon3.default);
    _class.displayName = "EmojiFoodIcon", exports.default = _class;
}, /* 109 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _extends2 = __webpack_require__(19), _extends3 = _interopRequireDefault(_extends2), _getPrototypeOf = __webpack_require__(4), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(5), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(6), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(7), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(8), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(9), _react2 = _interopRequireDefault(_react), _Icon2 = __webpack_require__(2), _Icon3 = _interopRequireDefault(_Icon2), _class = function(_Icon) {
        function _class() {
            return (0, _classCallCheck3.default)(this, _class), (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, 
            _getPrototypeOf2.default)(_class)).apply(this, arguments));
        }
        return (0, _inherits3.default)(_class, _Icon), (0, _createClass3.default)(_class, [ {
            key: "getGlyphTemplate",
            value: function() {
                return function(props) {
                    var title = props.label, iconProps = (0, _extends3.default)({}, props);
                    // eslint-disable-next-line max-len, react/jsx-space-before-closing
                    return delete iconProps.label, _react2.default.createElement("svg", (0, _extends3.default)({
                        width: "24",
                        height: "24",
                        viewBox: "0 0 24 24",
                        focusable: "false"
                    }, iconProps, {
                        "aria-labelledby": "title-96jtoyg"
                    }), _react2.default.createElement("title", {
                        id: "title-96jtoyg"
                    }, title), _react2.default.createElement("path", {
                        d: "M12 4c-4.412 0-8 3.588-8 8s3.588 8 8 8 8-3.588 8-8-3.588-8-8-8zm0 14.222A6.23 6.23 0 0 1 5.778 12 6.23 6.23 0 0 1 12 5.778 6.23 6.23 0 0 1 18.222 12 6.23 6.23 0 0 1 12 18.222zm.889-6.59V8.448c0-.489-.4-.889-.889-.889s-.889.4-.889.89v3.555c0 .248.103.471.268.633l2.195 2.194a.891.891 0 0 0 1.257 0 .891.891 0 0 0 0-1.256l-1.942-1.943z",
                        fill: "currentColor",
                        fillRule: "evenodd",
                        role: "presentation"
                    }));
                };
            }
        } ]), _class;
    }(_Icon3.default);
    _class.displayName = "EmojiFrequentIcon", exports.default = _class;
}, /* 110 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _extends2 = __webpack_require__(19), _extends3 = _interopRequireDefault(_extends2), _getPrototypeOf = __webpack_require__(4), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(5), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(6), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(7), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(8), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(9), _react2 = _interopRequireDefault(_react), _Icon2 = __webpack_require__(2), _Icon3 = _interopRequireDefault(_Icon2), _class = function(_Icon) {
        function _class() {
            return (0, _classCallCheck3.default)(this, _class), (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, 
            _getPrototypeOf2.default)(_class)).apply(this, arguments));
        }
        return (0, _inherits3.default)(_class, _Icon), (0, _createClass3.default)(_class, [ {
            key: "getGlyphTemplate",
            value: function() {
                return function(props) {
                    var title = props.label, iconProps = (0, _extends3.default)({}, props);
                    // eslint-disable-next-line max-len, react/jsx-space-before-closing
                    return delete iconProps.label, _react2.default.createElement("svg", (0, _extends3.default)({
                        width: "24",
                        height: "24",
                        viewBox: "0 0 24 24",
                        focusable: "false"
                    }, iconProps, {
                        "aria-labelledby": "title-vppaj7w"
                    }), _react2.default.createElement("title", {
                        id: "title-vppaj7w"
                    }, title), _react2.default.createElement("path", {
                        d: "M13 16h3.625l-2.5-4h1.208L12 7l-3.333 5h1.208l-2.5 4H11v2h2v-2zm4.33-2.06l1.527 2.546A1 1 0 0 1 18 18h-3c-.003 1.105-.9 2-1.998 2h-2.004A1.999 1.999 0 0 1 9 18H6a1 1 0 0 1-.857-1.514L6.67 13.94c-.6-.23-.888-1.068-.484-1.697l5-7.778c.4-.62 1.229-.62 1.628 0l5 7.778c.404.629.117 1.467-.484 1.697z",
                        fill: "currentColor",
                        fillRule: "evenodd",
                        role: "presentation"
                    }));
                };
            }
        } ]), _class;
    }(_Icon3.default);
    _class.displayName = "EmojiNatureIcon", exports.default = _class;
}, /* 111 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _extends2 = __webpack_require__(19), _extends3 = _interopRequireDefault(_extends2), _getPrototypeOf = __webpack_require__(4), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(5), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(6), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(7), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(8), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(9), _react2 = _interopRequireDefault(_react), _Icon2 = __webpack_require__(2), _Icon3 = _interopRequireDefault(_Icon2), _class = function(_Icon) {
        function _class() {
            return (0, _classCallCheck3.default)(this, _class), (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, 
            _getPrototypeOf2.default)(_class)).apply(this, arguments));
        }
        return (0, _inherits3.default)(_class, _Icon), (0, _createClass3.default)(_class, [ {
            key: "getGlyphTemplate",
            value: function() {
                return function(props) {
                    var title = props.label, iconProps = (0, _extends3.default)({}, props);
                    // eslint-disable-next-line max-len, react/jsx-space-before-closing
                    return delete iconProps.label, _react2.default.createElement("svg", (0, _extends3.default)({
                        width: "24",
                        height: "24",
                        viewBox: "0 0 24 24",
                        focusable: "false"
                    }, iconProps, {
                        "aria-labelledby": "title-d6uw9kq"
                    }), _react2.default.createElement("title", {
                        id: "title-d6uw9kq"
                    }, title), _react2.default.createElement("path", {
                        d: "M11.998 4A5.997 5.997 0 0 0 6 9.998c0 2.218 2.288 4.484 2.288 4.484.39.387.71 1.112.71 1.611 0 .499.45.907 1 .907h4c.55 0 1-.408 1-.907 0-.499.32-1.224.71-1.611 0 0 2.288-2.266 2.288-4.484A5.997 5.997 0 0 0 11.998 4m0 2a4.003 4.003 0 0 1 3.998 3.998c0 1.029-1.145 2.511-1.695 3.064-.507.501-.912 1.216-1.13 1.938h-2.346c-.217-.722-.622-1.435-1.125-1.934-.555-.557-1.7-2.039-1.7-3.068A4.003 4.003 0 0 1 11.998 6zm2.965 13c0-.55-.45-1-1-1h-4c-.55 0-1 .45-1 1v.003c0 .55.45 1 1 1h4c.55 0 1-.45 1-1V19z",
                        fill: "currentColor",
                        fillRule: "evenodd",
                        role: "presentation"
                    }));
                };
            }
        } ]), _class;
    }(_Icon3.default);
    _class.displayName = "EmojiObjectsIcon", exports.default = _class;
}, /* 112 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _extends2 = __webpack_require__(19), _extends3 = _interopRequireDefault(_extends2), _getPrototypeOf = __webpack_require__(4), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(5), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(6), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(7), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(8), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(9), _react2 = _interopRequireDefault(_react), _Icon2 = __webpack_require__(2), _Icon3 = _interopRequireDefault(_Icon2), _class = function(_Icon) {
        function _class() {
            return (0, _classCallCheck3.default)(this, _class), (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, 
            _getPrototypeOf2.default)(_class)).apply(this, arguments));
        }
        return (0, _inherits3.default)(_class, _Icon), (0, _createClass3.default)(_class, [ {
            key: "getGlyphTemplate",
            value: function() {
                return function(props) {
                    var title = props.label, iconProps = (0, _extends3.default)({}, props);
                    // eslint-disable-next-line max-len, react/jsx-space-before-closing
                    return delete iconProps.label, _react2.default.createElement("svg", (0, _extends3.default)({
                        width: "24",
                        height: "24",
                        viewBox: "0 0 24 24",
                        focusable: "false"
                    }, iconProps, {
                        "aria-labelledby": "title-33ox8ud"
                    }), _react2.default.createElement("title", {
                        id: "title-33ox8ud"
                    }, title), _react2.default.createElement("path", {
                        d: "M12 4c-4.412 0-8 3.588-8 8s3.588 8 8 8 8-3.588 8-8-3.588-8-8-8zm0 14.222A6.23 6.23 0 0 1 5.778 12 6.23 6.23 0 0 1 12 5.778 6.23 6.23 0 0 1 18.222 12 6.23 6.23 0 0 1 12 18.222zM14.83 14a3.001 3.001 0 0 1-5.66 0h5.66zM14 11a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm-4 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2z",
                        fill: "currentColor",
                        fillRule: "evenodd",
                        role: "presentation"
                    }));
                };
            }
        } ]), _class;
    }(_Icon3.default);
    _class.displayName = "EmojiPeopleIcon", exports.default = _class;
}, /* 113 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _extends2 = __webpack_require__(19), _extends3 = _interopRequireDefault(_extends2), _getPrototypeOf = __webpack_require__(4), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(5), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(6), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(7), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(8), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(9), _react2 = _interopRequireDefault(_react), _Icon2 = __webpack_require__(2), _Icon3 = _interopRequireDefault(_Icon2), _class = function(_Icon) {
        function _class() {
            return (0, _classCallCheck3.default)(this, _class), (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, 
            _getPrototypeOf2.default)(_class)).apply(this, arguments));
        }
        return (0, _inherits3.default)(_class, _Icon), (0, _createClass3.default)(_class, [ {
            key: "getGlyphTemplate",
            value: function() {
                return function(props) {
                    var title = props.label, iconProps = (0, _extends3.default)({}, props);
                    // eslint-disable-next-line max-len, react/jsx-space-before-closing
                    return delete iconProps.label, _react2.default.createElement("svg", (0, _extends3.default)({
                        width: "24",
                        height: "24",
                        viewBox: "0 0 24 24",
                        focusable: "false"
                    }, iconProps, {
                        "aria-labelledby": "title-i536ekp"
                    }), _react2.default.createElement("title", {
                        id: "title-i536ekp"
                    }, title), _react2.default.createElement("path", {
                        d: "M12.036 9.5l1.767-1.767a2.5 2.5 0 1 1 3.536 3.535l-5.303 5.303-5.303-5.303a2.5 2.5 0 1 1 3.535-3.536L12.036 9.5zM5.32 12.685l.004.004 6.35 6.35a.508.508 0 0 0 .72 0l6.351-6.35.004-.004.003-.003a4.5 4.5 0 0 0-6.364-6.364l-.003.003-.004.004-.346.347-.347-.347-.004-.004-.003-.003a4.5 4.5 0 1 0-6.364 6.364l.003.003z",
                        fill: "currentColor",
                        fillRule: "evenodd",
                        role: "presentation"
                    }));
                };
            }
        } ]), _class;
    }(_Icon3.default);
    _class.displayName = "EmojiSymbolsIcon", exports.default = _class;
}, /* 114 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _extends2 = __webpack_require__(19), _extends3 = _interopRequireDefault(_extends2), _getPrototypeOf = __webpack_require__(4), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(5), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(6), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(7), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(8), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(9), _react2 = _interopRequireDefault(_react), _Icon2 = __webpack_require__(2), _Icon3 = _interopRequireDefault(_Icon2), _class = function(_Icon) {
        function _class() {
            return (0, _classCallCheck3.default)(this, _class), (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, 
            _getPrototypeOf2.default)(_class)).apply(this, arguments));
        }
        return (0, _inherits3.default)(_class, _Icon), (0, _createClass3.default)(_class, [ {
            key: "getGlyphTemplate",
            value: function() {
                return function(props) {
                    var title = props.label, iconProps = (0, _extends3.default)({}, props);
                    // eslint-disable-next-line max-len, react/jsx-space-before-closing
                    return delete iconProps.label, _react2.default.createElement("svg", (0, _extends3.default)({
                        width: "24",
                        height: "24",
                        viewBox: "0 0 24 24",
                        focusable: "false"
                    }, iconProps, {
                        "aria-labelledby": "title-kcg5jip"
                    }), _react2.default.createElement("title", {
                        id: "title-kcg5jip"
                    }, title), _react2.default.createElement("path", {
                        d: "M15.584 17H8.416l-2.708 2.709a1.004 1.004 0 0 1-1.415 0l-.002-.002a1.004 1.004 0 0 1 0-1.415l1.618-1.617A1.998 1.998 0 0 1 5 14.997V6.003C5 4.897 5.897 4 7.006 4h9.988C18.102 4 19 4.894 19 6.003v8.994a2 2 0 0 1-.909 1.678l1.618 1.617a1.004 1.004 0 0 1 0 1.415 1.004 1.004 0 0 1-1.417.002L15.584 17zM17 10V6H7v4h10zm0 2v3H7v-3h10zm-1.5 6.997c0 .55-.45 1-1 1h-5c-.55 0-1-.45-1-1s.45-1 1-1h5c.55 0 1 .45 1 1zm.2-5.517a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm-6.691 1a1 1 0 1 1 0-2 1 1 0 0 1 0 2z",
                        fill: "currentColor",
                        fillRule: "evenodd",
                        role: "presentation"
                    }));
                };
            }
        } ]), _class;
    }(_Icon3.default);
    _class.displayName = "EmojiTravelIcon", exports.default = _class;
}, /* 115 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _extends2 = __webpack_require__(19), _extends3 = _interopRequireDefault(_extends2), _getPrototypeOf = __webpack_require__(4), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(5), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(6), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(7), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(8), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(9), _react2 = _interopRequireDefault(_react), _Icon2 = __webpack_require__(2), _Icon3 = _interopRequireDefault(_Icon2), _class = function(_Icon) {
        function _class() {
            return (0, _classCallCheck3.default)(this, _class), (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, 
            _getPrototypeOf2.default)(_class)).apply(this, arguments));
        }
        return (0, _inherits3.default)(_class, _Icon), (0, _createClass3.default)(_class, [ {
            key: "getGlyphTemplate",
            value: function() {
                return function(props) {
                    var title = props.label, iconProps = (0, _extends3.default)({}, props);
                    // eslint-disable-next-line max-len, react/jsx-space-before-closing
                    return delete iconProps.label, _react2.default.createElement("svg", (0, _extends3.default)({
                        width: "12",
                        height: "12",
                        viewBox: "0 0 12 12",
                        focusable: "false"
                    }, iconProps, {
                        "aria-labelledby": "title-2xiy8l4"
                    }), _react2.default.createElement("title", {
                        id: "title-2xiy8l4"
                    }, title), _react2.default.createElement("g", {
                        fill: "currentColor",
                        fillRule: "evenodd"
                    }, _react2.default.createElement("path", {
                        d: "M6 0a6 6 0 1 0 0 12A6 6 0 0 0 6 0z",
                        fill: "inherit",
                        role: "presentation"
                    }), _react2.default.createElement("path", {
                        d: "M8.65 7.59a.75.75 0 1 1-1.06 1.061L6 7.061 4.407 8.65a.748.748 0 0 1-1.06 0 .75.75 0 0 1 0-1.06L4.937 6l-1.59-1.59a.75.75 0 0 1 1.06-1.061l1.591 1.59L7.59 3.35a.75.75 0 1 1 1.06 1.06L7.06 6l1.59 1.59z",
                        fill: "#fff",
                        role: "presentation"
                    })));
                };
            }
        } ]), _class;
    }(_Icon3.default);
    _class.displayName = "ErrorIcon", exports.default = _class;
}, /* 116 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _extends2 = __webpack_require__(19), _extends3 = _interopRequireDefault(_extends2), _getPrototypeOf = __webpack_require__(4), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(5), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(6), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(7), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(8), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(9), _react2 = _interopRequireDefault(_react), _Icon2 = __webpack_require__(2), _Icon3 = _interopRequireDefault(_Icon2), _class = function(_Icon) {
        function _class() {
            return (0, _classCallCheck3.default)(this, _class), (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, 
            _getPrototypeOf2.default)(_class)).apply(this, arguments));
        }
        return (0, _inherits3.default)(_class, _Icon), (0, _createClass3.default)(_class, [ {
            key: "getGlyphTemplate",
            value: function() {
                return function(props) {
                    var title = props.label, iconProps = (0, _extends3.default)({}, props);
                    // eslint-disable-next-line max-len, react/jsx-space-before-closing
                    return delete iconProps.label, _react2.default.createElement("svg", (0, _extends3.default)({
                        width: "20",
                        height: "20",
                        viewBox: "0 0 20 20",
                        focusable: "false"
                    }, iconProps, {
                        "aria-labelledby": "title-9q54vyo"
                    }), _react2.default.createElement("title", {
                        id: "title-9q54vyo"
                    }, title), _react2.default.createElement("path", {
                        d: "M12.584 8.376l-3 2h.832l-3-2a.75.75 0 0 0-.832 1.248l3 2 .416.277.416-.277 3-2a.75.75 0 1 0-.832-1.248z",
                        fill: "currentColor",
                        fillRule: "evenodd",
                        role: "presentation"
                    }));
                };
            }
        } ]), _class;
    }(_Icon3.default);
    _class.displayName = "ExpandIcon", exports.default = _class;
}, /* 117 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _extends2 = __webpack_require__(19), _extends3 = _interopRequireDefault(_extends2), _getPrototypeOf = __webpack_require__(4), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(5), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(6), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(7), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(8), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(9), _react2 = _interopRequireDefault(_react), _Icon2 = __webpack_require__(2), _Icon3 = _interopRequireDefault(_Icon2), _class = function(_Icon) {
        function _class() {
            return (0, _classCallCheck3.default)(this, _class), (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, 
            _getPrototypeOf2.default)(_class)).apply(this, arguments));
        }
        return (0, _inherits3.default)(_class, _Icon), (0, _createClass3.default)(_class, [ {
            key: "getGlyphTemplate",
            value: function() {
                return function(props) {
                    var title = props.label, iconProps = (0, _extends3.default)({}, props);
                    // eslint-disable-next-line max-len, react/jsx-space-before-closing
                    return delete iconProps.label, _react2.default.createElement("svg", (0, _extends3.default)({
                        width: "20",
                        height: "20",
                        viewBox: "0 0 20 20",
                        focusable: "false"
                    }, iconProps, {
                        "aria-labelledby": "title-fv6unvw"
                    }), _react2.default.createElement("title", {
                        id: "title-fv6unvw"
                    }, title), _react2.default.createElement("path", {
                        d: "M3.485 10.54l-.547-.199C2.418 10.151 2 9.552 2 9c0-.556.42-1.153.938-1.341l9.124-3.318c.52-.19.938.105.938.654v8.01c0 .54-.42.842-.938.654l-3.03-1.102-5.547-2.017zM6 12.955V14c0 .552-.405 1.202-.895 1.447l-.21.106C4.4 15.8 4 15.549 4 15.009v-2.782l2 .728zm9.224-5.508l2-1a.5.5 0 0 0-.448-.894l-2 1a.5.5 0 0 0 .448.894zm-.448 4l2 1a.5.5 0 1 0 .448-.894l-2-1a.5.5 0 1 0-.448.894zM15 9.5h3a.5.5 0 1 0 0-1h-3a.5.5 0 1 0 0 1z",
                        fill: "currentColor",
                        fillRule: "evenodd",
                        role: "presentation"
                    }));
                };
            }
        } ]), _class;
    }(_Icon3.default);
    _class.displayName = "FeedbackIcon", exports.default = _class;
}, /* 118 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _extends2 = __webpack_require__(19), _extends3 = _interopRequireDefault(_extends2), _getPrototypeOf = __webpack_require__(4), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(5), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(6), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(7), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(8), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(9), _react2 = _interopRequireDefault(_react), _Icon2 = __webpack_require__(2), _Icon3 = _interopRequireDefault(_Icon2), _class = function(_Icon) {
        function _class() {
            return (0, _classCallCheck3.default)(this, _class), (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, 
            _getPrototypeOf2.default)(_class)).apply(this, arguments));
        }
        return (0, _inherits3.default)(_class, _Icon), (0, _createClass3.default)(_class, [ {
            key: "getGlyphTemplate",
            value: function() {
                return function(props) {
                    var title = props.label, iconProps = (0, _extends3.default)({}, props);
                    // eslint-disable-next-line max-len, react/jsx-space-before-closing
                    return delete iconProps.label, _react2.default.createElement("svg", (0, _extends3.default)({
                        width: "18",
                        height: "18",
                        viewBox: "11 11 18 18",
                        focusable: "false"
                    }, iconProps, {
                        "aria-labelledby": "title-dtbdv4c"
                    }), _react2.default.createElement("title", {
                        id: "title-dtbdv4c"
                    }, title), _react2.default.createElement("path", {
                        d: "M11 20a9 9 0 1 0 18 0 9 9 0 0 0-18 0zm8.858 5.25h-.047c-.733-.023-1.251-.563-1.23-1.286.021-.71.55-1.227 1.26-1.227l.043.001c.753.022 1.265.557 1.244 1.3-.022.713-.542 1.211-1.27 1.211zm3.086-6.124c-.173.244-.552.55-1.03.922l-.527.363c-.288.225-.463.437-.527.645-.053.163-.077.207-.082.54v.084h-2.01l.005-.17c.025-.698.042-1.11.332-1.45.454-.533 1.457-1.18 1.5-1.207a1.56 1.56 0 0 0 .355-.363c.21-.292.304-.52.304-.744a1.45 1.45 0 0 0-.275-.858c-.176-.25-.51-.374-.995-.374-.48 0-.809.152-1.005.465-.202.32-.304.657-.304 1v.087h-2.073l.004-.09c.053-1.268.507-2.183 1.345-2.716.528-.338 1.185-.51 1.95-.51 1.002 0 1.85.244 2.515.724.676.486 1.018 1.216 1.018 2.166 0 .532-.168 1.032-.5 1.486z",
                        fill: "currentColor",
                        fillRule: "evenodd",
                        role: "presentation"
                    }));
                };
            }
        } ]), _class;
    }(_Icon3.default);
    _class.displayName = "HelpIcon", exports.default = _class;
}, /* 119 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _extends2 = __webpack_require__(19), _extends3 = _interopRequireDefault(_extends2), _getPrototypeOf = __webpack_require__(4), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(5), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(6), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(7), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(8), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(9), _react2 = _interopRequireDefault(_react), _Icon2 = __webpack_require__(2), _Icon3 = _interopRequireDefault(_Icon2), _class = function(_Icon) {
        function _class() {
            return (0, _classCallCheck3.default)(this, _class), (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, 
            _getPrototypeOf2.default)(_class)).apply(this, arguments));
        }
        return (0, _inherits3.default)(_class, _Icon), (0, _createClass3.default)(_class, [ {
            key: "getGlyphTemplate",
            value: function() {
                return function(props) {
                    var title = props.label, iconProps = (0, _extends3.default)({}, props);
                    // eslint-disable-next-line max-len, react/jsx-space-before-closing
                    return delete iconProps.label, _react2.default.createElement("svg", (0, _extends3.default)({
                        width: "32",
                        height: "30",
                        viewBox: "4 5 32 30",
                        focusable: "false"
                    }, iconProps, {
                        "aria-labelledby": "title-ig9v4wx"
                    }), _react2.default.createElement("title", {
                        id: "title-ig9v4wx"
                    }, title), _react2.default.createElement("path", {
                        d: "M20 35c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15-8.284 0-15 6.716-15 15 0 8.284 6.716 15 15 15zm-8-15.5c0-.276.153-.653.354-.854l7.292-7.292a.496.496 0 0 1 .708 0l7.292 7.292c.195.195.354.585.354.854v7c0 .276-.228.5-.491.5h-5.018a.488.488 0 0 1-.491-.49V23s-1-1-2-1-2 1-2 1v3.51c0 .27-.228.49-.491.49h-5.018a.5.5 0 0 1-.491-.5v-7z",
                        fill: "currentColor",
                        fillRule: "evenodd",
                        role: "presentation"
                    }));
                };
            }
        } ]), _class;
    }(_Icon3.default);
    _class.displayName = "HomeIcon", exports.default = _class;
}, /* 120 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _extends2 = __webpack_require__(19), _extends3 = _interopRequireDefault(_extends2), _getPrototypeOf = __webpack_require__(4), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(5), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(6), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(7), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(8), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(9), _react2 = _interopRequireDefault(_react), _Icon2 = __webpack_require__(2), _Icon3 = _interopRequireDefault(_Icon2), _class = function(_Icon) {
        function _class() {
            return (0, _classCallCheck3.default)(this, _class), (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, 
            _getPrototypeOf2.default)(_class)).apply(this, arguments));
        }
        return (0, _inherits3.default)(_class, _Icon), (0, _createClass3.default)(_class, [ {
            key: "getGlyphTemplate",
            value: function() {
                return function(props) {
                    var title = props.label, iconProps = (0, _extends3.default)({}, props);
                    // eslint-disable-next-line max-len, react/jsx-space-before-closing
                    return delete iconProps.label, _react2.default.createElement("svg", (0, _extends3.default)({
                        width: "20",
                        height: "27",
                        viewBox: "10 6 20 27",
                        focusable: "false"
                    }, iconProps, {
                        "aria-labelledby": "title-ti5fjku"
                    }), _react2.default.createElement("title", {
                        id: "title-ti5fjku"
                    }, title), _react2.default.createElement("path", {
                        d: "M14.25 7.578c-.944 0-1.709.772-1.709 1.73 0 .954.765 1.73 1.71 1.73a1.72 1.72 0 0 0 1.71-1.73c0-.958-.765-1.73-1.71-1.73zm11.233 0c-.945 0-1.71.772-1.71 1.73 0 .954.765 1.73 1.71 1.73a1.72 1.72 0 0 0 1.71-1.73 1.72 1.72 0 0 0-1.71-1.73zM19.867 6c-.945 0-1.71.772-1.71 1.73 0 .954.765 1.73 1.71 1.73a1.72 1.72 0 0 0 1.71-1.73c0-.958-.765-1.73-1.71-1.73zm9.658 6.397a.534.534 0 0 0-.517-.075 26.185 26.185 0 0 1-3.406 1.04.672.672 0 0 0-.469.413c-.781 2.165-2.778 4.225-4.872 6.384-.084.08-.202.187-.393.187-.192 0-.308-.103-.394-.187-2.094-2.159-4.09-4.212-4.872-6.377a.673.673 0 0 0-.469-.413 26.223 26.223 0 0 1-3.408-1.05.534.534 0 0 0-.723.552c.178 1.8.881 3.56 2.151 5.403 1.194 1.734 2.75 3.338 4.256 4.89 2.774 2.86 5.394 5.56 5.623 8.691a.539.539 0 0 0 .535.502h3.258a.534.534 0 0 0 .389-.169.544.544 0 0 0 .147-.4c-.103-2.093-.882-4.19-2.384-6.409a21.895 21.895 0 0 0-1.003-1.36A.396.396 0 0 1 23 23.5l.326-.337c1.506-1.552 3.062-3.156 4.256-4.89 1.27-1.844 1.973-3.593 2.15-5.392a.558.558 0 0 0-.207-.485zM16.37 25.6a.494.494 0 0 0-.38-.165.535.535 0 0 0-.443.254c-1.37 2.108-2.078 4.098-2.176 6.097a.54.54 0 0 0 .537.57h3.253c.28 0 .516-.22.537-.503.07-.963.367-1.93.908-2.944a.77.77 0 0 0-.066-.822c-.537-.705-1.193-1.457-2.17-2.487zm3.5-11.59c1.02 0 1.613-.061 1.821-.061a.5.5 0 0 1 .453.701c-.135.366-.752 1.683-1.902 2.812a.52.52 0 0 1-.375.15h-.001a.52.52 0 0 1-.376-.15c-1.149-1.13-1.766-2.446-1.901-2.812a.5.5 0 0 1 .453-.701c.208 0 .8.062 1.82.062h.008z",
                        fill: "currentColor",
                        fillRule: "evenodd",
                        role: "presentation"
                    }));
                };
            }
        } ]), _class;
    }(_Icon3.default);
    _class.displayName = "JiraLogoIcon", exports.default = _class;
}, /* 121 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _extends2 = __webpack_require__(19), _extends3 = _interopRequireDefault(_extends2), _getPrototypeOf = __webpack_require__(4), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(5), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(6), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(7), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(8), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(9), _react2 = _interopRequireDefault(_react), _Icon2 = __webpack_require__(2), _Icon3 = _interopRequireDefault(_Icon2), _class = function(_Icon) {
        function _class() {
            return (0, _classCallCheck3.default)(this, _class), (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, 
            _getPrototypeOf2.default)(_class)).apply(this, arguments));
        }
        return (0, _inherits3.default)(_class, _Icon), (0, _createClass3.default)(_class, [ {
            key: "getGlyphTemplate",
            value: function() {
                return function(props) {
                    var title = props.label, iconProps = (0, _extends3.default)({}, props);
                    // eslint-disable-next-line max-len, react/jsx-space-before-closing
                    return delete iconProps.label, _react2.default.createElement("svg", (0, _extends3.default)({
                        width: "20",
                        height: "20",
                        viewBox: "0 0 20 20",
                        focusable: "false"
                    }, iconProps, {
                        "aria-labelledby": "title-mr1l7ip"
                    }), _react2.default.createElement("title", {
                        id: "title-mr1l7ip"
                    }, title), _react2.default.createElement("path", {
                        d: "M6 10c0-.552-.195-1.023-.586-1.414A1.927 1.927 0 0 0 4 8c-.552 0-1.023.195-1.414.586C2.196 8.976 2 9.448 2 10c0 .552.195 1.023.586 1.414.39.39.862.586 1.414.586.552 0 1.023-.195 1.414-.586.39-.39.586-.862.586-1.414zm6 0c0-.552-.195-1.023-.586-1.414A1.927 1.927 0 0 0 10 8c-.552 0-1.023.195-1.414.586C8.196 8.976 8 9.448 8 10c0 .552.195 1.023.586 1.414.39.39.862.586 1.414.586.552 0 1.023-.195 1.414-.586.39-.39.586-.862.586-1.414zm6 0c0-.552-.195-1.023-.586-1.414A1.927 1.927 0 0 0 16 8c-.552 0-1.023.195-1.414.586-.39.39-.586.862-.586 1.414 0 .552.195 1.023.586 1.414.39.39.862.586 1.414.586.552 0 1.023-.195 1.414-.586.39-.39.586-.862.586-1.414z",
                        fill: "currentColor",
                        fillRule: "evenodd",
                        role: "presentation"
                    }));
                };
            }
        } ]), _class;
    }(_Icon3.default);
    _class.displayName = "MoreoptionsIcon", exports.default = _class;
}, /* 122 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _extends2 = __webpack_require__(19), _extends3 = _interopRequireDefault(_extends2), _getPrototypeOf = __webpack_require__(4), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(5), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(6), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(7), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(8), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(9), _react2 = _interopRequireDefault(_react), _Icon2 = __webpack_require__(2), _Icon3 = _interopRequireDefault(_Icon2), _class = function(_Icon) {
        function _class() {
            return (0, _classCallCheck3.default)(this, _class), (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, 
            _getPrototypeOf2.default)(_class)).apply(this, arguments));
        }
        return (0, _inherits3.default)(_class, _Icon), (0, _createClass3.default)(_class, [ {
            key: "getGlyphTemplate",
            value: function() {
                return function(props) {
                    var title = props.label, iconProps = (0, _extends3.default)({}, props);
                    // eslint-disable-next-line max-len, react/jsx-space-before-closing
                    return delete iconProps.label, _react2.default.createElement("svg", (0, _extends3.default)({
                        width: "18",
                        height: "17",
                        viewBox: "32 52 18 17",
                        focusable: "false"
                    }, iconProps, {
                        "aria-labelledby": "title-1grccos"
                    }), _react2.default.createElement("title", {
                        id: "title-1grccos"
                    }, title), _react2.default.createElement("path", {
                        stroke: "#42526E",
                        fill: "currentColor",
                        d: "M38.563 53h-4.445L34 67.06h14.106V55.013h-7.16z",
                        strokeWidth: "2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        fillRule: "evenodd",
                        role: "presentation"
                    }));
                };
            }
        } ]), _class;
    }(_Icon3.default);
    _class.displayName = "ProjectsIcon", exports.default = _class;
}, /* 123 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _extends2 = __webpack_require__(19), _extends3 = _interopRequireDefault(_extends2), _getPrototypeOf = __webpack_require__(4), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(5), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(6), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(7), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(8), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(9), _react2 = _interopRequireDefault(_react), _Icon2 = __webpack_require__(2), _Icon3 = _interopRequireDefault(_Icon2), _class = function(_Icon) {
        function _class() {
            return (0, _classCallCheck3.default)(this, _class), (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, 
            _getPrototypeOf2.default)(_class)).apply(this, arguments));
        }
        return (0, _inherits3.default)(_class, _Icon), (0, _createClass3.default)(_class, [ {
            key: "getGlyphTemplate",
            value: function() {
                return function(props) {
                    var title = props.label, iconProps = (0, _extends3.default)({}, props);
                    // eslint-disable-next-line max-len, react/jsx-space-before-closing
                    return delete iconProps.label, _react2.default.createElement("svg", (0, _extends3.default)({
                        width: "20",
                        height: "20",
                        viewBox: "31 284 18 19",
                        focusable: "false"
                    }, iconProps, {
                        "aria-labelledby": "title-d2sbtts"
                    }), _react2.default.createElement("title", {
                        id: "title-d2sbtts"
                    }, title), _react2.default.createElement("path", {
                        fill: "currentColor",
                        d: "M40 284.001a9 9 0 1 0 9 9 9 9 0 0 0-9-9zm-.142 14.25h-.047c-.733-.022-1.251-.563-1.23-1.286.021-.71.55-1.227 1.26-1.227l.043.001c.754.022 1.265.557 1.244 1.3-.022.713-.542 1.211-1.27 1.211zm3.086-6.124c-.173.244-.552.55-1.03.922l-.526.363c-.29.225-.464.437-.528.645-.053.163-.077.207-.082.54v.084h-2.01l.005-.17c.025-.698.042-1.11.332-1.45.454-.533 1.458-1.18 1.5-1.207a1.56 1.56 0 0 0 .355-.363c.21-.292.304-.52.304-.744a1.45 1.45 0 0 0-.275-.858c-.176-.25-.51-.374-.995-.374-.48 0-.809.152-1.005.465-.202.32-.304.657-.304 1v.087h-2.073l.004-.09c.053-1.268.507-2.183 1.345-2.716.528-.338 1.185-.51 1.95-.51 1.002 0 1.85.244 2.515.724.676.486 1.018 1.216 1.018 2.166 0 .532-.168 1.032-.5 1.486z",
                        fillRule: "evenodd",
                        role: "presentation"
                    }));
                };
            }
        } ]), _class;
    }(_Icon3.default);
    _class.displayName = "QuestionIcon", exports.default = _class;
}, /* 124 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _extends2 = __webpack_require__(19), _extends3 = _interopRequireDefault(_extends2), _getPrototypeOf = __webpack_require__(4), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(5), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(6), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(7), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(8), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(9), _react2 = _interopRequireDefault(_react), _Icon2 = __webpack_require__(2), _Icon3 = _interopRequireDefault(_Icon2), _class = function(_Icon) {
        function _class() {
            return (0, _classCallCheck3.default)(this, _class), (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, 
            _getPrototypeOf2.default)(_class)).apply(this, arguments));
        }
        return (0, _inherits3.default)(_class, _Icon), (0, _createClass3.default)(_class, [ {
            key: "getGlyphTemplate",
            value: function() {
                return function(props) {
                    var title = props.label, iconProps = (0, _extends3.default)({}, props);
                    // eslint-disable-next-line max-len, react/jsx-space-before-closing
                    return delete iconProps.label, _react2.default.createElement("svg", (0, _extends3.default)({
                        width: "12",
                        height: "12",
                        viewBox: "0 0 12 12",
                        focusable: "false"
                    }, iconProps, {
                        "aria-labelledby": "title-fd0e15o"
                    }), _react2.default.createElement("title", {
                        id: "title-fd0e15o"
                    }, title), _react2.default.createElement("path", {
                        d: "M6 12A6 6 0 1 0 6 0a6 6 0 0 0 0 12z",
                        fill: "currentColor",
                        role: "presentation"
                    }), _react2.default.createElement("use", null), _react2.default.createElement("use", {
                        stroke: "currentColor",
                        mask: "url(#mask-2)",
                        strokeWidth: "2"
                    }), _react2.default.createElement("circle", {
                        cx: "6",
                        cy: "6",
                        r: "2",
                        fill: "inherit",
                        role: "presentation"
                    }));
                };
            }
        } ]), _class;
    }(_Icon3.default);
    _class.displayName = "RadioIcon", exports.default = _class;
}, /* 125 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _extends2 = __webpack_require__(19), _extends3 = _interopRequireDefault(_extends2), _getPrototypeOf = __webpack_require__(4), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(5), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(6), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(7), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(8), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(9), _react2 = _interopRequireDefault(_react), _Icon2 = __webpack_require__(2), _Icon3 = _interopRequireDefault(_Icon2), _class = function(_Icon) {
        function _class() {
            return (0, _classCallCheck3.default)(this, _class), (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, 
            _getPrototypeOf2.default)(_class)).apply(this, arguments));
        }
        return (0, _inherits3.default)(_class, _Icon), (0, _createClass3.default)(_class, [ {
            key: "getGlyphTemplate",
            value: function() {
                return function(props) {
                    var title = props.label, iconProps = (0, _extends3.default)({}, props);
                    // eslint-disable-next-line max-len, react/jsx-space-before-closing
                    return delete iconProps.label, _react2.default.createElement("svg", (0, _extends3.default)({
                        width: "17",
                        height: "17",
                        viewBox: "7 7 17 17",
                        focusable: "false"
                    }, iconProps, {
                        "aria-labelledby": "title-qyvony9"
                    }), _react2.default.createElement("title", {
                        id: "title-qyvony9"
                    }, title), _react2.default.createElement("g", {
                        fill: "none",
                        stroke: "currentColor",
                        fillRule: "evenodd",
                        strokeWidth: "2"
                    }, _react2.default.createElement("path", {
                        d: "M20.172 14.086a6.087 6.087 0 1 1-12.173 0 6.087 6.087 0 0 1 12.173 0z",
                        role: "presentation"
                    }), _react2.default.createElement("path", {
                        d: "M18.714 18.714l3.497 3.497",
                        strokeLinecap: "round",
                        role: "presentation"
                    })));
                };
            }
        } ]), _class;
    }(_Icon3.default);
    _class.displayName = "SearchIcon", exports.default = _class;
}, /* 126 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _extends2 = __webpack_require__(19), _extends3 = _interopRequireDefault(_extends2), _getPrototypeOf = __webpack_require__(4), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(5), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(6), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(7), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(8), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(9), _react2 = _interopRequireDefault(_react), _Icon2 = __webpack_require__(2), _Icon3 = _interopRequireDefault(_Icon2), _class = function(_Icon) {
        function _class() {
            return (0, _classCallCheck3.default)(this, _class), (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, 
            _getPrototypeOf2.default)(_class)).apply(this, arguments));
        }
        return (0, _inherits3.default)(_class, _Icon), (0, _createClass3.default)(_class, [ {
            key: "getGlyphTemplate",
            value: function() {
                return function(props) {
                    var title = props.label, iconProps = (0, _extends3.default)({}, props);
                    // eslint-disable-next-line max-len, react/jsx-space-before-closing
                    return delete iconProps.label, _react2.default.createElement("svg", (0, _extends3.default)({
                        width: "22",
                        height: "22",
                        viewBox: "-1 -1 22 22",
                        focusable: "false"
                    }, iconProps, {
                        "aria-labelledby": "title-lmhs84t"
                    }), _react2.default.createElement("title", {
                        id: "title-lmhs84t"
                    }, title), _react2.default.createElement("path", {
                        d: "M18.4 11.9c-.8-.3-1.3-1-1.3-1.9 0-.9.6-1.6 1.3-1.9.2-.1.4-.3.3-.6-.2-.7-.5-1.4-.8-2-.1-.2-.4-.3-.6-.2-.4.2-.8.2-1.3.1-.7-.2-1.2-.7-1.4-1.4-.1-.5-.1-.9.1-1.3.1-.2 0-.5-.2-.6-.6-.3-1.3-.6-2-.8-.2-.1-.5.1-.6.3-.3.8-1 1.3-1.9 1.3-.9 0-1.6-.6-1.9-1.3-.1-.2-.3-.4-.6-.3-.7.2-1.4.5-2 .8-.2.1-.2.4-.2.6.1.4.2.8.1 1.2-.1.7-.7 1.3-1.4 1.5-.4.1-.9.1-1.3-.1-.2-.1-.5 0-.6.2-.4.6-.6 1.3-.8 2 0 .3.1.5.3.6.8.3 1.3 1 1.3 1.9 0 .9-.6 1.6-1.3 1.9-.2.1-.4.3-.3.6.2.5.4 1.1.7 1.7.1.2.4.3.6.2.6-.3 1.3-.3 2.1.2l.3.3c.5.8.5 1.6.2 2.2-.1.2 0 .5.2.6.7.4 1.4.7 2.1.9.2.1.5-.1.6-.3.3-.8 1-1.4 1.9-1.4.9 0 1.6.6 1.9 1.4.1.2.3.4.6.3.7-.2 1.4-.5 2.1-.9.2-.1.3-.4.2-.6-.3-.6-.3-1.4.2-2.2l.3-.3c.8-.5 1.5-.5 2.1-.2.2.1.5 0 .6-.2.3-.6.5-1.2.7-1.8.1-.2-.1-.5-.3-.5zM10 15c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5c0 2.7-2.2 5-5 5z",
                        fill: "currentColor",
                        fillRule: "evenodd",
                        role: "presentation"
                    }));
                };
            }
        } ]), _class;
    }(_Icon3.default);
    _class.displayName = "SettingsIcon", exports.default = _class;
}, /* 127 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _extends2 = __webpack_require__(19), _extends3 = _interopRequireDefault(_extends2), _getPrototypeOf = __webpack_require__(4), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(5), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(6), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(7), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(8), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(9), _react2 = _interopRequireDefault(_react), _Icon2 = __webpack_require__(2), _Icon3 = _interopRequireDefault(_Icon2), _class = function(_Icon) {
        function _class() {
            return (0, _classCallCheck3.default)(this, _class), (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, 
            _getPrototypeOf2.default)(_class)).apply(this, arguments));
        }
        return (0, _inherits3.default)(_class, _Icon), (0, _createClass3.default)(_class, [ {
            key: "getGlyphTemplate",
            value: function() {
                return function(props) {
                    var title = props.label, iconProps = (0, _extends3.default)({}, props);
                    // eslint-disable-next-line max-len, react/jsx-space-before-closing
                    return delete iconProps.label, _react2.default.createElement("svg", (0, _extends3.default)({
                        width: "12",
                        height: "12",
                        viewBox: "0 0 12 12",
                        focusable: "false"
                    }, iconProps, {
                        "aria-labelledby": "title-fcjv0q5"
                    }), _react2.default.createElement("title", {
                        id: "title-fcjv0q5"
                    }, title), _react2.default.createElement("g", {
                        fill: "currentColor",
                        fillRule: "evenodd"
                    }, _react2.default.createElement("circle", {
                        fill: "inherit",
                        cx: "6",
                        cy: "6",
                        r: "6",
                        role: "presentation"
                    }), _react2.default.createElement("path", {
                        d: "M9.287 4.812L5.468 8.63a.75.75 0 0 1-1.06 0L2.71 6.933a.75.75 0 1 1 1.061-1.06L4.938 7.04l3.288-3.288a.75.75 0 1 1 1.06 1.06",
                        fill: "#fff",
                        role: "presentation"
                    })));
                };
            }
        } ]), _class;
    }(_Icon3.default);
    _class.displayName = "SuccessIcon", exports.default = _class;
}, /* 128 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _extends2 = __webpack_require__(19), _extends3 = _interopRequireDefault(_extends2), _getPrototypeOf = __webpack_require__(4), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(5), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(6), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(7), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(8), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(9), _react2 = _interopRequireDefault(_react), _Icon2 = __webpack_require__(2), _Icon3 = _interopRequireDefault(_Icon2), _class = function(_Icon) {
        function _class() {
            return (0, _classCallCheck3.default)(this, _class), (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, 
            _getPrototypeOf2.default)(_class)).apply(this, arguments));
        }
        return (0, _inherits3.default)(_class, _Icon), (0, _createClass3.default)(_class, [ {
            key: "getGlyphTemplate",
            value: function() {
                return function(props) {
                    var title = props.label, iconProps = (0, _extends3.default)({}, props);
                    // eslint-disable-next-line max-len, react/jsx-space-before-closing
                    return delete iconProps.label, _react2.default.createElement("svg", (0, _extends3.default)({
                        width: "20",
                        height: "20",
                        viewBox: "0 0 20 20",
                        focusable: "false"
                    }, iconProps, {
                        "aria-labelledby": "title-qxw7gvm"
                    }), _react2.default.createElement("title", {
                        id: "title-qxw7gvm"
                    }, title), _react2.default.createElement("g", {
                        fill: "none",
                        fillRule: "evenodd"
                    }, _react2.default.createElement("path", {
                        d: "M17.888 16.524L10.846 2.536a.936.936 0 0 0-1.692 0L2.112 16.524c-.336.67.125 1.476.846 1.476h14.084c.721 0 1.182-.807.846-1.476z",
                        fill: "currentColor",
                        role: "presentation"
                    }), _react2.default.createElement("path", {
                        d: "M10 16a1 1 0 1 1 .001-2.001A1 1 0 0 1 10 16zm1-4c0 .55-.45 1-1 1s-1-.45-1-1V7c0-.55.45-1 1-1s1 .45 1 1v5z",
                        fill: "#FFF",
                        role: "presentation"
                    })));
                };
            }
        } ]), _class;
    }(_Icon3.default);
    _class.displayName = "WarningIcon", exports.default = _class;
} ]);


//////////////////
// WEBPACK FOOTER
// /opt/atlassian/pipelines/agent/build/~/ak-icon/dist/bundle-cjs.js
// module id = 337
// module chunks = 0